/*./.eslintrc.yaml*/
const $protobuf = require('protobufjs/minimal')

const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

const commands = $root.commands = (() => {

    const commands = {};

    commands.CommandContext = (function() {

        function CommandContext(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        CommandContext.prototype.session = null;
        CommandContext.prototype.referrerContext = null;
        CommandContext.prototype.currentContext = null;
        CommandContext.prototype.eventTimestamp = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        CommandContext.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.session != null && Object.hasOwnProperty.call(m, "session"))
                $root.globals.Session.encode(m.session, w.uint32(10).fork()).ldelim();
            if (m.referrerContext != null && Object.hasOwnProperty.call(m, "referrerContext"))
                $root.globals.PageContext.encode(m.referrerContext, w.uint32(18).fork()).ldelim();
            if (m.currentContext != null && Object.hasOwnProperty.call(m, "currentContext"))
                $root.globals.PageContext.encode(m.currentContext, w.uint32(26).fork()).ldelim();
            if (m.eventTimestamp != null && Object.hasOwnProperty.call(m, "eventTimestamp"))
                w.uint32(32).uint64(m.eventTimestamp);
            return w;
        };

        CommandContext.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        CommandContext.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.CommandContext();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.session = $root.globals.Session.decode(r, r.uint32());
                    break;
                case 2:
                    m.referrerContext = $root.globals.PageContext.decode(r, r.uint32());
                    break;
                case 3:
                    m.currentContext = $root.globals.PageContext.decode(r, r.uint32());
                    break;
                case 4:
                    m.eventTimestamp = r.uint64();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        CommandContext.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        CommandContext.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.session != null && m.hasOwnProperty("session")) {
                {
                    var e = $root.globals.Session.verify(m.session);
                    if (e)
                        return "session." + e;
                }
            }
            if (m.referrerContext != null && m.hasOwnProperty("referrerContext")) {
                {
                    var e = $root.globals.PageContext.verify(m.referrerContext);
                    if (e)
                        return "referrerContext." + e;
                }
            }
            if (m.currentContext != null && m.hasOwnProperty("currentContext")) {
                {
                    var e = $root.globals.PageContext.verify(m.currentContext);
                    if (e)
                        return "currentContext." + e;
                }
            }
            if (m.eventTimestamp != null && m.hasOwnProperty("eventTimestamp")) {
                if (!$util.isInteger(m.eventTimestamp) && !(m.eventTimestamp && $util.isInteger(m.eventTimestamp.low) && $util.isInteger(m.eventTimestamp.high)))
                    return "eventTimestamp: integer|Long expected";
            }
            return null;
        };

        CommandContext.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.CommandContext)
                return d;
            var m = new $root.commands.CommandContext();
            if (d.session != null) {
                if (typeof d.session !== "object")
                    throw TypeError(".commands.CommandContext.session: object expected");
                m.session = $root.globals.Session.fromObject(d.session);
            }
            if (d.referrerContext != null) {
                if (typeof d.referrerContext !== "object")
                    throw TypeError(".commands.CommandContext.referrerContext: object expected");
                m.referrerContext = $root.globals.PageContext.fromObject(d.referrerContext);
            }
            if (d.currentContext != null) {
                if (typeof d.currentContext !== "object")
                    throw TypeError(".commands.CommandContext.currentContext: object expected");
                m.currentContext = $root.globals.PageContext.fromObject(d.currentContext);
            }
            if (d.eventTimestamp != null) {
                if ($util.Long)
                    (m.eventTimestamp = $util.Long.fromValue(d.eventTimestamp)).unsigned = true;
                else if (typeof d.eventTimestamp === "string")
                    m.eventTimestamp = parseInt(d.eventTimestamp, 10);
                else if (typeof d.eventTimestamp === "number")
                    m.eventTimestamp = d.eventTimestamp;
                else if (typeof d.eventTimestamp === "object")
                    m.eventTimestamp = new $util.LongBits(d.eventTimestamp.low >>> 0, d.eventTimestamp.high >>> 0).toNumber(true);
            }
            return m;
        };

        CommandContext.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.session = null;
                d.referrerContext = null;
                d.currentContext = null;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.eventTimestamp = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.eventTimestamp = o.longs === String ? "0" : 0;
            }
            if (m.session != null && m.hasOwnProperty("session")) {
                d.session = $root.globals.Session.toObject(m.session, o);
            }
            if (m.referrerContext != null && m.hasOwnProperty("referrerContext")) {
                d.referrerContext = $root.globals.PageContext.toObject(m.referrerContext, o);
            }
            if (m.currentContext != null && m.hasOwnProperty("currentContext")) {
                d.currentContext = $root.globals.PageContext.toObject(m.currentContext, o);
            }
            if (m.eventTimestamp != null && m.hasOwnProperty("eventTimestamp")) {
                if (typeof m.eventTimestamp === "number")
                    d.eventTimestamp = o.longs === String ? String(m.eventTimestamp) : m.eventTimestamp;
                else
                    d.eventTimestamp = o.longs === String ? $util.Long.prototype.toString.call(m.eventTimestamp) : o.longs === Number ? new $util.LongBits(m.eventTimestamp.low >>> 0, m.eventTimestamp.high >>> 0).toNumber(true) : m.eventTimestamp;
            }
            return d;
        };

        CommandContext.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CommandContext;
    })();

    commands.FollowMix = (function() {

        function FollowMix(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        FollowMix.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        FollowMix.prototype.mixId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        FollowMix.prototype.followType = 0;
        FollowMix.prototype.context = null;

        FollowMix.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.mixId != null && Object.hasOwnProperty.call(m, "mixId"))
                w.uint32(16).uint64(m.mixId);
            if (m.followType != null && Object.hasOwnProperty.call(m, "followType"))
                w.uint32(24).int32(m.followType);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        FollowMix.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        FollowMix.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.FollowMix();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.mixId = r.uint64();
                    break;
                case 3:
                    m.followType = r.int32();
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        FollowMix.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        FollowMix.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.mixId != null && m.hasOwnProperty("mixId")) {
                if (!$util.isInteger(m.mixId) && !(m.mixId && $util.isInteger(m.mixId.low) && $util.isInteger(m.mixId.high)))
                    return "mixId: integer|Long expected";
            }
            if (m.followType != null && m.hasOwnProperty("followType")) {
                switch (m.followType) {
                default:
                    return "followType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        FollowMix.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.FollowMix)
                return d;
            var m = new $root.commands.FollowMix();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            if (d.mixId != null) {
                if ($util.Long)
                    (m.mixId = $util.Long.fromValue(d.mixId)).unsigned = true;
                else if (typeof d.mixId === "string")
                    m.mixId = parseInt(d.mixId, 10);
                else if (typeof d.mixId === "number")
                    m.mixId = d.mixId;
                else if (typeof d.mixId === "object")
                    m.mixId = new $util.LongBits(d.mixId.low >>> 0, d.mixId.high >>> 0).toNumber(true);
            }
            switch (d.followType) {
            case "UNKNOWN_FOLLOW_EVENT_TYPE":
            case 0:
                m.followType = 0;
                break;
            case "FOLLOWED":
            case 1:
                m.followType = 1;
                break;
            case "UNFOLLOWED":
            case 2:
                m.followType = 2;
                break;
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.FollowMix.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        FollowMix.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.mixId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.mixId = o.longs === String ? "0" : 0;
                d.followType = o.enums === String ? "UNKNOWN_FOLLOW_EVENT_TYPE" : 0;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.mixId != null && m.hasOwnProperty("mixId")) {
                if (typeof m.mixId === "number")
                    d.mixId = o.longs === String ? String(m.mixId) : m.mixId;
                else
                    d.mixId = o.longs === String ? $util.Long.prototype.toString.call(m.mixId) : o.longs === Number ? new $util.LongBits(m.mixId.low >>> 0, m.mixId.high >>> 0).toNumber(true) : m.mixId;
            }
            if (m.followType != null && m.hasOwnProperty("followType")) {
                d.followType = o.enums === String ? $root.globals.FollowEventType[m.followType] : m.followType;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        FollowMix.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FollowMix;
    })();

    commands.RecommendStrategy = (function() {

        function RecommendStrategy(p) {
            this.context = [];
            this.seen = [];
            this.scores = [];
            this.experiments = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RecommendStrategy.prototype.mode = 0;
        RecommendStrategy.prototype.sort = 0;
        RecommendStrategy.prototype.context = $util.emptyArray;
        RecommendStrategy.prototype.filters = null;
        RecommendStrategy.prototype.seen = $util.emptyArray;
        RecommendStrategy.prototype.scores = $util.emptyArray;
        RecommendStrategy.prototype.display = null;
        RecommendStrategy.prototype.experiments = $util.emptyArray;
        RecommendStrategy.prototype.experimentState = null;
        RecommendStrategy.prototype.limit = null;
        RecommendStrategy.prototype.cursor = null;
        RecommendStrategy.prototype.page = null;

        RecommendStrategy.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.mode != null && Object.hasOwnProperty.call(m, "mode"))
                w.uint32(8).int32(m.mode);
            if (m.sort != null && Object.hasOwnProperty.call(m, "sort"))
                w.uint32(16).int32(m.sort);
            if (m.context != null && m.context.length) {
                for (var i = 0; i < m.context.length; ++i)
                    $root.globals.RecItem.encode(m.context[i], w.uint32(26).fork()).ldelim();
            }
            if (m.filters != null && Object.hasOwnProperty.call(m, "filters"))
                $root.globals.RecFilters.encode(m.filters, w.uint32(34).fork()).ldelim();
            if (m.seen != null && m.seen.length) {
                for (var i = 0; i < m.seen.length; ++i)
                    $root.globals.RecItem.encode(m.seen[i], w.uint32(42).fork()).ldelim();
            }
            if (m.scores != null && m.scores.length) {
                for (var i = 0; i < m.scores.length; ++i)
                    $root.globals.RecScore.encode(m.scores[i], w.uint32(50).fork()).ldelim();
            }
            if (m.display != null && Object.hasOwnProperty.call(m, "display"))
                $root.globals.DisplayInfo.encode(m.display, w.uint32(58).fork()).ldelim();
            if (m.experiments != null && m.experiments.length) {
                for (var i = 0; i < m.experiments.length; ++i)
                    $root.globals.Experiment.encode(m.experiments[i], w.uint32(66).fork()).ldelim();
            }
            if (m.experimentState != null && Object.hasOwnProperty.call(m, "experimentState"))
                $root.google.protobuf.StringValue.encode(m.experimentState, w.uint32(74).fork()).ldelim();
            if (m.limit != null && Object.hasOwnProperty.call(m, "limit"))
                $root.google.protobuf.UInt64Value.encode(m.limit, w.uint32(82).fork()).ldelim();
            if (m.cursor != null && Object.hasOwnProperty.call(m, "cursor"))
                $root.google.protobuf.StringValue.encode(m.cursor, w.uint32(90).fork()).ldelim();
            if (m.page != null && Object.hasOwnProperty.call(m, "page"))
                $root.google.protobuf.UInt32Value.encode(m.page, w.uint32(98).fork()).ldelim();
            return w;
        };

        RecommendStrategy.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RecommendStrategy.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.RecommendStrategy();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.mode = r.int32();
                    break;
                case 2:
                    m.sort = r.int32();
                    break;
                case 3:
                    if (!(m.context && m.context.length))
                        m.context = [];
                    m.context.push($root.globals.RecItem.decode(r, r.uint32()));
                    break;
                case 4:
                    m.filters = $root.globals.RecFilters.decode(r, r.uint32());
                    break;
                case 5:
                    if (!(m.seen && m.seen.length))
                        m.seen = [];
                    m.seen.push($root.globals.RecItem.decode(r, r.uint32()));
                    break;
                case 6:
                    if (!(m.scores && m.scores.length))
                        m.scores = [];
                    m.scores.push($root.globals.RecScore.decode(r, r.uint32()));
                    break;
                case 7:
                    m.display = $root.globals.DisplayInfo.decode(r, r.uint32());
                    break;
                case 8:
                    if (!(m.experiments && m.experiments.length))
                        m.experiments = [];
                    m.experiments.push($root.globals.Experiment.decode(r, r.uint32()));
                    break;
                case 9:
                    m.experimentState = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 10:
                    m.limit = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 11:
                    m.cursor = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 12:
                    m.page = $root.google.protobuf.UInt32Value.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RecommendStrategy.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RecommendStrategy.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.mode != null && m.hasOwnProperty("mode")) {
                switch (m.mode) {
                default:
                    return "mode: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                    break;
                }
            }
            if (m.sort != null && m.hasOwnProperty("sort")) {
                switch (m.sort) {
                default:
                    return "sort: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                if (!Array.isArray(m.context))
                    return "context: array expected";
                for (var i = 0; i < m.context.length; ++i) {
                    {
                        var e = $root.globals.RecItem.verify(m.context[i]);
                        if (e)
                            return "context." + e;
                    }
                }
            }
            if (m.filters != null && m.hasOwnProperty("filters")) {
                {
                    var e = $root.globals.RecFilters.verify(m.filters);
                    if (e)
                        return "filters." + e;
                }
            }
            if (m.seen != null && m.hasOwnProperty("seen")) {
                if (!Array.isArray(m.seen))
                    return "seen: array expected";
                for (var i = 0; i < m.seen.length; ++i) {
                    {
                        var e = $root.globals.RecItem.verify(m.seen[i]);
                        if (e)
                            return "seen." + e;
                    }
                }
            }
            if (m.scores != null && m.hasOwnProperty("scores")) {
                if (!Array.isArray(m.scores))
                    return "scores: array expected";
                for (var i = 0; i < m.scores.length; ++i) {
                    {
                        var e = $root.globals.RecScore.verify(m.scores[i]);
                        if (e)
                            return "scores." + e;
                    }
                }
            }
            if (m.display != null && m.hasOwnProperty("display")) {
                {
                    var e = $root.globals.DisplayInfo.verify(m.display);
                    if (e)
                        return "display." + e;
                }
            }
            if (m.experiments != null && m.hasOwnProperty("experiments")) {
                if (!Array.isArray(m.experiments))
                    return "experiments: array expected";
                for (var i = 0; i < m.experiments.length; ++i) {
                    {
                        var e = $root.globals.Experiment.verify(m.experiments[i]);
                        if (e)
                            return "experiments." + e;
                    }
                }
            }
            if (m.experimentState != null && m.hasOwnProperty("experimentState")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.experimentState);
                    if (e)
                        return "experimentState." + e;
                }
            }
            if (m.limit != null && m.hasOwnProperty("limit")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.limit);
                    if (e)
                        return "limit." + e;
                }
            }
            if (m.cursor != null && m.hasOwnProperty("cursor")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.cursor);
                    if (e)
                        return "cursor." + e;
                }
            }
            if (m.page != null && m.hasOwnProperty("page")) {
                {
                    var e = $root.google.protobuf.UInt32Value.verify(m.page);
                    if (e)
                        return "page." + e;
                }
            }
            return null;
        };

        RecommendStrategy.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.RecommendStrategy)
                return d;
            var m = new $root.commands.RecommendStrategy();
            switch (d.mode) {
            case "UNKNOWN_REC_MODE":
            case 0:
                m.mode = 0;
                break;
            case "REC_MODE_RECOMMENDED":
            case 1:
                m.mode = 1;
                break;
            case "REC_MODE_POPULAR":
            case 2:
                m.mode = 2;
                break;
            case "REC_MODE_TOPICS":
            case 3:
                m.mode = 3;
                break;
            case "REC_MODE_COLLECTIONS":
            case 4:
                m.mode = 4;
                break;
            case "REC_MODE_FRIENDS":
            case 5:
                m.mode = 5;
                break;
            case "REC_MODE_TRENDING":
            case 6:
                m.mode = 6;
                break;
            case "REC_MODE_SAMPLING":
            case 7:
                m.mode = 7;
                break;
            case "REC_MODE_EDITOR_PICKS":
            case 8:
                m.mode = 8;
                break;
            case "REC_MODE_SEARCH":
            case 9:
                m.mode = 9;
                break;
            case "REC_MODE_SUBSCRIPTIONS":
            case 10:
                m.mode = 10;
                break;
            }
            switch (d.sort) {
            case "UNKNOWN_SORT":
            case 0:
                m.sort = 0;
                break;
            case "SORT_RECOMMENDED":
            case 1:
                m.sort = 1;
                break;
            case "SORT_ACCURATE":
            case 2:
                m.sort = 2;
                break;
            case "SORT_POPULAR":
            case 3:
                m.sort = 3;
                break;
            case "SORT_TRENDING":
            case 4:
                m.sort = 4;
                break;
            case "SORT_TIMEDESC":
            case 5:
                m.sort = 5;
                break;
            case "SORT_TIMEASC":
            case 6:
                m.sort = 6;
                break;
            case "SORT_FEED":
            case 7:
                m.sort = 7;
                break;
            case "SORT_RANDOM":
            case 8:
                m.sort = 8;
                break;
            }
            if (d.context) {
                if (!Array.isArray(d.context))
                    throw TypeError(".commands.RecommendStrategy.context: array expected");
                m.context = [];
                for (var i = 0; i < d.context.length; ++i) {
                    if (typeof d.context[i] !== "object")
                        throw TypeError(".commands.RecommendStrategy.context: object expected");
                    m.context[i] = $root.globals.RecItem.fromObject(d.context[i]);
                }
            }
            if (d.filters != null) {
                if (typeof d.filters !== "object")
                    throw TypeError(".commands.RecommendStrategy.filters: object expected");
                m.filters = $root.globals.RecFilters.fromObject(d.filters);
            }
            if (d.seen) {
                if (!Array.isArray(d.seen))
                    throw TypeError(".commands.RecommendStrategy.seen: array expected");
                m.seen = [];
                for (var i = 0; i < d.seen.length; ++i) {
                    if (typeof d.seen[i] !== "object")
                        throw TypeError(".commands.RecommendStrategy.seen: object expected");
                    m.seen[i] = $root.globals.RecItem.fromObject(d.seen[i]);
                }
            }
            if (d.scores) {
                if (!Array.isArray(d.scores))
                    throw TypeError(".commands.RecommendStrategy.scores: array expected");
                m.scores = [];
                for (var i = 0; i < d.scores.length; ++i) {
                    if (typeof d.scores[i] !== "object")
                        throw TypeError(".commands.RecommendStrategy.scores: object expected");
                    m.scores[i] = $root.globals.RecScore.fromObject(d.scores[i]);
                }
            }
            if (d.display != null) {
                if (typeof d.display !== "object")
                    throw TypeError(".commands.RecommendStrategy.display: object expected");
                m.display = $root.globals.DisplayInfo.fromObject(d.display);
            }
            if (d.experiments) {
                if (!Array.isArray(d.experiments))
                    throw TypeError(".commands.RecommendStrategy.experiments: array expected");
                m.experiments = [];
                for (var i = 0; i < d.experiments.length; ++i) {
                    if (typeof d.experiments[i] !== "object")
                        throw TypeError(".commands.RecommendStrategy.experiments: object expected");
                    m.experiments[i] = $root.globals.Experiment.fromObject(d.experiments[i]);
                }
            }
            if (d.experimentState != null) {
                if (typeof d.experimentState === "object" && d.experimentState !== null && d.experimentState.value !== undefined)
                    throw TypeError(".commands.RecommendStrategy.experimentState: wrapped value not expected");
                m.experimentState = $root.google.protobuf.StringValue.fromObject({ value: d.experimentState });
            }
            if (d.limit != null) {
                if (typeof d.limit === "object" && d.limit !== null && d.limit.value !== undefined)
                    throw TypeError(".commands.RecommendStrategy.limit: wrapped value not expected");
                m.limit = $root.google.protobuf.UInt64Value.fromObject({ value: d.limit });
            }
            if (d.cursor != null) {
                if (typeof d.cursor === "object" && d.cursor !== null && d.cursor.value !== undefined)
                    throw TypeError(".commands.RecommendStrategy.cursor: wrapped value not expected");
                m.cursor = $root.google.protobuf.StringValue.fromObject({ value: d.cursor });
            }
            if (d.page != null) {
                if (typeof d.page === "object" && d.page !== null && d.page.value !== undefined)
                    throw TypeError(".commands.RecommendStrategy.page: wrapped value not expected");
                m.page = $root.google.protobuf.UInt32Value.fromObject({ value: d.page });
            }
            return m;
        };

        RecommendStrategy.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.context = [];
                d.seen = [];
                d.scores = [];
                d.experiments = [];
            }
            if (o.defaults) {
                d.mode = o.enums === String ? "UNKNOWN_REC_MODE" : 0;
                d.sort = o.enums === String ? "UNKNOWN_SORT" : 0;
                d.filters = null;
                d.display = null;
                d.experimentState = null;
                d.limit = null;
                d.cursor = null;
                d.page = null;
            }
            if (m.mode != null && m.hasOwnProperty("mode")) {
                d.mode = o.enums === String ? $root.globals.RecMode[m.mode] : m.mode;
            }
            if (m.sort != null && m.hasOwnProperty("sort")) {
                d.sort = o.enums === String ? $root.globals.Sort[m.sort] : m.sort;
            }
            if (m.context && m.context.length) {
                d.context = [];
                for (var j = 0; j < m.context.length; ++j) {
                    d.context[j] = $root.globals.RecItem.toObject(m.context[j], o);
                }
            }
            if (m.filters != null && m.hasOwnProperty("filters")) {
                d.filters = $root.globals.RecFilters.toObject(m.filters, o);
            }
            if (m.seen && m.seen.length) {
                d.seen = [];
                for (var j = 0; j < m.seen.length; ++j) {
                    d.seen[j] = $root.globals.RecItem.toObject(m.seen[j], o);
                }
            }
            if (m.scores && m.scores.length) {
                d.scores = [];
                for (var j = 0; j < m.scores.length; ++j) {
                    d.scores[j] = $root.globals.RecScore.toObject(m.scores[j], o);
                }
            }
            if (m.display != null && m.hasOwnProperty("display")) {
                d.display = $root.globals.DisplayInfo.toObject(m.display, o);
            }
            if (m.experiments && m.experiments.length) {
                d.experiments = [];
                for (var j = 0; j < m.experiments.length; ++j) {
                    d.experiments[j] = $root.globals.Experiment.toObject(m.experiments[j], o);
                }
            }
            if (m.experimentState != null && m.hasOwnProperty("experimentState")) {
                d.experimentState = $root.google.protobuf.StringValue.toObject(m.experimentState, o).value;
            }
            if (m.limit != null && m.hasOwnProperty("limit")) {
                d.limit = $root.google.protobuf.UInt64Value.toObject(m.limit, o).value;
            }
            if (m.cursor != null && m.hasOwnProperty("cursor")) {
                d.cursor = $root.google.protobuf.StringValue.toObject(m.cursor, o).value;
            }
            if (m.page != null && m.hasOwnProperty("page")) {
                d.page = $root.google.protobuf.UInt32Value.toObject(m.page, o).value;
            }
            return d;
        };

        RecommendStrategy.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RecommendStrategy;
    })();

    commands.RecommendClient = (function() {

        function RecommendClient(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RecommendClient.prototype.userId = null;
        RecommendClient.prototype.visitorId = null;
        RecommendClient.prototype.device = 0;
        RecommendClient.prototype.adblocker = null;

        let $oneOfFields;

        Object.defineProperty(RecommendClient.prototype, "currentUserId", {
            get: $util.oneOfGetter($oneOfFields = ["userId", "visitorId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        RecommendClient.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                $root.google.protobuf.UInt64Value.encode(m.userId, w.uint32(10).fork()).ldelim();
            if (m.visitorId != null && Object.hasOwnProperty.call(m, "visitorId"))
                $root.google.protobuf.StringValue.encode(m.visitorId, w.uint32(18).fork()).ldelim();
            if (m.device != null && Object.hasOwnProperty.call(m, "device"))
                w.uint32(24).int32(m.device);
            if (m.adblocker != null && Object.hasOwnProperty.call(m, "adblocker"))
                $root.google.protobuf.StringValue.encode(m.adblocker, w.uint32(34).fork()).ldelim();
            return w;
        };

        RecommendClient.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RecommendClient.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.RecommendClient();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 2:
                    m.visitorId = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 3:
                    m.device = r.int32();
                    break;
                case 4:
                    m.adblocker = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RecommendClient.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RecommendClient.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            var p = {};
            if (m.userId != null && m.hasOwnProperty("userId")) {
                p.currentUserId = 1;
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.userId);
                    if (e)
                        return "userId." + e;
                }
            }
            if (m.visitorId != null && m.hasOwnProperty("visitorId")) {
                if (p.currentUserId === 1)
                    return "currentUserId: multiple values";
                p.currentUserId = 1;
                {
                    var e = $root.google.protobuf.StringValue.verify(m.visitorId);
                    if (e)
                        return "visitorId." + e;
                }
            }
            if (m.device != null && m.hasOwnProperty("device")) {
                switch (m.device) {
                default:
                    return "device: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                    break;
                }
            }
            if (m.adblocker != null && m.hasOwnProperty("adblocker")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.adblocker);
                    if (e)
                        return "adblocker." + e;
                }
            }
            return null;
        };

        RecommendClient.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.RecommendClient)
                return d;
            var m = new $root.commands.RecommendClient();
            if (d.userId != null) {
                if (typeof d.userId === "object" && d.userId !== null && d.userId.value !== undefined)
                    throw TypeError(".commands.RecommendClient.userId: wrapped value not expected");
                m.userId = $root.google.protobuf.UInt64Value.fromObject({ value: d.userId });
            }
            if (d.visitorId != null) {
                if (typeof d.visitorId === "object" && d.visitorId !== null && d.visitorId.value !== undefined)
                    throw TypeError(".commands.RecommendClient.visitorId: wrapped value not expected");
                m.visitorId = $root.google.protobuf.StringValue.fromObject({ value: d.visitorId });
            }
            switch (d.device) {
            case "UNKNOWN_DEVICE":
            case 0:
                m.device = 0;
                break;
            case "IPHONE":
            case 1:
                m.device = 1;
                break;
            case "DEPRECATED_CHROME_EXTENSION":
            case 2:
                m.device = 2;
                break;
            case "DEPRECATED_WEBAPP":
            case 3:
                m.device = 3;
                break;
            case "DEPRECATED_FIREFOX_EXTENSION":
            case 4:
                m.device = 4;
                break;
            case "ANDROID":
            case 5:
                m.device = 5;
                break;
            case "IPAD":
            case 6:
                m.device = 6;
                break;
            case "ANDROID_TABLET":
            case 7:
                m.device = 7;
                break;
            case "DESKTOP":
            case 8:
                m.device = 8;
                break;
            case "INTERNAL":
            case 9:
                m.device = 9;
                break;
            case "WINDOWS_PHONE":
            case 10:
                m.device = 10;
                break;
            case "SYMBIAN":
            case 11:
                m.device = 11;
                break;
            }
            if (d.adblocker != null) {
                if (typeof d.adblocker === "object" && d.adblocker !== null && d.adblocker.value !== undefined)
                    throw TypeError(".commands.RecommendClient.adblocker: wrapped value not expected");
                m.adblocker = $root.google.protobuf.StringValue.fromObject({ value: d.adblocker });
            }
            return m;
        };

        RecommendClient.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.device = o.enums === String ? "UNKNOWN_DEVICE" : 0;
                d.adblocker = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                d.userId = $root.google.protobuf.UInt64Value.toObject(m.userId, o).value;
                if (o.oneofs)
                    d.currentUserId = "userId";
            }
            if (m.visitorId != null && m.hasOwnProperty("visitorId")) {
                d.visitorId = $root.google.protobuf.StringValue.toObject(m.visitorId, o).value;
                if (o.oneofs)
                    d.currentUserId = "visitorId";
            }
            if (m.device != null && m.hasOwnProperty("device")) {
                d.device = o.enums === String ? $root.globals.DeviceType[m.device] : m.device;
            }
            if (m.adblocker != null && m.hasOwnProperty("adblocker")) {
                d.adblocker = $root.google.protobuf.StringValue.toObject(m.adblocker, o).value;
            }
            return d;
        };

        RecommendClient.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RecommendClient;
    })();

    commands.Recommend = (function() {

        function Recommend(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Recommend.prototype.client = null;
        Recommend.prototype.strategy = null;
        Recommend.prototype.context = null;

        Recommend.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.client != null && Object.hasOwnProperty.call(m, "client"))
                $root.commands.RecommendClient.encode(m.client, w.uint32(10).fork()).ldelim();
            if (m.strategy != null && Object.hasOwnProperty.call(m, "strategy"))
                $root.commands.RecommendStrategy.encode(m.strategy, w.uint32(18).fork()).ldelim();
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(26).fork()).ldelim();
            return w;
        };

        Recommend.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Recommend.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.Recommend();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.client = $root.commands.RecommendClient.decode(r, r.uint32());
                    break;
                case 2:
                    m.strategy = $root.commands.RecommendStrategy.decode(r, r.uint32());
                    break;
                case 3:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Recommend.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Recommend.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.client != null && m.hasOwnProperty("client")) {
                {
                    var e = $root.commands.RecommendClient.verify(m.client);
                    if (e)
                        return "client." + e;
                }
            }
            if (m.strategy != null && m.hasOwnProperty("strategy")) {
                {
                    var e = $root.commands.RecommendStrategy.verify(m.strategy);
                    if (e)
                        return "strategy." + e;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        Recommend.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.Recommend)
                return d;
            var m = new $root.commands.Recommend();
            if (d.client != null) {
                if (typeof d.client !== "object")
                    throw TypeError(".commands.Recommend.client: object expected");
                m.client = $root.commands.RecommendClient.fromObject(d.client);
            }
            if (d.strategy != null) {
                if (typeof d.strategy !== "object")
                    throw TypeError(".commands.Recommend.strategy: object expected");
                m.strategy = $root.commands.RecommendStrategy.fromObject(d.strategy);
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.Recommend.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        Recommend.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.client = null;
                d.strategy = null;
                d.context = null;
            }
            if (m.client != null && m.hasOwnProperty("client")) {
                d.client = $root.commands.RecommendClient.toObject(m.client, o);
            }
            if (m.strategy != null && m.hasOwnProperty("strategy")) {
                d.strategy = $root.commands.RecommendStrategy.toObject(m.strategy, o);
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        Recommend.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Recommend;
    })();

    commands.RecommendSections = (function() {

        function RecommendSections(p) {
            this.sections = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RecommendSections.prototype.client = null;
        RecommendSections.prototype.defaultStrategy = null;
        RecommendSections.prototype.sections = $util.emptyArray;
        RecommendSections.prototype.context = null;

        RecommendSections.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.client != null && Object.hasOwnProperty.call(m, "client"))
                $root.commands.RecommendClient.encode(m.client, w.uint32(10).fork()).ldelim();
            if (m.defaultStrategy != null && Object.hasOwnProperty.call(m, "defaultStrategy"))
                $root.commands.RecommendStrategy.encode(m.defaultStrategy, w.uint32(18).fork()).ldelim();
            if (m.sections != null && m.sections.length) {
                for (var i = 0; i < m.sections.length; ++i)
                    $root.commands.RecommendStrategy.encode(m.sections[i], w.uint32(26).fork()).ldelim();
            }
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        RecommendSections.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RecommendSections.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.RecommendSections();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.client = $root.commands.RecommendClient.decode(r, r.uint32());
                    break;
                case 2:
                    m.defaultStrategy = $root.commands.RecommendStrategy.decode(r, r.uint32());
                    break;
                case 3:
                    if (!(m.sections && m.sections.length))
                        m.sections = [];
                    m.sections.push($root.commands.RecommendStrategy.decode(r, r.uint32()));
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RecommendSections.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RecommendSections.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.client != null && m.hasOwnProperty("client")) {
                {
                    var e = $root.commands.RecommendClient.verify(m.client);
                    if (e)
                        return "client." + e;
                }
            }
            if (m.defaultStrategy != null && m.hasOwnProperty("defaultStrategy")) {
                {
                    var e = $root.commands.RecommendStrategy.verify(m.defaultStrategy);
                    if (e)
                        return "defaultStrategy." + e;
                }
            }
            if (m.sections != null && m.hasOwnProperty("sections")) {
                if (!Array.isArray(m.sections))
                    return "sections: array expected";
                for (var i = 0; i < m.sections.length; ++i) {
                    {
                        var e = $root.commands.RecommendStrategy.verify(m.sections[i]);
                        if (e)
                            return "sections." + e;
                    }
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        RecommendSections.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.RecommendSections)
                return d;
            var m = new $root.commands.RecommendSections();
            if (d.client != null) {
                if (typeof d.client !== "object")
                    throw TypeError(".commands.RecommendSections.client: object expected");
                m.client = $root.commands.RecommendClient.fromObject(d.client);
            }
            if (d.defaultStrategy != null) {
                if (typeof d.defaultStrategy !== "object")
                    throw TypeError(".commands.RecommendSections.defaultStrategy: object expected");
                m.defaultStrategy = $root.commands.RecommendStrategy.fromObject(d.defaultStrategy);
            }
            if (d.sections) {
                if (!Array.isArray(d.sections))
                    throw TypeError(".commands.RecommendSections.sections: array expected");
                m.sections = [];
                for (var i = 0; i < d.sections.length; ++i) {
                    if (typeof d.sections[i] !== "object")
                        throw TypeError(".commands.RecommendSections.sections: object expected");
                    m.sections[i] = $root.commands.RecommendStrategy.fromObject(d.sections[i]);
                }
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.RecommendSections.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        RecommendSections.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.sections = [];
            }
            if (o.defaults) {
                d.client = null;
                d.defaultStrategy = null;
                d.context = null;
            }
            if (m.client != null && m.hasOwnProperty("client")) {
                d.client = $root.commands.RecommendClient.toObject(m.client, o);
            }
            if (m.defaultStrategy != null && m.hasOwnProperty("defaultStrategy")) {
                d.defaultStrategy = $root.commands.RecommendStrategy.toObject(m.defaultStrategy, o);
            }
            if (m.sections && m.sections.length) {
                d.sections = [];
                for (var j = 0; j < m.sections.length; ++j) {
                    d.sections[j] = $root.commands.RecommendStrategy.toObject(m.sections[j], o);
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        RecommendSections.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RecommendSections;
    })();

    commands.ReportUrlMiscat = (function() {

        function ReportUrlMiscat(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ReportUrlMiscat.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        ReportUrlMiscat.prototype.urlId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        ReportUrlMiscat.prototype.interestKey = "";
        ReportUrlMiscat.prototype.context = null;

        ReportUrlMiscat.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.urlId != null && Object.hasOwnProperty.call(m, "urlId"))
                w.uint32(16).uint64(m.urlId);
            if (m.interestKey != null && Object.hasOwnProperty.call(m, "interestKey"))
                w.uint32(26).string(m.interestKey);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        ReportUrlMiscat.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        ReportUrlMiscat.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.ReportUrlMiscat();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.urlId = r.uint64();
                    break;
                case 3:
                    m.interestKey = r.string();
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        ReportUrlMiscat.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        ReportUrlMiscat.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.urlId != null && m.hasOwnProperty("urlId")) {
                if (!$util.isInteger(m.urlId) && !(m.urlId && $util.isInteger(m.urlId.low) && $util.isInteger(m.urlId.high)))
                    return "urlId: integer|Long expected";
            }
            if (m.interestKey != null && m.hasOwnProperty("interestKey")) {
                if (!$util.isString(m.interestKey))
                    return "interestKey: string expected";
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        ReportUrlMiscat.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.ReportUrlMiscat)
                return d;
            var m = new $root.commands.ReportUrlMiscat();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            if (d.urlId != null) {
                if ($util.Long)
                    (m.urlId = $util.Long.fromValue(d.urlId)).unsigned = true;
                else if (typeof d.urlId === "string")
                    m.urlId = parseInt(d.urlId, 10);
                else if (typeof d.urlId === "number")
                    m.urlId = d.urlId;
                else if (typeof d.urlId === "object")
                    m.urlId = new $util.LongBits(d.urlId.low >>> 0, d.urlId.high >>> 0).toNumber(true);
            }
            if (d.interestKey != null) {
                m.interestKey = String(d.interestKey);
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.ReportUrlMiscat.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        ReportUrlMiscat.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.urlId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.urlId = o.longs === String ? "0" : 0;
                d.interestKey = "";
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.urlId != null && m.hasOwnProperty("urlId")) {
                if (typeof m.urlId === "number")
                    d.urlId = o.longs === String ? String(m.urlId) : m.urlId;
                else
                    d.urlId = o.longs === String ? $util.Long.prototype.toString.call(m.urlId) : o.longs === Number ? new $util.LongBits(m.urlId.low >>> 0, m.urlId.high >>> 0).toNumber(true) : m.urlId;
            }
            if (m.interestKey != null && m.hasOwnProperty("interestKey")) {
                d.interestKey = m.interestKey;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        ReportUrlMiscat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReportUrlMiscat;
    })();

    commands.TrackContentView = (function() {

        function TrackContentView(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackContentView.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackContentView.prototype.urlId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackContentView.prototype.viewType = 0;
        TrackContentView.prototype.context = null;

        TrackContentView.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.urlId != null && Object.hasOwnProperty.call(m, "urlId"))
                w.uint32(16).uint64(m.urlId);
            if (m.viewType != null && Object.hasOwnProperty.call(m, "viewType"))
                w.uint32(24).int32(m.viewType);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        TrackContentView.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackContentView.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackContentView();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.urlId = r.uint64();
                    break;
                case 3:
                    m.viewType = r.int32();
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackContentView.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackContentView.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.urlId != null && m.hasOwnProperty("urlId")) {
                if (!$util.isInteger(m.urlId) && !(m.urlId && $util.isInteger(m.urlId.low) && $util.isInteger(m.urlId.high)))
                    return "urlId: integer|Long expected";
            }
            if (m.viewType != null && m.hasOwnProperty("viewType")) {
                switch (m.viewType) {
                default:
                    return "viewType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackContentView.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackContentView)
                return d;
            var m = new $root.commands.TrackContentView();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            if (d.urlId != null) {
                if ($util.Long)
                    (m.urlId = $util.Long.fromValue(d.urlId)).unsigned = true;
                else if (typeof d.urlId === "string")
                    m.urlId = parseInt(d.urlId, 10);
                else if (typeof d.urlId === "number")
                    m.urlId = d.urlId;
                else if (typeof d.urlId === "object")
                    m.urlId = new $util.LongBits(d.urlId.low >>> 0, d.urlId.high >>> 0).toNumber(true);
            }
            switch (d.viewType) {
            case "UNKNOWN_CONTENT_VIEW_TYPE":
            case 0:
                m.viewType = 0;
                break;
            case "CARD_VIEW":
            case 1:
                m.viewType = 1;
                break;
            case "CONTENT_VIEW":
            case 2:
                m.viewType = 2;
                break;
            case "GRID_VIEW":
            case 3:
                m.viewType = 3;
                break;
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackContentView.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackContentView.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.urlId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.urlId = o.longs === String ? "0" : 0;
                d.viewType = o.enums === String ? "UNKNOWN_CONTENT_VIEW_TYPE" : 0;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.urlId != null && m.hasOwnProperty("urlId")) {
                if (typeof m.urlId === "number")
                    d.urlId = o.longs === String ? String(m.urlId) : m.urlId;
                else
                    d.urlId = o.longs === String ? $util.Long.prototype.toString.call(m.urlId) : o.longs === Number ? new $util.LongBits(m.urlId.low >>> 0, m.urlId.high >>> 0).toNumber(true) : m.urlId;
            }
            if (m.viewType != null && m.hasOwnProperty("viewType")) {
                d.viewType = o.enums === String ? $root.globals.ContentViewType[m.viewType] : m.viewType;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackContentView.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackContentView;
    })();

    commands.TrackGridViews = (function() {

        function TrackGridViews(p) {
            this.gridViews = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackGridViews.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackGridViews.prototype.gridViews = $util.emptyArray;
        TrackGridViews.prototype.context = null;

        TrackGridViews.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.gridViews != null && m.gridViews.length) {
                for (var i = 0; i < m.gridViews.length; ++i)
                    $root.commands.TrackGridViews.GridView.encode(m.gridViews[i], w.uint32(18).fork()).ldelim();
            }
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(26).fork()).ldelim();
            return w;
        };

        TrackGridViews.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackGridViews.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackGridViews();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    if (!(m.gridViews && m.gridViews.length))
                        m.gridViews = [];
                    m.gridViews.push($root.commands.TrackGridViews.GridView.decode(r, r.uint32()));
                    break;
                case 3:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackGridViews.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackGridViews.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.gridViews != null && m.hasOwnProperty("gridViews")) {
                if (!Array.isArray(m.gridViews))
                    return "gridViews: array expected";
                for (var i = 0; i < m.gridViews.length; ++i) {
                    {
                        var e = $root.commands.TrackGridViews.GridView.verify(m.gridViews[i]);
                        if (e)
                            return "gridViews." + e;
                    }
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackGridViews.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackGridViews)
                return d;
            var m = new $root.commands.TrackGridViews();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            if (d.gridViews) {
                if (!Array.isArray(d.gridViews))
                    throw TypeError(".commands.TrackGridViews.gridViews: array expected");
                m.gridViews = [];
                for (var i = 0; i < d.gridViews.length; ++i) {
                    if (typeof d.gridViews[i] !== "object")
                        throw TypeError(".commands.TrackGridViews.gridViews: object expected");
                    m.gridViews[i] = $root.commands.TrackGridViews.GridView.fromObject(d.gridViews[i]);
                }
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackGridViews.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackGridViews.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.gridViews = [];
            }
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.gridViews && m.gridViews.length) {
                d.gridViews = [];
                for (var j = 0; j < m.gridViews.length; ++j) {
                    d.gridViews[j] = $root.commands.TrackGridViews.GridView.toObject(m.gridViews[j], o);
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackGridViews.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        TrackGridViews.GridView = (function() {

            function GridView(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            GridView.prototype.urlId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
            GridView.prototype.position = 0;

            GridView.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.urlId != null && Object.hasOwnProperty.call(m, "urlId"))
                    w.uint32(8).uint64(m.urlId);
                if (m.position != null && Object.hasOwnProperty.call(m, "position"))
                    w.uint32(16).int32(m.position);
                return w;
            };

            GridView.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            GridView.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackGridViews.GridView();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.urlId = r.uint64();
                        break;
                    case 2:
                        m.position = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            GridView.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            GridView.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.urlId != null && m.hasOwnProperty("urlId")) {
                    if (!$util.isInteger(m.urlId) && !(m.urlId && $util.isInteger(m.urlId.low) && $util.isInteger(m.urlId.high)))
                        return "urlId: integer|Long expected";
                }
                if (m.position != null && m.hasOwnProperty("position")) {
                    if (!$util.isInteger(m.position))
                        return "position: integer expected";
                }
                return null;
            };

            GridView.fromObject = function fromObject(d) {
                if (d instanceof $root.commands.TrackGridViews.GridView)
                    return d;
                var m = new $root.commands.TrackGridViews.GridView();
                if (d.urlId != null) {
                    if ($util.Long)
                        (m.urlId = $util.Long.fromValue(d.urlId)).unsigned = true;
                    else if (typeof d.urlId === "string")
                        m.urlId = parseInt(d.urlId, 10);
                    else if (typeof d.urlId === "number")
                        m.urlId = d.urlId;
                    else if (typeof d.urlId === "object")
                        m.urlId = new $util.LongBits(d.urlId.low >>> 0, d.urlId.high >>> 0).toNumber(true);
                }
                if (d.position != null) {
                    m.position = d.position | 0;
                }
                return m;
            };

            GridView.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    if ($util.Long) {
                        var n = new $util.Long(0, 0, true);
                        d.urlId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                    } else
                        d.urlId = o.longs === String ? "0" : 0;
                    d.position = 0;
                }
                if (m.urlId != null && m.hasOwnProperty("urlId")) {
                    if (typeof m.urlId === "number")
                        d.urlId = o.longs === String ? String(m.urlId) : m.urlId;
                    else
                        d.urlId = o.longs === String ? $util.Long.prototype.toString.call(m.urlId) : o.longs === Number ? new $util.LongBits(m.urlId.low >>> 0, m.urlId.high >>> 0).toNumber(true) : m.urlId;
                }
                if (m.position != null && m.hasOwnProperty("position")) {
                    d.position = m.position;
                }
                return d;
            };

            GridView.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return GridView;
        })();

        return TrackGridViews;
    })();

    commands.TrackUserSession = (function() {

        function TrackUserSession(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackUserSession.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackUserSession.prototype.eventType = 0;
        TrackUserSession.prototype.clientSession = null;
        TrackUserSession.prototype.context = null;

        TrackUserSession.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.eventType != null && Object.hasOwnProperty.call(m, "eventType"))
                w.uint32(16).int32(m.eventType);
            if (m.clientSession != null && Object.hasOwnProperty.call(m, "clientSession"))
                $root.globals.ClientSession.encode(m.clientSession, w.uint32(26).fork()).ldelim();
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        TrackUserSession.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackUserSession.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackUserSession();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.eventType = r.int32();
                    break;
                case 3:
                    m.clientSession = $root.globals.ClientSession.decode(r, r.uint32());
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackUserSession.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackUserSession.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.eventType != null && m.hasOwnProperty("eventType")) {
                switch (m.eventType) {
                default:
                    return "eventType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            }
            if (m.clientSession != null && m.hasOwnProperty("clientSession")) {
                {
                    var e = $root.globals.ClientSession.verify(m.clientSession);
                    if (e)
                        return "clientSession." + e;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackUserSession.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackUserSession)
                return d;
            var m = new $root.commands.TrackUserSession();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            switch (d.eventType) {
            case "UNKNOWN_SESSION_EVENT_TYPE":
            case 0:
                m.eventType = 0;
                break;
            case "SESSION_STARTED":
            case 1:
                m.eventType = 1;
                break;
            case "SESSION_ENDED":
            case 2:
                m.eventType = 2;
                break;
            case "SESSION_UPDATED":
            case 3:
                m.eventType = 3;
                break;
            }
            if (d.clientSession != null) {
                if (typeof d.clientSession !== "object")
                    throw TypeError(".commands.TrackUserSession.clientSession: object expected");
                m.clientSession = $root.globals.ClientSession.fromObject(d.clientSession);
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackUserSession.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackUserSession.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                d.eventType = o.enums === String ? "UNKNOWN_SESSION_EVENT_TYPE" : 0;
                d.clientSession = null;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.eventType != null && m.hasOwnProperty("eventType")) {
                d.eventType = o.enums === String ? $root.globals.SessionEventType[m.eventType] : m.eventType;
            }
            if (m.clientSession != null && m.hasOwnProperty("clientSession")) {
                d.clientSession = $root.globals.ClientSession.toObject(m.clientSession, o);
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackUserSession.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackUserSession;
    })();

    commands.TrackStreamProfileView = (function() {

        function TrackStreamProfileView(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackStreamProfileView.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackStreamProfileView.prototype.streamType = 0;
        TrackStreamProfileView.prototype.context = null;

        TrackStreamProfileView.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.streamType != null && Object.hasOwnProperty.call(m, "streamType"))
                w.uint32(16).int32(m.streamType);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(26).fork()).ldelim();
            return w;
        };

        TrackStreamProfileView.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackStreamProfileView.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackStreamProfileView();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.streamType = r.int32();
                    break;
                case 3:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackStreamProfileView.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackStreamProfileView.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.streamType != null && m.hasOwnProperty("streamType")) {
                switch (m.streamType) {
                default:
                    return "streamType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackStreamProfileView.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackStreamProfileView)
                return d;
            var m = new $root.commands.TrackStreamProfileView();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            switch (d.streamType) {
            case "UNKNOWN_STREAM_TYPE":
            case 0:
                m.streamType = 0;
                break;
            case "TOP_FOR_YOU_STREAM":
            case 1:
                m.streamType = 1;
                break;
            case "CATEGORY_STREAM":
            case 2:
                m.streamType = 2;
                break;
            case "TOPIC_STREAM":
            case 3:
                m.streamType = 3;
                break;
            case "MIX_STREAM":
            case 4:
                m.streamType = 4;
                break;
            case "SHARE_STREAM":
            case 5:
                m.streamType = 5;
                break;
            case "USER_MIXED_STREAM":
            case 6:
                m.streamType = 6;
                break;
            case "MIX_DIGEST_STREAM":
            case 7:
                m.streamType = 7;
                break;
            case "ALL_OF_MIX_STREAM":
            case 8:
                m.streamType = 8;
                break;
            case "FEATURED_COLLECTION_CAROUSEL":
            case 9:
                m.streamType = 9;
                break;
            case "FEATURED_ARTICLE_CAROUSEL":
            case 10:
                m.streamType = 10;
                break;
            case "RELATED_ARTICLE_STREAM":
            case 11:
                m.streamType = 11;
                break;
            case "SEARCH_POSTS_STREAM":
            case 12:
                m.streamType = 12;
                break;
            case "SEARCH_COLLECTIONS_STREAM":
            case 13:
                m.streamType = 13;
                break;
            case "SEARCH_INTERESTS_STREAM":
            case 14:
                m.streamType = 14;
                break;
            case "SEARCH_PEOPLE_STREAM":
            case 15:
                m.streamType = 15;
                break;
            case "SEARCH_ALL_STREAM":
            case 16:
                m.streamType = 16;
                break;
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackStreamProfileView.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackStreamProfileView.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                d.streamType = o.enums === String ? "UNKNOWN_STREAM_TYPE" : 0;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.streamType != null && m.hasOwnProperty("streamType")) {
                d.streamType = o.enums === String ? $root.globals.StreamType[m.streamType] : m.streamType;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackStreamProfileView.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackStreamProfileView;
    })();

    commands.TrackUserProfileView = (function() {

        function TrackUserProfileView(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackUserProfileView.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackUserProfileView.prototype.profileUserId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackUserProfileView.prototype.context = null;

        TrackUserProfileView.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.profileUserId != null && Object.hasOwnProperty.call(m, "profileUserId"))
                w.uint32(16).uint64(m.profileUserId);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(26).fork()).ldelim();
            return w;
        };

        TrackUserProfileView.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackUserProfileView.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackUserProfileView();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.profileUserId = r.uint64();
                    break;
                case 3:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackUserProfileView.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackUserProfileView.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.profileUserId != null && m.hasOwnProperty("profileUserId")) {
                if (!$util.isInteger(m.profileUserId) && !(m.profileUserId && $util.isInteger(m.profileUserId.low) && $util.isInteger(m.profileUserId.high)))
                    return "profileUserId: integer|Long expected";
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackUserProfileView.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackUserProfileView)
                return d;
            var m = new $root.commands.TrackUserProfileView();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            if (d.profileUserId != null) {
                if ($util.Long)
                    (m.profileUserId = $util.Long.fromValue(d.profileUserId)).unsigned = true;
                else if (typeof d.profileUserId === "string")
                    m.profileUserId = parseInt(d.profileUserId, 10);
                else if (typeof d.profileUserId === "number")
                    m.profileUserId = d.profileUserId;
                else if (typeof d.profileUserId === "object")
                    m.profileUserId = new $util.LongBits(d.profileUserId.low >>> 0, d.profileUserId.high >>> 0).toNumber(true);
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackUserProfileView.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackUserProfileView.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.profileUserId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.profileUserId = o.longs === String ? "0" : 0;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.profileUserId != null && m.hasOwnProperty("profileUserId")) {
                if (typeof m.profileUserId === "number")
                    d.profileUserId = o.longs === String ? String(m.profileUserId) : m.profileUserId;
                else
                    d.profileUserId = o.longs === String ? $util.Long.prototype.toString.call(m.profileUserId) : o.longs === Number ? new $util.LongBits(m.profileUserId.low >>> 0, m.profileUserId.high >>> 0).toNumber(true) : m.profileUserId;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackUserProfileView.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackUserProfileView;
    })();

    commands.TrackMixProfileView = (function() {

        function TrackMixProfileView(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackMixProfileView.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackMixProfileView.prototype.viewedMixId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackMixProfileView.prototype.context = null;

        TrackMixProfileView.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.viewedMixId != null && Object.hasOwnProperty.call(m, "viewedMixId"))
                w.uint32(16).uint64(m.viewedMixId);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(26).fork()).ldelim();
            return w;
        };

        TrackMixProfileView.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackMixProfileView.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackMixProfileView();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.viewedMixId = r.uint64();
                    break;
                case 3:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackMixProfileView.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackMixProfileView.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.viewedMixId != null && m.hasOwnProperty("viewedMixId")) {
                if (!$util.isInteger(m.viewedMixId) && !(m.viewedMixId && $util.isInteger(m.viewedMixId.low) && $util.isInteger(m.viewedMixId.high)))
                    return "viewedMixId: integer|Long expected";
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackMixProfileView.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackMixProfileView)
                return d;
            var m = new $root.commands.TrackMixProfileView();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            if (d.viewedMixId != null) {
                if ($util.Long)
                    (m.viewedMixId = $util.Long.fromValue(d.viewedMixId)).unsigned = true;
                else if (typeof d.viewedMixId === "string")
                    m.viewedMixId = parseInt(d.viewedMixId, 10);
                else if (typeof d.viewedMixId === "number")
                    m.viewedMixId = d.viewedMixId;
                else if (typeof d.viewedMixId === "object")
                    m.viewedMixId = new $util.LongBits(d.viewedMixId.low >>> 0, d.viewedMixId.high >>> 0).toNumber(true);
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackMixProfileView.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackMixProfileView.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.viewedMixId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.viewedMixId = o.longs === String ? "0" : 0;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.viewedMixId != null && m.hasOwnProperty("viewedMixId")) {
                if (typeof m.viewedMixId === "number")
                    d.viewedMixId = o.longs === String ? String(m.viewedMixId) : m.viewedMixId;
                else
                    d.viewedMixId = o.longs === String ? $util.Long.prototype.toString.call(m.viewedMixId) : o.longs === Number ? new $util.LongBits(m.viewedMixId.low >>> 0, m.viewedMixId.high >>> 0).toNumber(true) : m.viewedMixId;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackMixProfileView.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackMixProfileView;
    })();

    commands.TrackTopicProfileView = (function() {

        function TrackTopicProfileView(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackTopicProfileView.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackTopicProfileView.prototype.topicKey = "";
        TrackTopicProfileView.prototype.context = null;

        TrackTopicProfileView.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.topicKey != null && Object.hasOwnProperty.call(m, "topicKey"))
                w.uint32(18).string(m.topicKey);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(26).fork()).ldelim();
            return w;
        };

        TrackTopicProfileView.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackTopicProfileView.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackTopicProfileView();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.topicKey = r.string();
                    break;
                case 3:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackTopicProfileView.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackTopicProfileView.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.topicKey != null && m.hasOwnProperty("topicKey")) {
                if (!$util.isString(m.topicKey))
                    return "topicKey: string expected";
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackTopicProfileView.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackTopicProfileView)
                return d;
            var m = new $root.commands.TrackTopicProfileView();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            if (d.topicKey != null) {
                m.topicKey = String(d.topicKey);
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackTopicProfileView.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackTopicProfileView.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                d.topicKey = "";
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.topicKey != null && m.hasOwnProperty("topicKey")) {
                d.topicKey = m.topicKey;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackTopicProfileView.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackTopicProfileView;
    })();

    commands.TrackUserProfileEvent = (function() {

        function TrackUserProfileEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackUserProfileEvent.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackUserProfileEvent.prototype.eventType = 0;
        TrackUserProfileEvent.prototype.context = null;

        TrackUserProfileEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.eventType != null && Object.hasOwnProperty.call(m, "eventType"))
                w.uint32(16).int32(m.eventType);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(26).fork()).ldelim();
            return w;
        };

        TrackUserProfileEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackUserProfileEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackUserProfileEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.eventType = r.int32();
                    break;
                case 3:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackUserProfileEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackUserProfileEvent.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.eventType != null && m.hasOwnProperty("eventType")) {
                switch (m.eventType) {
                default:
                    return "eventType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackUserProfileEvent.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackUserProfileEvent)
                return d;
            var m = new $root.commands.TrackUserProfileEvent();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            switch (d.eventType) {
            case "UNKNOWN_USER_PROFILE_EVENT_TYPE":
            case 0:
                m.eventType = 0;
                break;
            case "USER_PROFILE_CREATED":
            case 1:
                m.eventType = 1;
                break;
            case "USER_PROFILE_DELETED":
            case 2:
                m.eventType = 2;
                break;
            case "USER_PROFILE_UPDATED":
            case 3:
                m.eventType = 3;
                break;
            case "USER_PROFILE_COMPLETED":
            case 4:
                m.eventType = 4;
                break;
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackUserProfileEvent.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackUserProfileEvent.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                d.eventType = o.enums === String ? "UNKNOWN_USER_PROFILE_EVENT_TYPE" : 0;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.eventType != null && m.hasOwnProperty("eventType")) {
                d.eventType = o.enums === String ? $root.globals.UserProfileEventType[m.eventType] : m.eventType;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackUserProfileEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackUserProfileEvent;
    })();

    commands.TrackExternalUrlPrivateShareEvent = (function() {

        function TrackExternalUrlPrivateShareEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackExternalUrlPrivateShareEvent.prototype.senderUserId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackExternalUrlPrivateShareEvent.prototype.urlId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackExternalUrlPrivateShareEvent.prototype.shareType = 0;
        TrackExternalUrlPrivateShareEvent.prototype.context = null;

        TrackExternalUrlPrivateShareEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.senderUserId != null && Object.hasOwnProperty.call(m, "senderUserId"))
                w.uint32(8).uint64(m.senderUserId);
            if (m.urlId != null && Object.hasOwnProperty.call(m, "urlId"))
                w.uint32(16).uint64(m.urlId);
            if (m.shareType != null && Object.hasOwnProperty.call(m, "shareType"))
                w.uint32(24).int32(m.shareType);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        TrackExternalUrlPrivateShareEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackExternalUrlPrivateShareEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackExternalUrlPrivateShareEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.senderUserId = r.uint64();
                    break;
                case 2:
                    m.urlId = r.uint64();
                    break;
                case 3:
                    m.shareType = r.int32();
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackExternalUrlPrivateShareEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackExternalUrlPrivateShareEvent.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.senderUserId != null && m.hasOwnProperty("senderUserId")) {
                if (!$util.isInteger(m.senderUserId) && !(m.senderUserId && $util.isInteger(m.senderUserId.low) && $util.isInteger(m.senderUserId.high)))
                    return "senderUserId: integer|Long expected";
            }
            if (m.urlId != null && m.hasOwnProperty("urlId")) {
                if (!$util.isInteger(m.urlId) && !(m.urlId && $util.isInteger(m.urlId.low) && $util.isInteger(m.urlId.high)))
                    return "urlId: integer|Long expected";
            }
            if (m.shareType != null && m.hasOwnProperty("shareType")) {
                switch (m.shareType) {
                default:
                    return "shareType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackExternalUrlPrivateShareEvent.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackExternalUrlPrivateShareEvent)
                return d;
            var m = new $root.commands.TrackExternalUrlPrivateShareEvent();
            if (d.senderUserId != null) {
                if ($util.Long)
                    (m.senderUserId = $util.Long.fromValue(d.senderUserId)).unsigned = true;
                else if (typeof d.senderUserId === "string")
                    m.senderUserId = parseInt(d.senderUserId, 10);
                else if (typeof d.senderUserId === "number")
                    m.senderUserId = d.senderUserId;
                else if (typeof d.senderUserId === "object")
                    m.senderUserId = new $util.LongBits(d.senderUserId.low >>> 0, d.senderUserId.high >>> 0).toNumber(true);
            }
            if (d.urlId != null) {
                if ($util.Long)
                    (m.urlId = $util.Long.fromValue(d.urlId)).unsigned = true;
                else if (typeof d.urlId === "string")
                    m.urlId = parseInt(d.urlId, 10);
                else if (typeof d.urlId === "number")
                    m.urlId = d.urlId;
                else if (typeof d.urlId === "object")
                    m.urlId = new $util.LongBits(d.urlId.low >>> 0, d.urlId.high >>> 0).toNumber(true);
            }
            switch (d.shareType) {
            case "UNKNOWN_SHARE_TYPE":
            case 0:
                m.shareType = 0;
                break;
            case "INTERNAL_SHARE":
            case 1:
                m.shareType = 1;
                break;
            case "FB_SHARE":
            case 2:
                m.shareType = 2;
                break;
            case "TWITTER_SHARE":
            case 3:
                m.shareType = 3;
                break;
            case "WHATSAPP_SHARE":
            case 4:
                m.shareType = 4;
                break;
            case "SMS_SHARE":
            case 5:
                m.shareType = 5;
                break;
            case "EMAIL_SHARE":
            case 6:
                m.shareType = 6;
                break;
            case "EXTERNAL_SHARE":
            case 7:
                m.shareType = 7;
                break;
            case "PINTEREST_SHARE":
            case 8:
                m.shareType = 8;
                break;
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackExternalUrlPrivateShareEvent.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackExternalUrlPrivateShareEvent.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.senderUserId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.senderUserId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.urlId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.urlId = o.longs === String ? "0" : 0;
                d.shareType = o.enums === String ? "UNKNOWN_SHARE_TYPE" : 0;
                d.context = null;
            }
            if (m.senderUserId != null && m.hasOwnProperty("senderUserId")) {
                if (typeof m.senderUserId === "number")
                    d.senderUserId = o.longs === String ? String(m.senderUserId) : m.senderUserId;
                else
                    d.senderUserId = o.longs === String ? $util.Long.prototype.toString.call(m.senderUserId) : o.longs === Number ? new $util.LongBits(m.senderUserId.low >>> 0, m.senderUserId.high >>> 0).toNumber(true) : m.senderUserId;
            }
            if (m.urlId != null && m.hasOwnProperty("urlId")) {
                if (typeof m.urlId === "number")
                    d.urlId = o.longs === String ? String(m.urlId) : m.urlId;
                else
                    d.urlId = o.longs === String ? $util.Long.prototype.toString.call(m.urlId) : o.longs === Number ? new $util.LongBits(m.urlId.low >>> 0, m.urlId.high >>> 0).toNumber(true) : m.urlId;
            }
            if (m.shareType != null && m.hasOwnProperty("shareType")) {
                d.shareType = o.enums === String ? $root.globals.ShareType[m.shareType] : m.shareType;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackExternalUrlPrivateShareEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackExternalUrlPrivateShareEvent;
    })();

    commands.TrackExternalUserShareEvent = (function() {

        function TrackExternalUserShareEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackExternalUserShareEvent.prototype.senderUserId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackExternalUserShareEvent.prototype.sharedUserId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackExternalUserShareEvent.prototype.shareType = 0;
        TrackExternalUserShareEvent.prototype.context = null;

        TrackExternalUserShareEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.senderUserId != null && Object.hasOwnProperty.call(m, "senderUserId"))
                w.uint32(8).uint64(m.senderUserId);
            if (m.sharedUserId != null && Object.hasOwnProperty.call(m, "sharedUserId"))
                w.uint32(16).uint64(m.sharedUserId);
            if (m.shareType != null && Object.hasOwnProperty.call(m, "shareType"))
                w.uint32(24).int32(m.shareType);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        TrackExternalUserShareEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackExternalUserShareEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackExternalUserShareEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.senderUserId = r.uint64();
                    break;
                case 2:
                    m.sharedUserId = r.uint64();
                    break;
                case 3:
                    m.shareType = r.int32();
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackExternalUserShareEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackExternalUserShareEvent.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.senderUserId != null && m.hasOwnProperty("senderUserId")) {
                if (!$util.isInteger(m.senderUserId) && !(m.senderUserId && $util.isInteger(m.senderUserId.low) && $util.isInteger(m.senderUserId.high)))
                    return "senderUserId: integer|Long expected";
            }
            if (m.sharedUserId != null && m.hasOwnProperty("sharedUserId")) {
                if (!$util.isInteger(m.sharedUserId) && !(m.sharedUserId && $util.isInteger(m.sharedUserId.low) && $util.isInteger(m.sharedUserId.high)))
                    return "sharedUserId: integer|Long expected";
            }
            if (m.shareType != null && m.hasOwnProperty("shareType")) {
                switch (m.shareType) {
                default:
                    return "shareType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackExternalUserShareEvent.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackExternalUserShareEvent)
                return d;
            var m = new $root.commands.TrackExternalUserShareEvent();
            if (d.senderUserId != null) {
                if ($util.Long)
                    (m.senderUserId = $util.Long.fromValue(d.senderUserId)).unsigned = true;
                else if (typeof d.senderUserId === "string")
                    m.senderUserId = parseInt(d.senderUserId, 10);
                else if (typeof d.senderUserId === "number")
                    m.senderUserId = d.senderUserId;
                else if (typeof d.senderUserId === "object")
                    m.senderUserId = new $util.LongBits(d.senderUserId.low >>> 0, d.senderUserId.high >>> 0).toNumber(true);
            }
            if (d.sharedUserId != null) {
                if ($util.Long)
                    (m.sharedUserId = $util.Long.fromValue(d.sharedUserId)).unsigned = true;
                else if (typeof d.sharedUserId === "string")
                    m.sharedUserId = parseInt(d.sharedUserId, 10);
                else if (typeof d.sharedUserId === "number")
                    m.sharedUserId = d.sharedUserId;
                else if (typeof d.sharedUserId === "object")
                    m.sharedUserId = new $util.LongBits(d.sharedUserId.low >>> 0, d.sharedUserId.high >>> 0).toNumber(true);
            }
            switch (d.shareType) {
            case "UNKNOWN_SHARE_TYPE":
            case 0:
                m.shareType = 0;
                break;
            case "INTERNAL_SHARE":
            case 1:
                m.shareType = 1;
                break;
            case "FB_SHARE":
            case 2:
                m.shareType = 2;
                break;
            case "TWITTER_SHARE":
            case 3:
                m.shareType = 3;
                break;
            case "WHATSAPP_SHARE":
            case 4:
                m.shareType = 4;
                break;
            case "SMS_SHARE":
            case 5:
                m.shareType = 5;
                break;
            case "EMAIL_SHARE":
            case 6:
                m.shareType = 6;
                break;
            case "EXTERNAL_SHARE":
            case 7:
                m.shareType = 7;
                break;
            case "PINTEREST_SHARE":
            case 8:
                m.shareType = 8;
                break;
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackExternalUserShareEvent.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackExternalUserShareEvent.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.senderUserId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.senderUserId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.sharedUserId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.sharedUserId = o.longs === String ? "0" : 0;
                d.shareType = o.enums === String ? "UNKNOWN_SHARE_TYPE" : 0;
                d.context = null;
            }
            if (m.senderUserId != null && m.hasOwnProperty("senderUserId")) {
                if (typeof m.senderUserId === "number")
                    d.senderUserId = o.longs === String ? String(m.senderUserId) : m.senderUserId;
                else
                    d.senderUserId = o.longs === String ? $util.Long.prototype.toString.call(m.senderUserId) : o.longs === Number ? new $util.LongBits(m.senderUserId.low >>> 0, m.senderUserId.high >>> 0).toNumber(true) : m.senderUserId;
            }
            if (m.sharedUserId != null && m.hasOwnProperty("sharedUserId")) {
                if (typeof m.sharedUserId === "number")
                    d.sharedUserId = o.longs === String ? String(m.sharedUserId) : m.sharedUserId;
                else
                    d.sharedUserId = o.longs === String ? $util.Long.prototype.toString.call(m.sharedUserId) : o.longs === Number ? new $util.LongBits(m.sharedUserId.low >>> 0, m.sharedUserId.high >>> 0).toNumber(true) : m.sharedUserId;
            }
            if (m.shareType != null && m.hasOwnProperty("shareType")) {
                d.shareType = o.enums === String ? $root.globals.ShareType[m.shareType] : m.shareType;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackExternalUserShareEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackExternalUserShareEvent;
    })();

    commands.TrackExternalMixShareEvent = (function() {

        function TrackExternalMixShareEvent(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackExternalMixShareEvent.prototype.senderUserId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackExternalMixShareEvent.prototype.mixId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        TrackExternalMixShareEvent.prototype.shareType = 0;
        TrackExternalMixShareEvent.prototype.context = null;

        TrackExternalMixShareEvent.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.senderUserId != null && Object.hasOwnProperty.call(m, "senderUserId"))
                w.uint32(8).uint64(m.senderUserId);
            if (m.mixId != null && Object.hasOwnProperty.call(m, "mixId"))
                w.uint32(16).uint64(m.mixId);
            if (m.shareType != null && Object.hasOwnProperty.call(m, "shareType"))
                w.uint32(24).int32(m.shareType);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        TrackExternalMixShareEvent.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackExternalMixShareEvent.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.TrackExternalMixShareEvent();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.senderUserId = r.uint64();
                    break;
                case 2:
                    m.mixId = r.uint64();
                    break;
                case 3:
                    m.shareType = r.int32();
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackExternalMixShareEvent.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackExternalMixShareEvent.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.senderUserId != null && m.hasOwnProperty("senderUserId")) {
                if (!$util.isInteger(m.senderUserId) && !(m.senderUserId && $util.isInteger(m.senderUserId.low) && $util.isInteger(m.senderUserId.high)))
                    return "senderUserId: integer|Long expected";
            }
            if (m.mixId != null && m.hasOwnProperty("mixId")) {
                if (!$util.isInteger(m.mixId) && !(m.mixId && $util.isInteger(m.mixId.low) && $util.isInteger(m.mixId.high)))
                    return "mixId: integer|Long expected";
            }
            if (m.shareType != null && m.hasOwnProperty("shareType")) {
                switch (m.shareType) {
                default:
                    return "shareType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        TrackExternalMixShareEvent.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.TrackExternalMixShareEvent)
                return d;
            var m = new $root.commands.TrackExternalMixShareEvent();
            if (d.senderUserId != null) {
                if ($util.Long)
                    (m.senderUserId = $util.Long.fromValue(d.senderUserId)).unsigned = true;
                else if (typeof d.senderUserId === "string")
                    m.senderUserId = parseInt(d.senderUserId, 10);
                else if (typeof d.senderUserId === "number")
                    m.senderUserId = d.senderUserId;
                else if (typeof d.senderUserId === "object")
                    m.senderUserId = new $util.LongBits(d.senderUserId.low >>> 0, d.senderUserId.high >>> 0).toNumber(true);
            }
            if (d.mixId != null) {
                if ($util.Long)
                    (m.mixId = $util.Long.fromValue(d.mixId)).unsigned = true;
                else if (typeof d.mixId === "string")
                    m.mixId = parseInt(d.mixId, 10);
                else if (typeof d.mixId === "number")
                    m.mixId = d.mixId;
                else if (typeof d.mixId === "object")
                    m.mixId = new $util.LongBits(d.mixId.low >>> 0, d.mixId.high >>> 0).toNumber(true);
            }
            switch (d.shareType) {
            case "UNKNOWN_SHARE_TYPE":
            case 0:
                m.shareType = 0;
                break;
            case "INTERNAL_SHARE":
            case 1:
                m.shareType = 1;
                break;
            case "FB_SHARE":
            case 2:
                m.shareType = 2;
                break;
            case "TWITTER_SHARE":
            case 3:
                m.shareType = 3;
                break;
            case "WHATSAPP_SHARE":
            case 4:
                m.shareType = 4;
                break;
            case "SMS_SHARE":
            case 5:
                m.shareType = 5;
                break;
            case "EMAIL_SHARE":
            case 6:
                m.shareType = 6;
                break;
            case "EXTERNAL_SHARE":
            case 7:
                m.shareType = 7;
                break;
            case "PINTEREST_SHARE":
            case 8:
                m.shareType = 8;
                break;
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.TrackExternalMixShareEvent.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        TrackExternalMixShareEvent.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.senderUserId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.senderUserId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.mixId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.mixId = o.longs === String ? "0" : 0;
                d.shareType = o.enums === String ? "UNKNOWN_SHARE_TYPE" : 0;
                d.context = null;
            }
            if (m.senderUserId != null && m.hasOwnProperty("senderUserId")) {
                if (typeof m.senderUserId === "number")
                    d.senderUserId = o.longs === String ? String(m.senderUserId) : m.senderUserId;
                else
                    d.senderUserId = o.longs === String ? $util.Long.prototype.toString.call(m.senderUserId) : o.longs === Number ? new $util.LongBits(m.senderUserId.low >>> 0, m.senderUserId.high >>> 0).toNumber(true) : m.senderUserId;
            }
            if (m.mixId != null && m.hasOwnProperty("mixId")) {
                if (typeof m.mixId === "number")
                    d.mixId = o.longs === String ? String(m.mixId) : m.mixId;
                else
                    d.mixId = o.longs === String ? $util.Long.prototype.toString.call(m.mixId) : o.longs === Number ? new $util.LongBits(m.mixId.low >>> 0, m.mixId.high >>> 0).toNumber(true) : m.mixId;
            }
            if (m.shareType != null && m.hasOwnProperty("shareType")) {
                d.shareType = o.enums === String ? $root.globals.ShareType[m.shareType] : m.shareType;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        TrackExternalMixShareEvent.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackExternalMixShareEvent;
    })();

    commands.RateUrl = (function() {

        function RateUrl(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RateUrl.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        RateUrl.prototype.urlId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
        RateUrl.prototype.ratingType = 0;
        RateUrl.prototype.context = null;

        RateUrl.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                w.uint32(8).uint64(m.userId);
            if (m.urlId != null && Object.hasOwnProperty.call(m, "urlId"))
                w.uint32(16).uint64(m.urlId);
            if (m.ratingType != null && Object.hasOwnProperty.call(m, "ratingType"))
                w.uint32(24).int32(m.ratingType);
            if (m.context != null && Object.hasOwnProperty.call(m, "context"))
                $root.commands.CommandContext.encode(m.context, w.uint32(34).fork()).ldelim();
            return w;
        };

        RateUrl.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RateUrl.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.commands.RateUrl();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = r.uint64();
                    break;
                case 2:
                    m.urlId = r.uint64();
                    break;
                case 3:
                    m.ratingType = r.int32();
                    break;
                case 4:
                    m.context = $root.commands.CommandContext.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RateUrl.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RateUrl.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (!$util.isInteger(m.userId) && !(m.userId && $util.isInteger(m.userId.low) && $util.isInteger(m.userId.high)))
                    return "userId: integer|Long expected";
            }
            if (m.urlId != null && m.hasOwnProperty("urlId")) {
                if (!$util.isInteger(m.urlId) && !(m.urlId && $util.isInteger(m.urlId.low) && $util.isInteger(m.urlId.high)))
                    return "urlId: integer|Long expected";
            }
            if (m.ratingType != null && m.hasOwnProperty("ratingType")) {
                switch (m.ratingType) {
                default:
                    return "ratingType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                {
                    var e = $root.commands.CommandContext.verify(m.context);
                    if (e)
                        return "context." + e;
                }
            }
            return null;
        };

        RateUrl.fromObject = function fromObject(d) {
            if (d instanceof $root.commands.RateUrl)
                return d;
            var m = new $root.commands.RateUrl();
            if (d.userId != null) {
                if ($util.Long)
                    (m.userId = $util.Long.fromValue(d.userId)).unsigned = true;
                else if (typeof d.userId === "string")
                    m.userId = parseInt(d.userId, 10);
                else if (typeof d.userId === "number")
                    m.userId = d.userId;
                else if (typeof d.userId === "object")
                    m.userId = new $util.LongBits(d.userId.low >>> 0, d.userId.high >>> 0).toNumber(true);
            }
            if (d.urlId != null) {
                if ($util.Long)
                    (m.urlId = $util.Long.fromValue(d.urlId)).unsigned = true;
                else if (typeof d.urlId === "string")
                    m.urlId = parseInt(d.urlId, 10);
                else if (typeof d.urlId === "number")
                    m.urlId = d.urlId;
                else if (typeof d.urlId === "object")
                    m.urlId = new $util.LongBits(d.urlId.low >>> 0, d.urlId.high >>> 0).toNumber(true);
            }
            switch (d.ratingType) {
            case "UNKNOWN_RATE_URL_TYPE":
            case 0:
                m.ratingType = 0;
                break;
            case "RATE_URL_NONE":
            case 1:
                m.ratingType = 1;
                break;
            case "RATE_URL_UP":
            case 2:
                m.ratingType = 2;
                break;
            case "RATE_URL_DOWN":
            case 3:
                m.ratingType = 3;
                break;
            }
            if (d.context != null) {
                if (typeof d.context !== "object")
                    throw TypeError(".commands.RateUrl.context: object expected");
                m.context = $root.commands.CommandContext.fromObject(d.context);
            }
            return m;
        };

        RateUrl.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.userId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.userId = o.longs === String ? "0" : 0;
                if ($util.Long) {
                    var n = new $util.Long(0, 0, true);
                    d.urlId = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                } else
                    d.urlId = o.longs === String ? "0" : 0;
                d.ratingType = o.enums === String ? "UNKNOWN_RATE_URL_TYPE" : 0;
                d.context = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                if (typeof m.userId === "number")
                    d.userId = o.longs === String ? String(m.userId) : m.userId;
                else
                    d.userId = o.longs === String ? $util.Long.prototype.toString.call(m.userId) : o.longs === Number ? new $util.LongBits(m.userId.low >>> 0, m.userId.high >>> 0).toNumber(true) : m.userId;
            }
            if (m.urlId != null && m.hasOwnProperty("urlId")) {
                if (typeof m.urlId === "number")
                    d.urlId = o.longs === String ? String(m.urlId) : m.urlId;
                else
                    d.urlId = o.longs === String ? $util.Long.prototype.toString.call(m.urlId) : o.longs === Number ? new $util.LongBits(m.urlId.low >>> 0, m.urlId.high >>> 0).toNumber(true) : m.urlId;
            }
            if (m.ratingType != null && m.hasOwnProperty("ratingType")) {
                d.ratingType = o.enums === String ? $root.globals.RateUrlType[m.ratingType] : m.ratingType;
            }
            if (m.context != null && m.hasOwnProperty("context")) {
                d.context = $root.commands.CommandContext.toObject(m.context, o);
            }
            return d;
        };

        RateUrl.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RateUrl;
    })();

    return commands;
})();

const google = $root.google = (() => {

    const google = {};

    google.protobuf = (function() {

        const protobuf = {};

        protobuf.DoubleValue = (function() {

            function DoubleValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            DoubleValue.prototype.value = 0;

            DoubleValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(9).double(m.value);
                return w;
            };

            DoubleValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            DoubleValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.DoubleValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.double();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            DoubleValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            DoubleValue.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (typeof m.value !== "number")
                        return "value: number expected";
                }
                return null;
            };

            DoubleValue.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.DoubleValue)
                    return d;
                var m = new $root.google.protobuf.DoubleValue();
                if (d.value != null) {
                    m.value = Number(d.value);
                }
                return m;
            };

            DoubleValue.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    d.value = 0;
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    d.value = o.json && !isFinite(m.value) ? String(m.value) : m.value;
                }
                return d;
            };

            DoubleValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return DoubleValue;
        })();

        protobuf.FloatValue = (function() {

            function FloatValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            FloatValue.prototype.value = 0;

            FloatValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(13).float(m.value);
                return w;
            };

            FloatValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            FloatValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.FloatValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.float();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            FloatValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            FloatValue.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (typeof m.value !== "number")
                        return "value: number expected";
                }
                return null;
            };

            FloatValue.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.FloatValue)
                    return d;
                var m = new $root.google.protobuf.FloatValue();
                if (d.value != null) {
                    m.value = Number(d.value);
                }
                return m;
            };

            FloatValue.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    d.value = 0;
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    d.value = o.json && !isFinite(m.value) ? String(m.value) : m.value;
                }
                return d;
            };

            FloatValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return FloatValue;
        })();

        protobuf.Int64Value = (function() {

            function Int64Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            Int64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            Int64Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).int64(m.value);
                return w;
            };

            Int64Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            Int64Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Int64Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.int64();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            Int64Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            Int64Value.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (!$util.isInteger(m.value) && !(m.value && $util.isInteger(m.value.low) && $util.isInteger(m.value.high)))
                        return "value: integer|Long expected";
                }
                return null;
            };

            Int64Value.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.Int64Value)
                    return d;
                var m = new $root.google.protobuf.Int64Value();
                if (d.value != null) {
                    if ($util.Long)
                        (m.value = $util.Long.fromValue(d.value)).unsigned = false;
                    else if (typeof d.value === "string")
                        m.value = parseInt(d.value, 10);
                    else if (typeof d.value === "number")
                        m.value = d.value;
                    else if (typeof d.value === "object")
                        m.value = new $util.LongBits(d.value.low >>> 0, d.value.high >>> 0).toNumber();
                }
                return m;
            };

            Int64Value.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    if ($util.Long) {
                        var n = new $util.Long(0, 0, false);
                        d.value = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                    } else
                        d.value = o.longs === String ? "0" : 0;
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (typeof m.value === "number")
                        d.value = o.longs === String ? String(m.value) : m.value;
                    else
                        d.value = o.longs === String ? $util.Long.prototype.toString.call(m.value) : o.longs === Number ? new $util.LongBits(m.value.low >>> 0, m.value.high >>> 0).toNumber() : m.value;
                }
                return d;
            };

            Int64Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Int64Value;
        })();

        protobuf.UInt64Value = (function() {

            function UInt64Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            UInt64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

            UInt64Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).uint64(m.value);
                return w;
            };

            UInt64Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            UInt64Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.UInt64Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.uint64();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            UInt64Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            UInt64Value.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (!$util.isInteger(m.value) && !(m.value && $util.isInteger(m.value.low) && $util.isInteger(m.value.high)))
                        return "value: integer|Long expected";
                }
                return null;
            };

            UInt64Value.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.UInt64Value)
                    return d;
                var m = new $root.google.protobuf.UInt64Value();
                if (d.value != null) {
                    if ($util.Long)
                        (m.value = $util.Long.fromValue(d.value)).unsigned = true;
                    else if (typeof d.value === "string")
                        m.value = parseInt(d.value, 10);
                    else if (typeof d.value === "number")
                        m.value = d.value;
                    else if (typeof d.value === "object")
                        m.value = new $util.LongBits(d.value.low >>> 0, d.value.high >>> 0).toNumber(true);
                }
                return m;
            };

            UInt64Value.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    if ($util.Long) {
                        var n = new $util.Long(0, 0, true);
                        d.value = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                    } else
                        d.value = o.longs === String ? "0" : 0;
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (typeof m.value === "number")
                        d.value = o.longs === String ? String(m.value) : m.value;
                    else
                        d.value = o.longs === String ? $util.Long.prototype.toString.call(m.value) : o.longs === Number ? new $util.LongBits(m.value.low >>> 0, m.value.high >>> 0).toNumber(true) : m.value;
                }
                return d;
            };

            UInt64Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UInt64Value;
        })();

        protobuf.Int32Value = (function() {

            function Int32Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            Int32Value.prototype.value = 0;

            Int32Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).int32(m.value);
                return w;
            };

            Int32Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            Int32Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.Int32Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.int32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            Int32Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            Int32Value.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (!$util.isInteger(m.value))
                        return "value: integer expected";
                }
                return null;
            };

            Int32Value.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.Int32Value)
                    return d;
                var m = new $root.google.protobuf.Int32Value();
                if (d.value != null) {
                    m.value = d.value | 0;
                }
                return m;
            };

            Int32Value.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    d.value = 0;
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    d.value = m.value;
                }
                return d;
            };

            Int32Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Int32Value;
        })();

        protobuf.UInt32Value = (function() {

            function UInt32Value(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            UInt32Value.prototype.value = 0;

            UInt32Value.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).uint32(m.value);
                return w;
            };

            UInt32Value.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            UInt32Value.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.UInt32Value();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.uint32();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            UInt32Value.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            UInt32Value.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (!$util.isInteger(m.value))
                        return "value: integer expected";
                }
                return null;
            };

            UInt32Value.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.UInt32Value)
                    return d;
                var m = new $root.google.protobuf.UInt32Value();
                if (d.value != null) {
                    m.value = d.value >>> 0;
                }
                return m;
            };

            UInt32Value.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    d.value = 0;
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    d.value = m.value;
                }
                return d;
            };

            UInt32Value.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return UInt32Value;
        })();

        protobuf.BoolValue = (function() {

            function BoolValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            BoolValue.prototype.value = false;

            BoolValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(8).bool(m.value);
                return w;
            };

            BoolValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            BoolValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.BoolValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.bool();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            BoolValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            BoolValue.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (typeof m.value !== "boolean")
                        return "value: boolean expected";
                }
                return null;
            };

            BoolValue.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.BoolValue)
                    return d;
                var m = new $root.google.protobuf.BoolValue();
                if (d.value != null) {
                    m.value = Boolean(d.value);
                }
                return m;
            };

            BoolValue.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    d.value = false;
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    d.value = m.value;
                }
                return d;
            };

            BoolValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BoolValue;
        })();

        protobuf.StringValue = (function() {

            function StringValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            StringValue.prototype.value = "";

            StringValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(10).string(m.value);
                return w;
            };

            StringValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            StringValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.StringValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.string();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            StringValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            StringValue.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (!$util.isString(m.value))
                        return "value: string expected";
                }
                return null;
            };

            StringValue.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.StringValue)
                    return d;
                var m = new $root.google.protobuf.StringValue();
                if (d.value != null) {
                    m.value = String(d.value);
                }
                return m;
            };

            StringValue.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    d.value = "";
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    d.value = m.value;
                }
                return d;
            };

            StringValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return StringValue;
        })();

        protobuf.BytesValue = (function() {

            function BytesValue(p) {
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            BytesValue.prototype.value = $util.newBuffer([]);

            BytesValue.encode = function encode(m, w) {
                if (!w)
                    w = $Writer.create();
                if (m.value != null && Object.hasOwnProperty.call(m, "value"))
                    w.uint32(10).bytes(m.value);
                return w;
            };

            BytesValue.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            BytesValue.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.google.protobuf.BytesValue();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        m.value = r.bytes();
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            BytesValue.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            BytesValue.verify = function verify(m) {
                if (typeof m !== "object" || m === null)
                    return "object expected";
                if (m.value != null && m.hasOwnProperty("value")) {
                    if (!(m.value && typeof m.value.length === "number" || $util.isString(m.value)))
                        return "value: buffer expected";
                }
                return null;
            };

            BytesValue.fromObject = function fromObject(d) {
                if (d instanceof $root.google.protobuf.BytesValue)
                    return d;
                var m = new $root.google.protobuf.BytesValue();
                if (d.value != null) {
                    if (typeof d.value === "string")
                        $util.base64.decode(d.value, m.value = $util.newBuffer($util.base64.length(d.value)), 0);
                    else if (d.value.length)
                        m.value = d.value;
                }
                return m;
            };

            BytesValue.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.defaults) {
                    if (o.bytes === String)
                        d.value = "";
                    else {
                        d.value = [];
                        if (o.bytes !== Array)
                            d.value = $util.newBuffer(d.value);
                    }
                }
                if (m.value != null && m.hasOwnProperty("value")) {
                    d.value = o.bytes === String ? $util.base64.encode(m.value, 0, m.value.length) : o.bytes === Array ? Array.prototype.slice.call(m.value) : m.value;
                }
                return d;
            };

            BytesValue.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return BytesValue;
        })();

        return protobuf;
    })();

    return google;
})();

const globals = $root.globals = (() => {

    const globals = {};

    globals.Gender = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_GENDER"] = 0;
        values[valuesById[1] = "FEMALE"] = 1;
        values[valuesById[2] = "MALE"] = 2;
        values[valuesById[3] = "NOT_SPECIFIED"] = 3;
        return values;
    })();

    globals.Language = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_LANGUAGE"] = 0;
        values[valuesById[1] = "ENGLISH"] = 1;
        return values;
    })();

    globals.DeviceType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_DEVICE"] = 0;
        values[valuesById[1] = "IPHONE"] = 1;
        values[valuesById[2] = "DEPRECATED_CHROME_EXTENSION"] = 2;
        values[valuesById[3] = "DEPRECATED_WEBAPP"] = 3;
        values[valuesById[4] = "DEPRECATED_FIREFOX_EXTENSION"] = 4;
        values[valuesById[5] = "ANDROID"] = 5;
        values[valuesById[6] = "IPAD"] = 6;
        values[valuesById[7] = "ANDROID_TABLET"] = 7;
        values[valuesById[8] = "DESKTOP"] = 8;
        values[valuesById[9] = "INTERNAL"] = 9;
        values[valuesById[10] = "WINDOWS_PHONE"] = 10;
        values[valuesById[11] = "SYMBIAN"] = 11;
        return values;
    })();

    globals.ApplicationType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_APP"] = 0;
        values[valuesById[1] = "IOS_APP"] = 1;
        values[valuesById[2] = "WEBAPP"] = 2;
        values[valuesById[3] = "ANDROID_APP"] = 3;
        values[valuesById[4] = "CHROME_EXTENSION"] = 4;
        values[valuesById[5] = "FIREFOX_EXTENSION"] = 5;
        values[valuesById[6] = "MIX_BADGE"] = 6;
        values[valuesById[7] = "THIRD_PARTY_BADGE"] = 7;
        values[valuesById[8] = "INGESTER"] = 8;
        values[valuesById[9] = "INTERNAL_APP"] = 9;
        values[valuesById[10] = "SAFARI_EXTENSION"] = 10;
        values[valuesById[11] = "EDGE_EXTENSION"] = 11;
        return values;
    })();

    globals.AppProvider = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_PROVIDER"] = 0;
        values[valuesById[1] = "APPLE_STORE"] = 1;
        values[valuesById[2] = "CHROME_WEB_STORE"] = 2;
        values[valuesById[3] = "MIX"] = 3;
        values[valuesById[4] = "GOOGLE_PLAY_STORE"] = 4;
        values[valuesById[5] = "OTHER_APP_PROVIDER"] = 5;
        values[valuesById[6] = "FIREFOX_ADD_ONS"] = 6;
        values[valuesById[7] = "MICROSOFT_STORE"] = 7;
        return values;
    })();

    globals.StreamType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_STREAM_TYPE"] = 0;
        values[valuesById[1] = "TOP_FOR_YOU_STREAM"] = 1;
        values[valuesById[2] = "CATEGORY_STREAM"] = 2;
        values[valuesById[3] = "TOPIC_STREAM"] = 3;
        values[valuesById[4] = "MIX_STREAM"] = 4;
        values[valuesById[5] = "SHARE_STREAM"] = 5;
        values[valuesById[6] = "USER_MIXED_STREAM"] = 6;
        values[valuesById[7] = "MIX_DIGEST_STREAM"] = 7;
        values[valuesById[8] = "ALL_OF_MIX_STREAM"] = 8;
        values[valuesById[9] = "FEATURED_COLLECTION_CAROUSEL"] = 9;
        values[valuesById[10] = "FEATURED_ARTICLE_CAROUSEL"] = 10;
        values[valuesById[11] = "RELATED_ARTICLE_STREAM"] = 11;
        values[valuesById[12] = "SEARCH_POSTS_STREAM"] = 12;
        values[valuesById[13] = "SEARCH_COLLECTIONS_STREAM"] = 13;
        values[valuesById[14] = "SEARCH_INTERESTS_STREAM"] = 14;
        values[valuesById[15] = "SEARCH_PEOPLE_STREAM"] = 15;
        values[valuesById[16] = "SEARCH_ALL_STREAM"] = 16;
        return values;
    })();

    globals.ShareType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SHARE_TYPE"] = 0;
        values[valuesById[1] = "INTERNAL_SHARE"] = 1;
        values[valuesById[2] = "FB_SHARE"] = 2;
        values[valuesById[3] = "TWITTER_SHARE"] = 3;
        values[valuesById[4] = "WHATSAPP_SHARE"] = 4;
        values[valuesById[5] = "SMS_SHARE"] = 5;
        values[valuesById[6] = "EMAIL_SHARE"] = 6;
        values[valuesById[7] = "EXTERNAL_SHARE"] = 7;
        values[valuesById[8] = "PINTEREST_SHARE"] = 8;
        return values;
    })();

    globals.OptType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_OPT_TYPE"] = 0;
        values[valuesById[1] = "OPT_IN"] = 1;
        values[valuesById[2] = "OPT_OUT"] = 2;
        return values;
    })();

    globals.NotificationChannel = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_NOTIFICATION_CHANNEL"] = 0;
        values[valuesById[1] = "SMS"] = 1;
        values[valuesById[2] = "EMAIL"] = 2;
        values[valuesById[3] = "MOBILE"] = 3;
        return values;
    })();

    globals.UserExternalAccountType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_ACCOUNT"] = 0;
        values[valuesById[1] = "FACEBOOK_ACCOUNT"] = 1;
        values[valuesById[2] = "TWITTER_ACCOUNT"] = 2;
        values[valuesById[3] = "GOOGLE_ACCOUNT"] = 3;
        values[valuesById[4] = "STUMBLEUPON_ACCOUNT"] = 4;
        values[valuesById[5] = "APPLE_ACCOUNT"] = 5;
        values[valuesById[6] = "EMAIL_ACCOUNT"] = 6;
        return values;
    })();

    globals.ContentViewType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_CONTENT_VIEW_TYPE"] = 0;
        values[valuesById[1] = "CARD_VIEW"] = 1;
        values[valuesById[2] = "CONTENT_VIEW"] = 2;
        values[valuesById[3] = "GRID_VIEW"] = 3;
        return values;
    })();

    globals.FollowEventType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_FOLLOW_EVENT_TYPE"] = 0;
        values[valuesById[1] = "FOLLOWED"] = 1;
        values[valuesById[2] = "UNFOLLOWED"] = 2;
        return values;
    })();

    globals.UrlFlaggedReason = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_FLAG_REASON"] = 0;
        values[valuesById[1] = "NOT_INTERESTED"] = 1;
        values[valuesById[2] = "SENSITIVE_IMG"] = 2;
        values[valuesById[3] = "ABUSIVE"] = 3;
        values[valuesById[4] = "SPAM"] = 4;
        values[valuesById[5] = "NSFW"] = 5;
        values[valuesById[6] = "DEAD"] = 6;
        values[valuesById[7] = "EXTENSION_BREAKS"] = 7;
        values[valuesById[8] = "EXTENSION_REMOVED"] = 8;
        return values;
    })();

    globals.BooleanValue = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "NOT_SET"] = 0;
        values[valuesById[1] = "TRUE"] = 1;
        values[valuesById[2] = "FALSE"] = 2;
        return values;
    })();

    globals.SessionEventType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SESSION_EVENT_TYPE"] = 0;
        values[valuesById[1] = "SESSION_STARTED"] = 1;
        values[valuesById[2] = "SESSION_ENDED"] = 2;
        values[valuesById[3] = "SESSION_UPDATED"] = 3;
        return values;
    })();

    globals.UserProfileEventType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_USER_PROFILE_EVENT_TYPE"] = 0;
        values[valuesById[1] = "USER_PROFILE_CREATED"] = 1;
        values[valuesById[2] = "USER_PROFILE_DELETED"] = 2;
        values[valuesById[3] = "USER_PROFILE_UPDATED"] = 3;
        values[valuesById[4] = "USER_PROFILE_COMPLETED"] = 4;
        return values;
    })();

    globals.RateUrlType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_RATE_URL_TYPE"] = 0;
        values[valuesById[1] = "RATE_URL_NONE"] = 1;
        values[valuesById[2] = "RATE_URL_UP"] = 2;
        values[valuesById[3] = "RATE_URL_DOWN"] = 3;
        return values;
    })();

    globals.MediaType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_MEDIA_TYPE"] = 0;
        values[valuesById[1] = "WEBSITE"] = 1;
        values[valuesById[2] = "ARTICLE"] = 2;
        values[valuesById[3] = "IMAGE"] = 3;
        values[valuesById[4] = "VIDEO"] = 4;
        values[valuesById[5] = "AUDIO"] = 5;
        values[valuesById[6] = "PDF"] = 6;
        values[valuesById[7] = "NEWS"] = 7;
        values[valuesById[8] = "GAME"] = 8;
        values[valuesById[9] = "GIF"] = 9;
        values[valuesById[10] = "APP"] = 10;
        return values;
    })();

    globals.EntityType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_ENTITY_TYPE"] = 0;
        values[valuesById[1] = "TYPE_URL"] = 1;
        values[valuesById[2] = "TYPE_COLLECTION"] = 2;
        values[valuesById[3] = "TYPE_USER"] = 3;
        values[valuesById[4] = "TYPE_INTEREST"] = 4;
        values[valuesById[5] = "TYPE_DOMAIN"] = 5;
        values[valuesById[6] = "TYPE_KEYWORD"] = 6;
        return values;
    })();

    globals.DisplayOrientation = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_DISPLAY_ORIENTATION"] = 0;
        values[valuesById[1] = "DISPLAY_ORIENTATION_LANDSCAPE"] = 1;
        values[valuesById[2] = "DISPLAY_ORIENTATION_PORTRAIT"] = 2;
        return values;
    })();

    globals.RecMode = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_REC_MODE"] = 0;
        values[valuesById[1] = "REC_MODE_RECOMMENDED"] = 1;
        values[valuesById[2] = "REC_MODE_POPULAR"] = 2;
        values[valuesById[3] = "REC_MODE_TOPICS"] = 3;
        values[valuesById[4] = "REC_MODE_COLLECTIONS"] = 4;
        values[valuesById[5] = "REC_MODE_FRIENDS"] = 5;
        values[valuesById[6] = "REC_MODE_TRENDING"] = 6;
        values[valuesById[7] = "REC_MODE_SAMPLING"] = 7;
        values[valuesById[8] = "REC_MODE_EDITOR_PICKS"] = 8;
        values[valuesById[9] = "REC_MODE_SEARCH"] = 9;
        values[valuesById[10] = "REC_MODE_SUBSCRIPTIONS"] = 10;
        return values;
    })();

    globals.Sort = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SORT"] = 0;
        values[valuesById[1] = "SORT_RECOMMENDED"] = 1;
        values[valuesById[2] = "SORT_ACCURATE"] = 2;
        values[valuesById[3] = "SORT_POPULAR"] = 3;
        values[valuesById[4] = "SORT_TRENDING"] = 4;
        values[valuesById[5] = "SORT_TIMEDESC"] = 5;
        values[valuesById[6] = "SORT_TIMEASC"] = 6;
        values[valuesById[7] = "SORT_FEED"] = 7;
        values[valuesById[8] = "SORT_RANDOM"] = 8;
        return values;
    })();

    globals.ScoreType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_SCORE_TYPE"] = 0;
        values[valuesById[1] = "SCORE_RATE_UP"] = 1;
        values[valuesById[2] = "SCORE_RATE_DOWN"] = 2;
        values[valuesById[3] = "SCORE_BOOKMARK"] = 3;
        values[valuesById[4] = "SCORE_CURATE"] = 4;
        values[valuesById[5] = "SCORE_DWELL"] = 5;
        values[valuesById[6] = "SCORE_PLAY"] = 6;
        values[valuesById[7] = "SCORE_SCROLL"] = 7;
        values[valuesById[8] = "SCORE_FLAG"] = 8;
        values[valuesById[9] = "SCORE_PIVOT"] = 9;
        values[valuesById[10] = "SCORE_CLICK"] = 10;
        return values;
    })();

    globals.RecResultType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_REC_RESULT_TYPE"] = 0;
        values[valuesById[1] = "URL_RESULT"] = 1;
        values[valuesById[2] = "USER_RESULT"] = 2;
        values[valuesById[3] = "MIX_RESULT"] = 3;
        values[valuesById[4] = "INTEREST_RESULT"] = 4;
        values[valuesById[5] = "CATEGORY_RESULT"] = 5;
        return values;
    })();

    globals.ProviderType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_PROVIDER_TYPE"] = 0;
        values[valuesById[1] = "REDDIT"] = 1;
        values[valuesById[2] = "YOUTUBE"] = 2;
        values[valuesById[3] = "IMGUR"] = 3;
        values[valuesById[4] = "VIMEO"] = 4;
        return values;
    })();

    globals.ProviderItemInfoType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_PROVIDER_ITEM_STAT_TYPE"] = 0;
        values[valuesById[1] = "UP_VOTES"] = 1;
        values[valuesById[2] = "DOWN_VOTES"] = 2;
        values[valuesById[3] = "SCORE"] = 3;
        values[valuesById[4] = "FEATURED"] = 4;
        values[valuesById[5] = "POPULARITY"] = 5;
        values[valuesById[6] = "VIEWS"] = 6;
        values[valuesById[7] = "GILDED"] = 7;
        values[valuesById[8] = "PLAYS"] = 8;
        values[valuesById[9] = "LIKES"] = 9;
        values[valuesById[10] = "DISLIKES"] = 10;
        return values;
    })();

    globals.RecReasonType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_REC_REASON_TYPE"] = 0;
        values[valuesById[1] = "TOPIC_FEEDS"] = 1;
        values[valuesById[2] = "CURATED_TOPICS"] = 2;
        values[valuesById[3] = "POPULAR_URLS"] = 3;
        values[valuesById[4] = "MIX_FEEDS_FOLLOWING"] = 4;
        values[valuesById[5] = "MIX_FEEDS_NOT_FOLLOWING"] = 5;
        values[valuesById[6] = "TAG_AFFINITY_GENERIC"] = 6;
        values[valuesById[7] = "FRIENDS_FEED"] = 7;
        values[valuesById[8] = "MIXED_MIX"] = 8;
        values[valuesById[9] = "TRENDING_URLS"] = 9;
        values[valuesById[10] = "COLLABORATIVE_FILTER"] = 10;
        values[valuesById[11] = "COLLABORATIVE_FILTER_IMPLICIT"] = 11;
        values[valuesById[12] = "COLLABORATIVE_FILTER_RATINGS"] = 12;
        return values;
    })();

    globals.CountryCodeType = (function() {
        const valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "UNKNOWN_COUNTRY"] = 0;
        values[valuesById[1] = "AF"] = 1;
        values[valuesById[2] = "AL"] = 2;
        values[valuesById[3] = "AQ"] = 3;
        values[valuesById[4] = "DZ"] = 4;
        values[valuesById[5] = "AS"] = 5;
        values[valuesById[6] = "AD"] = 6;
        values[valuesById[7] = "AO"] = 7;
        values[valuesById[8] = "AG"] = 8;
        values[valuesById[9] = "AZ"] = 9;
        values[valuesById[10] = "AR"] = 10;
        values[valuesById[11] = "AU"] = 11;
        values[valuesById[12] = "AT"] = 12;
        values[valuesById[13] = "BS"] = 13;
        values[valuesById[14] = "BH"] = 14;
        values[valuesById[15] = "BD"] = 15;
        values[valuesById[16] = "AM"] = 16;
        values[valuesById[17] = "BB"] = 17;
        values[valuesById[18] = "BE"] = 18;
        values[valuesById[19] = "BM"] = 19;
        values[valuesById[20] = "BT"] = 20;
        values[valuesById[21] = "BO"] = 21;
        values[valuesById[22] = "BA"] = 22;
        values[valuesById[23] = "BW"] = 23;
        values[valuesById[24] = "BV"] = 24;
        values[valuesById[25] = "BR"] = 25;
        values[valuesById[26] = "BZ"] = 26;
        values[valuesById[27] = "IO"] = 27;
        values[valuesById[28] = "SB"] = 28;
        values[valuesById[29] = "VG"] = 29;
        values[valuesById[30] = "BN"] = 30;
        values[valuesById[31] = "BG"] = 31;
        values[valuesById[32] = "MM"] = 32;
        values[valuesById[33] = "BI"] = 33;
        values[valuesById[34] = "BY"] = 34;
        values[valuesById[35] = "KH"] = 35;
        values[valuesById[36] = "CM"] = 36;
        values[valuesById[37] = "CA"] = 37;
        values[valuesById[38] = "CV"] = 38;
        values[valuesById[39] = "KY"] = 39;
        values[valuesById[40] = "CF"] = 40;
        values[valuesById[41] = "LK"] = 41;
        values[valuesById[42] = "TD"] = 42;
        values[valuesById[43] = "CL"] = 43;
        values[valuesById[44] = "CN"] = 44;
        values[valuesById[45] = "TW"] = 45;
        values[valuesById[46] = "CX"] = 46;
        values[valuesById[47] = "CC"] = 47;
        values[valuesById[48] = "CO"] = 48;
        values[valuesById[49] = "KM"] = 49;
        values[valuesById[50] = "YT"] = 50;
        values[valuesById[51] = "CG"] = 51;
        values[valuesById[52] = "CD"] = 52;
        values[valuesById[53] = "CK"] = 53;
        values[valuesById[54] = "CR"] = 54;
        values[valuesById[55] = "HR"] = 55;
        values[valuesById[56] = "CU"] = 56;
        values[valuesById[57] = "CY"] = 57;
        values[valuesById[58] = "CZ"] = 58;
        values[valuesById[59] = "BJ"] = 59;
        values[valuesById[60] = "DK"] = 60;
        values[valuesById[61] = "DM"] = 61;
        values[valuesById[62] = "DO"] = 62;
        values[valuesById[63] = "EC"] = 63;
        values[valuesById[64] = "SV"] = 64;
        values[valuesById[65] = "GQ"] = 65;
        values[valuesById[66] = "ET"] = 66;
        values[valuesById[67] = "ER"] = 67;
        values[valuesById[68] = "EE"] = 68;
        values[valuesById[69] = "FO"] = 69;
        values[valuesById[70] = "FK"] = 70;
        values[valuesById[71] = "GS"] = 71;
        values[valuesById[72] = "FJ"] = 72;
        values[valuesById[73] = "FI"] = 73;
        values[valuesById[74] = "AX"] = 74;
        values[valuesById[75] = "FR"] = 75;
        values[valuesById[76] = "GF"] = 76;
        values[valuesById[77] = "PF"] = 77;
        values[valuesById[78] = "TF"] = 78;
        values[valuesById[79] = "DJ"] = 79;
        values[valuesById[80] = "GA"] = 80;
        values[valuesById[81] = "GE"] = 81;
        values[valuesById[82] = "GM"] = 82;
        values[valuesById[83] = "PS"] = 83;
        values[valuesById[84] = "DE"] = 84;
        values[valuesById[85] = "GH"] = 85;
        values[valuesById[86] = "GI"] = 86;
        values[valuesById[87] = "KI"] = 87;
        values[valuesById[88] = "GR"] = 88;
        values[valuesById[89] = "GL"] = 89;
        values[valuesById[90] = "GD"] = 90;
        values[valuesById[91] = "GP"] = 91;
        values[valuesById[92] = "GU"] = 92;
        values[valuesById[93] = "GT"] = 93;
        values[valuesById[94] = "GN"] = 94;
        values[valuesById[95] = "GY"] = 95;
        values[valuesById[96] = "HT"] = 96;
        values[valuesById[97] = "HM"] = 97;
        values[valuesById[98] = "VA"] = 98;
        values[valuesById[99] = "HN"] = 99;
        values[valuesById[100] = "HK"] = 100;
        values[valuesById[101] = "HU"] = 101;
        values[valuesById[102] = "IS"] = 102;
        values[valuesById[103] = "IN"] = 103;
        values[valuesById[104] = "ID"] = 104;
        values[valuesById[105] = "IR"] = 105;
        values[valuesById[106] = "IQ"] = 106;
        values[valuesById[107] = "IE"] = 107;
        values[valuesById[108] = "IL"] = 108;
        values[valuesById[109] = "IT"] = 109;
        values[valuesById[110] = "CI"] = 110;
        values[valuesById[111] = "JM"] = 111;
        values[valuesById[112] = "JP"] = 112;
        values[valuesById[113] = "KZ"] = 113;
        values[valuesById[114] = "JO"] = 114;
        values[valuesById[115] = "KE"] = 115;
        values[valuesById[116] = "KP"] = 116;
        values[valuesById[117] = "KR"] = 117;
        values[valuesById[118] = "KW"] = 118;
        values[valuesById[119] = "KG"] = 119;
        values[valuesById[120] = "LA"] = 120;
        values[valuesById[121] = "LB"] = 121;
        values[valuesById[122] = "LS"] = 122;
        values[valuesById[123] = "LV"] = 123;
        values[valuesById[124] = "LR"] = 124;
        values[valuesById[125] = "LY"] = 125;
        values[valuesById[126] = "LI"] = 126;
        values[valuesById[127] = "LT"] = 127;
        values[valuesById[128] = "LU"] = 128;
        values[valuesById[129] = "MO"] = 129;
        values[valuesById[130] = "MG"] = 130;
        values[valuesById[131] = "MW"] = 131;
        values[valuesById[132] = "MY"] = 132;
        values[valuesById[133] = "MV"] = 133;
        values[valuesById[134] = "ML"] = 134;
        values[valuesById[135] = "MT"] = 135;
        values[valuesById[136] = "MQ"] = 136;
        values[valuesById[137] = "MR"] = 137;
        values[valuesById[138] = "MU"] = 138;
        values[valuesById[139] = "MX"] = 139;
        values[valuesById[140] = "MC"] = 140;
        values[valuesById[141] = "MN"] = 141;
        values[valuesById[142] = "MD"] = 142;
        values[valuesById[143] = "ME"] = 143;
        values[valuesById[144] = "MS"] = 144;
        values[valuesById[145] = "MA"] = 145;
        values[valuesById[146] = "MZ"] = 146;
        values[valuesById[147] = "OM"] = 147;
        values[valuesById[148] = "NA"] = 148;
        values[valuesById[149] = "NR"] = 149;
        values[valuesById[150] = "NP"] = 150;
        values[valuesById[151] = "NL"] = 151;
        values[valuesById[152] = "CW"] = 152;
        values[valuesById[153] = "AW"] = 153;
        values[valuesById[154] = "SX"] = 154;
        values[valuesById[155] = "BQ"] = 155;
        values[valuesById[156] = "NC"] = 156;
        values[valuesById[157] = "VU"] = 157;
        values[valuesById[158] = "NZ"] = 158;
        values[valuesById[159] = "NI"] = 159;
        values[valuesById[160] = "NE"] = 160;
        values[valuesById[161] = "NG"] = 161;
        values[valuesById[162] = "NU"] = 162;
        values[valuesById[163] = "NF"] = 163;
        values[valuesById[164] = "NO"] = 164;
        values[valuesById[165] = "MP"] = 165;
        values[valuesById[166] = "UM"] = 166;
        values[valuesById[167] = "FM"] = 167;
        values[valuesById[168] = "MH"] = 168;
        values[valuesById[169] = "PW"] = 169;
        values[valuesById[170] = "PK"] = 170;
        values[valuesById[171] = "PA"] = 171;
        values[valuesById[172] = "PG"] = 172;
        values[valuesById[173] = "PY"] = 173;
        values[valuesById[174] = "PE"] = 174;
        values[valuesById[175] = "PH"] = 175;
        values[valuesById[176] = "PN"] = 176;
        values[valuesById[177] = "PL"] = 177;
        values[valuesById[178] = "PT"] = 178;
        values[valuesById[179] = "GW"] = 179;
        values[valuesById[180] = "TL"] = 180;
        values[valuesById[181] = "PR"] = 181;
        values[valuesById[182] = "QA"] = 182;
        values[valuesById[183] = "RE"] = 183;
        values[valuesById[184] = "RO"] = 184;
        values[valuesById[185] = "RU"] = 185;
        values[valuesById[186] = "RW"] = 186;
        values[valuesById[187] = "BL"] = 187;
        values[valuesById[188] = "SH"] = 188;
        values[valuesById[189] = "KN"] = 189;
        values[valuesById[190] = "AI"] = 190;
        values[valuesById[191] = "LC"] = 191;
        values[valuesById[192] = "MF"] = 192;
        values[valuesById[193] = "PM"] = 193;
        values[valuesById[194] = "VC"] = 194;
        values[valuesById[195] = "SM"] = 195;
        values[valuesById[196] = "ST"] = 196;
        values[valuesById[197] = "SA"] = 197;
        values[valuesById[198] = "SN"] = 198;
        values[valuesById[199] = "RS"] = 199;
        values[valuesById[200] = "SC"] = 200;
        values[valuesById[201] = "SL"] = 201;
        values[valuesById[202] = "SG"] = 202;
        values[valuesById[203] = "SK"] = 203;
        values[valuesById[204] = "VN"] = 204;
        values[valuesById[205] = "SI"] = 205;
        values[valuesById[206] = "SO"] = 206;
        values[valuesById[207] = "ZA"] = 207;
        values[valuesById[208] = "ZW"] = 208;
        values[valuesById[209] = "ES"] = 209;
        values[valuesById[210] = "SS"] = 210;
        values[valuesById[211] = "SD"] = 211;
        values[valuesById[212] = "EH"] = 212;
        values[valuesById[213] = "SR"] = 213;
        values[valuesById[214] = "SJ"] = 214;
        values[valuesById[215] = "SZ"] = 215;
        values[valuesById[216] = "SE"] = 216;
        values[valuesById[217] = "CH"] = 217;
        values[valuesById[218] = "SY"] = 218;
        values[valuesById[219] = "TJ"] = 219;
        values[valuesById[220] = "TH"] = 220;
        values[valuesById[221] = "TG"] = 221;
        values[valuesById[222] = "TK"] = 222;
        values[valuesById[223] = "TO"] = 223;
        values[valuesById[224] = "TT"] = 224;
        values[valuesById[225] = "AE"] = 225;
        values[valuesById[226] = "TN"] = 226;
        values[valuesById[227] = "TR"] = 227;
        values[valuesById[228] = "TM"] = 228;
        values[valuesById[229] = "TC"] = 229;
        values[valuesById[230] = "TV"] = 230;
        values[valuesById[231] = "UG"] = 231;
        values[valuesById[232] = "UA"] = 232;
        values[valuesById[233] = "MK"] = 233;
        values[valuesById[234] = "EG"] = 234;
        values[valuesById[235] = "GB"] = 235;
        values[valuesById[236] = "GG"] = 236;
        values[valuesById[237] = "JE"] = 237;
        values[valuesById[238] = "IM"] = 238;
        values[valuesById[239] = "TZ"] = 239;
        values[valuesById[240] = "US"] = 240;
        values[valuesById[241] = "VI"] = 241;
        values[valuesById[242] = "BF"] = 242;
        values[valuesById[243] = "UY"] = 243;
        values[valuesById[244] = "UZ"] = 244;
        values[valuesById[245] = "VE"] = 245;
        values[valuesById[246] = "WF"] = 246;
        values[valuesById[247] = "WS"] = 247;
        values[valuesById[248] = "YE"] = 248;
        values[valuesById[249] = "ZM"] = 249;
        values[valuesById[250] = "A1"] = 250;
        values[valuesById[251] = "A2"] = 251;
        values[valuesById[252] = "O1"] = 252;
        values[valuesById[253] = "AP"] = 253;
        values[valuesById[254] = "EU"] = 254;
        values[valuesById[255] = "PRIVATE"] = 255;
        return values;
    })();

    globals.RecItem = (function() {

        function RecItem(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RecItem.prototype.type = 0;
        RecItem.prototype.id = null;
        RecItem.prototype.name = null;

        let $oneOfFields;

        Object.defineProperty(RecItem.prototype, "item", {
            get: $util.oneOfGetter($oneOfFields = ["id", "name"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        RecItem.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(8).int32(m.type);
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                $root.google.protobuf.UInt64Value.encode(m.id, w.uint32(18).fork()).ldelim();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                $root.google.protobuf.StringValue.encode(m.name, w.uint32(26).fork()).ldelim();
            return w;
        };

        RecItem.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RecItem.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.RecItem();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.int32();
                    break;
                case 2:
                    m.id = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 3:
                    m.name = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RecItem.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RecItem.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            var p = {};
            if (m.type != null && m.hasOwnProperty("type")) {
                switch (m.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            }
            if (m.id != null && m.hasOwnProperty("id")) {
                p.item = 1;
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.id);
                    if (e)
                        return "id." + e;
                }
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                if (p.item === 1)
                    return "item: multiple values";
                p.item = 1;
                {
                    var e = $root.google.protobuf.StringValue.verify(m.name);
                    if (e)
                        return "name." + e;
                }
            }
            return null;
        };

        RecItem.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.RecItem)
                return d;
            var m = new $root.globals.RecItem();
            switch (d.type) {
            case "UNKNOWN_ENTITY_TYPE":
            case 0:
                m.type = 0;
                break;
            case "TYPE_URL":
            case 1:
                m.type = 1;
                break;
            case "TYPE_COLLECTION":
            case 2:
                m.type = 2;
                break;
            case "TYPE_USER":
            case 3:
                m.type = 3;
                break;
            case "TYPE_INTEREST":
            case 4:
                m.type = 4;
                break;
            case "TYPE_DOMAIN":
            case 5:
                m.type = 5;
                break;
            case "TYPE_KEYWORD":
            case 6:
                m.type = 6;
                break;
            }
            if (d.id != null) {
                if (typeof d.id === "object" && d.id !== null && d.id.value !== undefined)
                    throw TypeError(".globals.RecItem.id: wrapped value not expected");
                m.id = $root.google.protobuf.UInt64Value.fromObject({ value: d.id });
            }
            if (d.name != null) {
                if (typeof d.name === "object" && d.name !== null && d.name.value !== undefined)
                    throw TypeError(".globals.RecItem.name: wrapped value not expected");
                m.name = $root.google.protobuf.StringValue.fromObject({ value: d.name });
            }
            return m;
        };

        RecItem.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.type = o.enums === String ? "UNKNOWN_ENTITY_TYPE" : 0;
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = o.enums === String ? $root.globals.EntityType[m.type] : m.type;
            }
            if (m.id != null && m.hasOwnProperty("id")) {
                d.id = $root.google.protobuf.UInt64Value.toObject(m.id, o).value;
                if (o.oneofs)
                    d.item = "id";
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                d.name = $root.google.protobuf.StringValue.toObject(m.name, o).value;
                if (o.oneofs)
                    d.item = "name";
            }
            return d;
        };

        RecItem.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RecItem;
    })();

    globals.RecFilters = (function() {

        function RecFilters(p) {
            this.media = [];
            this.types = [];
            this.keywords = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RecFilters.prototype.media = $util.emptyArray;
        RecFilters.prototype.types = $util.emptyArray;
        RecFilters.prototype.keywords = $util.emptyArray;
        RecFilters.prototype.gridDiscount = null;
        RecFilters.prototype.allowSeen = null;
        RecFilters.prototype.newerThan = null;
        RecFilters.prototype.olderThan = null;

        RecFilters.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.media != null && m.media.length) {
                w.uint32(10).fork();
                for (var i = 0; i < m.media.length; ++i)
                    w.int32(m.media[i]);
                w.ldelim();
            }
            if (m.types != null && m.types.length) {
                w.uint32(18).fork();
                for (var i = 0; i < m.types.length; ++i)
                    w.int32(m.types[i]);
                w.ldelim();
            }
            if (m.keywords != null && m.keywords.length) {
                for (var i = 0; i < m.keywords.length; ++i)
                    $root.google.protobuf.StringValue.encode(m.keywords[i], w.uint32(26).fork()).ldelim();
            }
            if (m.gridDiscount != null && Object.hasOwnProperty.call(m, "gridDiscount"))
                $root.google.protobuf.UInt64Value.encode(m.gridDiscount, w.uint32(34).fork()).ldelim();
            if (m.allowSeen != null && Object.hasOwnProperty.call(m, "allowSeen"))
                $root.google.protobuf.BoolValue.encode(m.allowSeen, w.uint32(42).fork()).ldelim();
            if (m.newerThan != null && Object.hasOwnProperty.call(m, "newerThan"))
                $root.google.protobuf.StringValue.encode(m.newerThan, w.uint32(50).fork()).ldelim();
            if (m.olderThan != null && Object.hasOwnProperty.call(m, "olderThan"))
                $root.google.protobuf.StringValue.encode(m.olderThan, w.uint32(58).fork()).ldelim();
            return w;
        };

        RecFilters.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RecFilters.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.RecFilters();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    if (!(m.media && m.media.length))
                        m.media = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.media.push(r.int32());
                    } else
                        m.media.push(r.int32());
                    break;
                case 2:
                    if (!(m.types && m.types.length))
                        m.types = [];
                    if ((t & 7) === 2) {
                        var c2 = r.uint32() + r.pos;
                        while (r.pos < c2)
                            m.types.push(r.int32());
                    } else
                        m.types.push(r.int32());
                    break;
                case 3:
                    if (!(m.keywords && m.keywords.length))
                        m.keywords = [];
                    m.keywords.push($root.google.protobuf.StringValue.decode(r, r.uint32()));
                    break;
                case 4:
                    m.gridDiscount = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 5:
                    m.allowSeen = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                case 6:
                    m.newerThan = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 7:
                    m.olderThan = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RecFilters.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RecFilters.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.media != null && m.hasOwnProperty("media")) {
                if (!Array.isArray(m.media))
                    return "media: array expected";
                for (var i = 0; i < m.media.length; ++i) {
                    switch (m.media[i]) {
                    default:
                        return "media: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                        break;
                    }
                }
            }
            if (m.types != null && m.hasOwnProperty("types")) {
                if (!Array.isArray(m.types))
                    return "types: array expected";
                for (var i = 0; i < m.types.length; ++i) {
                    switch (m.types[i]) {
                    default:
                        return "types: enum value[] expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                        break;
                    }
                }
            }
            if (m.keywords != null && m.hasOwnProperty("keywords")) {
                if (!Array.isArray(m.keywords))
                    return "keywords: array expected";
                for (var i = 0; i < m.keywords.length; ++i) {
                    {
                        var e = $root.google.protobuf.StringValue.verify(m.keywords[i]);
                        if (e)
                            return "keywords." + e;
                    }
                }
            }
            if (m.gridDiscount != null && m.hasOwnProperty("gridDiscount")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.gridDiscount);
                    if (e)
                        return "gridDiscount." + e;
                }
            }
            if (m.allowSeen != null && m.hasOwnProperty("allowSeen")) {
                {
                    var e = $root.google.protobuf.BoolValue.verify(m.allowSeen);
                    if (e)
                        return "allowSeen." + e;
                }
            }
            if (m.newerThan != null && m.hasOwnProperty("newerThan")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.newerThan);
                    if (e)
                        return "newerThan." + e;
                }
            }
            if (m.olderThan != null && m.hasOwnProperty("olderThan")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.olderThan);
                    if (e)
                        return "olderThan." + e;
                }
            }
            return null;
        };

        RecFilters.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.RecFilters)
                return d;
            var m = new $root.globals.RecFilters();
            if (d.media) {
                if (!Array.isArray(d.media))
                    throw TypeError(".globals.RecFilters.media: array expected");
                m.media = [];
                for (var i = 0; i < d.media.length; ++i) {
                    switch (d.media[i]) {
                    default:
                    case "UNKNOWN_MEDIA_TYPE":
                    case 0:
                        m.media[i] = 0;
                        break;
                    case "WEBSITE":
                    case 1:
                        m.media[i] = 1;
                        break;
                    case "ARTICLE":
                    case 2:
                        m.media[i] = 2;
                        break;
                    case "IMAGE":
                    case 3:
                        m.media[i] = 3;
                        break;
                    case "VIDEO":
                    case 4:
                        m.media[i] = 4;
                        break;
                    case "AUDIO":
                    case 5:
                        m.media[i] = 5;
                        break;
                    case "PDF":
                    case 6:
                        m.media[i] = 6;
                        break;
                    case "NEWS":
                    case 7:
                        m.media[i] = 7;
                        break;
                    case "GAME":
                    case 8:
                        m.media[i] = 8;
                        break;
                    case "GIF":
                    case 9:
                        m.media[i] = 9;
                        break;
                    case "APP":
                    case 10:
                        m.media[i] = 10;
                        break;
                    }
                }
            }
            if (d.types) {
                if (!Array.isArray(d.types))
                    throw TypeError(".globals.RecFilters.types: array expected");
                m.types = [];
                for (var i = 0; i < d.types.length; ++i) {
                    switch (d.types[i]) {
                    default:
                    case "UNKNOWN_ENTITY_TYPE":
                    case 0:
                        m.types[i] = 0;
                        break;
                    case "TYPE_URL":
                    case 1:
                        m.types[i] = 1;
                        break;
                    case "TYPE_COLLECTION":
                    case 2:
                        m.types[i] = 2;
                        break;
                    case "TYPE_USER":
                    case 3:
                        m.types[i] = 3;
                        break;
                    case "TYPE_INTEREST":
                    case 4:
                        m.types[i] = 4;
                        break;
                    case "TYPE_DOMAIN":
                    case 5:
                        m.types[i] = 5;
                        break;
                    case "TYPE_KEYWORD":
                    case 6:
                        m.types[i] = 6;
                        break;
                    }
                }
            }
            if (d.keywords) {
                if (!Array.isArray(d.keywords))
                    throw TypeError(".globals.RecFilters.keywords: array expected");
                m.keywords = [];
                for (var i = 0; i < d.keywords.length; ++i) {
                    if (typeof d.keywords[i] === "object" && d.keywords[i] !== null && d.keywords[i].value !== undefined)
                        throw TypeError(".globals.RecFilters.keywords: wrapped value not expected");
                    m.keywords[i] = $root.google.protobuf.StringValue.fromObject({ value: d.keywords[i] });
                }
            }
            if (d.gridDiscount != null) {
                if (typeof d.gridDiscount === "object" && d.gridDiscount !== null && d.gridDiscount.value !== undefined)
                    throw TypeError(".globals.RecFilters.gridDiscount: wrapped value not expected");
                m.gridDiscount = $root.google.protobuf.UInt64Value.fromObject({ value: d.gridDiscount });
            }
            if (d.allowSeen != null) {
                if (typeof d.allowSeen === "object" && d.allowSeen !== null && d.allowSeen.value !== undefined)
                    throw TypeError(".globals.RecFilters.allowSeen: wrapped value not expected");
                m.allowSeen = $root.google.protobuf.BoolValue.fromObject({ value: d.allowSeen });
            }
            if (d.newerThan != null) {
                if (typeof d.newerThan === "object" && d.newerThan !== null && d.newerThan.value !== undefined)
                    throw TypeError(".globals.RecFilters.newerThan: wrapped value not expected");
                m.newerThan = $root.google.protobuf.StringValue.fromObject({ value: d.newerThan });
            }
            if (d.olderThan != null) {
                if (typeof d.olderThan === "object" && d.olderThan !== null && d.olderThan.value !== undefined)
                    throw TypeError(".globals.RecFilters.olderThan: wrapped value not expected");
                m.olderThan = $root.google.protobuf.StringValue.fromObject({ value: d.olderThan });
            }
            return m;
        };

        RecFilters.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.media = [];
                d.types = [];
                d.keywords = [];
            }
            if (o.defaults) {
                d.gridDiscount = null;
                d.allowSeen = null;
                d.newerThan = null;
                d.olderThan = null;
            }
            if (m.media && m.media.length) {
                d.media = [];
                for (var j = 0; j < m.media.length; ++j) {
                    d.media[j] = o.enums === String ? $root.globals.MediaType[m.media[j]] : m.media[j];
                }
            }
            if (m.types && m.types.length) {
                d.types = [];
                for (var j = 0; j < m.types.length; ++j) {
                    d.types[j] = o.enums === String ? $root.globals.EntityType[m.types[j]] : m.types[j];
                }
            }
            if (m.keywords && m.keywords.length) {
                d.keywords = [];
                for (var j = 0; j < m.keywords.length; ++j) {
                    d.keywords[j] = $root.google.protobuf.StringValue.toObject(m.keywords[j], o).value;
                }
            }
            if (m.gridDiscount != null && m.hasOwnProperty("gridDiscount")) {
                d.gridDiscount = $root.google.protobuf.UInt64Value.toObject(m.gridDiscount, o).value;
            }
            if (m.allowSeen != null && m.hasOwnProperty("allowSeen")) {
                d.allowSeen = $root.google.protobuf.BoolValue.toObject(m.allowSeen, o).value;
            }
            if (m.newerThan != null && m.hasOwnProperty("newerThan")) {
                d.newerThan = $root.google.protobuf.StringValue.toObject(m.newerThan, o).value;
            }
            if (m.olderThan != null && m.hasOwnProperty("olderThan")) {
                d.olderThan = $root.google.protobuf.StringValue.toObject(m.olderThan, o).value;
            }
            return d;
        };

        RecFilters.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RecFilters;
    })();

    globals.DisplayInfo = (function() {

        function DisplayInfo(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        DisplayInfo.prototype.orientation = 0;
        DisplayInfo.prototype.width = null;
        DisplayInfo.prototype.height = null;
        DisplayInfo.prototype.dpi = null;
        DisplayInfo.prototype.foldItems = null;
        DisplayInfo.prototype.thumbWidth = null;
        DisplayInfo.prototype.thumbHeight = null;

        DisplayInfo.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.orientation != null && Object.hasOwnProperty.call(m, "orientation"))
                w.uint32(8).int32(m.orientation);
            if (m.width != null && Object.hasOwnProperty.call(m, "width"))
                $root.google.protobuf.UInt64Value.encode(m.width, w.uint32(18).fork()).ldelim();
            if (m.height != null && Object.hasOwnProperty.call(m, "height"))
                $root.google.protobuf.UInt64Value.encode(m.height, w.uint32(26).fork()).ldelim();
            if (m.dpi != null && Object.hasOwnProperty.call(m, "dpi"))
                $root.google.protobuf.DoubleValue.encode(m.dpi, w.uint32(34).fork()).ldelim();
            if (m.foldItems != null && Object.hasOwnProperty.call(m, "foldItems"))
                $root.google.protobuf.UInt64Value.encode(m.foldItems, w.uint32(42).fork()).ldelim();
            if (m.thumbWidth != null && Object.hasOwnProperty.call(m, "thumbWidth"))
                $root.google.protobuf.UInt64Value.encode(m.thumbWidth, w.uint32(50).fork()).ldelim();
            if (m.thumbHeight != null && Object.hasOwnProperty.call(m, "thumbHeight"))
                $root.google.protobuf.UInt64Value.encode(m.thumbHeight, w.uint32(58).fork()).ldelim();
            return w;
        };

        DisplayInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        DisplayInfo.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.DisplayInfo();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.orientation = r.int32();
                    break;
                case 2:
                    m.width = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 3:
                    m.height = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 4:
                    m.dpi = $root.google.protobuf.DoubleValue.decode(r, r.uint32());
                    break;
                case 5:
                    m.foldItems = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 6:
                    m.thumbWidth = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 7:
                    m.thumbHeight = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        DisplayInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        DisplayInfo.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.orientation != null && m.hasOwnProperty("orientation")) {
                switch (m.orientation) {
                default:
                    return "orientation: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            }
            if (m.width != null && m.hasOwnProperty("width")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.width);
                    if (e)
                        return "width." + e;
                }
            }
            if (m.height != null && m.hasOwnProperty("height")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.height);
                    if (e)
                        return "height." + e;
                }
            }
            if (m.dpi != null && m.hasOwnProperty("dpi")) {
                {
                    var e = $root.google.protobuf.DoubleValue.verify(m.dpi);
                    if (e)
                        return "dpi." + e;
                }
            }
            if (m.foldItems != null && m.hasOwnProperty("foldItems")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.foldItems);
                    if (e)
                        return "foldItems." + e;
                }
            }
            if (m.thumbWidth != null && m.hasOwnProperty("thumbWidth")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.thumbWidth);
                    if (e)
                        return "thumbWidth." + e;
                }
            }
            if (m.thumbHeight != null && m.hasOwnProperty("thumbHeight")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.thumbHeight);
                    if (e)
                        return "thumbHeight." + e;
                }
            }
            return null;
        };

        DisplayInfo.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.DisplayInfo)
                return d;
            var m = new $root.globals.DisplayInfo();
            switch (d.orientation) {
            case "UNKNOWN_DISPLAY_ORIENTATION":
            case 0:
                m.orientation = 0;
                break;
            case "DISPLAY_ORIENTATION_LANDSCAPE":
            case 1:
                m.orientation = 1;
                break;
            case "DISPLAY_ORIENTATION_PORTRAIT":
            case 2:
                m.orientation = 2;
                break;
            }
            if (d.width != null) {
                if (typeof d.width === "object" && d.width !== null && d.width.value !== undefined)
                    throw TypeError(".globals.DisplayInfo.width: wrapped value not expected");
                m.width = $root.google.protobuf.UInt64Value.fromObject({ value: d.width });
            }
            if (d.height != null) {
                if (typeof d.height === "object" && d.height !== null && d.height.value !== undefined)
                    throw TypeError(".globals.DisplayInfo.height: wrapped value not expected");
                m.height = $root.google.protobuf.UInt64Value.fromObject({ value: d.height });
            }
            if (d.dpi != null) {
                if (typeof d.dpi === "object" && d.dpi !== null && d.dpi.value !== undefined)
                    throw TypeError(".globals.DisplayInfo.dpi: wrapped value not expected");
                m.dpi = $root.google.protobuf.DoubleValue.fromObject({ value: d.dpi });
            }
            if (d.foldItems != null) {
                if (typeof d.foldItems === "object" && d.foldItems !== null && d.foldItems.value !== undefined)
                    throw TypeError(".globals.DisplayInfo.foldItems: wrapped value not expected");
                m.foldItems = $root.google.protobuf.UInt64Value.fromObject({ value: d.foldItems });
            }
            if (d.thumbWidth != null) {
                if (typeof d.thumbWidth === "object" && d.thumbWidth !== null && d.thumbWidth.value !== undefined)
                    throw TypeError(".globals.DisplayInfo.thumbWidth: wrapped value not expected");
                m.thumbWidth = $root.google.protobuf.UInt64Value.fromObject({ value: d.thumbWidth });
            }
            if (d.thumbHeight != null) {
                if (typeof d.thumbHeight === "object" && d.thumbHeight !== null && d.thumbHeight.value !== undefined)
                    throw TypeError(".globals.DisplayInfo.thumbHeight: wrapped value not expected");
                m.thumbHeight = $root.google.protobuf.UInt64Value.fromObject({ value: d.thumbHeight });
            }
            return m;
        };

        DisplayInfo.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.orientation = o.enums === String ? "UNKNOWN_DISPLAY_ORIENTATION" : 0;
                d.width = null;
                d.height = null;
                d.dpi = null;
                d.foldItems = null;
                d.thumbWidth = null;
                d.thumbHeight = null;
            }
            if (m.orientation != null && m.hasOwnProperty("orientation")) {
                d.orientation = o.enums === String ? $root.globals.DisplayOrientation[m.orientation] : m.orientation;
            }
            if (m.width != null && m.hasOwnProperty("width")) {
                d.width = $root.google.protobuf.UInt64Value.toObject(m.width, o).value;
            }
            if (m.height != null && m.hasOwnProperty("height")) {
                d.height = $root.google.protobuf.UInt64Value.toObject(m.height, o).value;
            }
            if (m.dpi != null && m.hasOwnProperty("dpi")) {
                d.dpi = $root.google.protobuf.DoubleValue.toObject(m.dpi, o).value;
            }
            if (m.foldItems != null && m.hasOwnProperty("foldItems")) {
                d.foldItems = $root.google.protobuf.UInt64Value.toObject(m.foldItems, o).value;
            }
            if (m.thumbWidth != null && m.hasOwnProperty("thumbWidth")) {
                d.thumbWidth = $root.google.protobuf.UInt64Value.toObject(m.thumbWidth, o).value;
            }
            if (m.thumbHeight != null && m.hasOwnProperty("thumbHeight")) {
                d.thumbHeight = $root.google.protobuf.UInt64Value.toObject(m.thumbHeight, o).value;
            }
            return d;
        };

        DisplayInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DisplayInfo;
    })();

    globals.RecScore = (function() {

        function RecScore(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        RecScore.prototype.item = null;
        RecScore.prototype.type = 0;
        RecScore.prototype.seconds = null;
        RecScore.prototype.percent = null;
        RecScore.prototype.offset = null;
        RecScore.prototype.count = null;

        let $oneOfFields;

        Object.defineProperty(RecScore.prototype, "score", {
            get: $util.oneOfGetter($oneOfFields = ["seconds", "percent", "offset", "count"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        RecScore.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.item != null && Object.hasOwnProperty.call(m, "item"))
                $root.globals.RecItem.encode(m.item, w.uint32(10).fork()).ldelim();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(16).int32(m.type);
            if (m.seconds != null && Object.hasOwnProperty.call(m, "seconds"))
                $root.google.protobuf.DoubleValue.encode(m.seconds, w.uint32(26).fork()).ldelim();
            if (m.percent != null && Object.hasOwnProperty.call(m, "percent"))
                $root.google.protobuf.DoubleValue.encode(m.percent, w.uint32(34).fork()).ldelim();
            if (m.offset != null && Object.hasOwnProperty.call(m, "offset"))
                $root.google.protobuf.UInt32Value.encode(m.offset, w.uint32(42).fork()).ldelim();
            if (m.count != null && Object.hasOwnProperty.call(m, "count"))
                $root.google.protobuf.UInt32Value.encode(m.count, w.uint32(50).fork()).ldelim();
            return w;
        };

        RecScore.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        RecScore.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.RecScore();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.item = $root.globals.RecItem.decode(r, r.uint32());
                    break;
                case 2:
                    m.type = r.int32();
                    break;
                case 3:
                    m.seconds = $root.google.protobuf.DoubleValue.decode(r, r.uint32());
                    break;
                case 4:
                    m.percent = $root.google.protobuf.DoubleValue.decode(r, r.uint32());
                    break;
                case 5:
                    m.offset = $root.google.protobuf.UInt32Value.decode(r, r.uint32());
                    break;
                case 6:
                    m.count = $root.google.protobuf.UInt32Value.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        RecScore.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        RecScore.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            var p = {};
            if (m.item != null && m.hasOwnProperty("item")) {
                {
                    var e = $root.globals.RecItem.verify(m.item);
                    if (e)
                        return "item." + e;
                }
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                switch (m.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                    break;
                }
            }
            if (m.seconds != null && m.hasOwnProperty("seconds")) {
                p.score = 1;
                {
                    var e = $root.google.protobuf.DoubleValue.verify(m.seconds);
                    if (e)
                        return "seconds." + e;
                }
            }
            if (m.percent != null && m.hasOwnProperty("percent")) {
                if (p.score === 1)
                    return "score: multiple values";
                p.score = 1;
                {
                    var e = $root.google.protobuf.DoubleValue.verify(m.percent);
                    if (e)
                        return "percent." + e;
                }
            }
            if (m.offset != null && m.hasOwnProperty("offset")) {
                if (p.score === 1)
                    return "score: multiple values";
                p.score = 1;
                {
                    var e = $root.google.protobuf.UInt32Value.verify(m.offset);
                    if (e)
                        return "offset." + e;
                }
            }
            if (m.count != null && m.hasOwnProperty("count")) {
                if (p.score === 1)
                    return "score: multiple values";
                p.score = 1;
                {
                    var e = $root.google.protobuf.UInt32Value.verify(m.count);
                    if (e)
                        return "count." + e;
                }
            }
            return null;
        };

        RecScore.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.RecScore)
                return d;
            var m = new $root.globals.RecScore();
            if (d.item != null) {
                if (typeof d.item !== "object")
                    throw TypeError(".globals.RecScore.item: object expected");
                m.item = $root.globals.RecItem.fromObject(d.item);
            }
            switch (d.type) {
            case "UNKNOWN_SCORE_TYPE":
            case 0:
                m.type = 0;
                break;
            case "SCORE_RATE_UP":
            case 1:
                m.type = 1;
                break;
            case "SCORE_RATE_DOWN":
            case 2:
                m.type = 2;
                break;
            case "SCORE_BOOKMARK":
            case 3:
                m.type = 3;
                break;
            case "SCORE_CURATE":
            case 4:
                m.type = 4;
                break;
            case "SCORE_DWELL":
            case 5:
                m.type = 5;
                break;
            case "SCORE_PLAY":
            case 6:
                m.type = 6;
                break;
            case "SCORE_SCROLL":
            case 7:
                m.type = 7;
                break;
            case "SCORE_FLAG":
            case 8:
                m.type = 8;
                break;
            case "SCORE_PIVOT":
            case 9:
                m.type = 9;
                break;
            case "SCORE_CLICK":
            case 10:
                m.type = 10;
                break;
            }
            if (d.seconds != null) {
                if (typeof d.seconds === "object" && d.seconds !== null && d.seconds.value !== undefined)
                    throw TypeError(".globals.RecScore.seconds: wrapped value not expected");
                m.seconds = $root.google.protobuf.DoubleValue.fromObject({ value: d.seconds });
            }
            if (d.percent != null) {
                if (typeof d.percent === "object" && d.percent !== null && d.percent.value !== undefined)
                    throw TypeError(".globals.RecScore.percent: wrapped value not expected");
                m.percent = $root.google.protobuf.DoubleValue.fromObject({ value: d.percent });
            }
            if (d.offset != null) {
                if (typeof d.offset === "object" && d.offset !== null && d.offset.value !== undefined)
                    throw TypeError(".globals.RecScore.offset: wrapped value not expected");
                m.offset = $root.google.protobuf.UInt32Value.fromObject({ value: d.offset });
            }
            if (d.count != null) {
                if (typeof d.count === "object" && d.count !== null && d.count.value !== undefined)
                    throw TypeError(".globals.RecScore.count: wrapped value not expected");
                m.count = $root.google.protobuf.UInt32Value.fromObject({ value: d.count });
            }
            return m;
        };

        RecScore.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.item = null;
                d.type = o.enums === String ? "UNKNOWN_SCORE_TYPE" : 0;
            }
            if (m.item != null && m.hasOwnProperty("item")) {
                d.item = $root.globals.RecItem.toObject(m.item, o);
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = o.enums === String ? $root.globals.ScoreType[m.type] : m.type;
            }
            if (m.seconds != null && m.hasOwnProperty("seconds")) {
                d.seconds = $root.google.protobuf.DoubleValue.toObject(m.seconds, o).value;
                if (o.oneofs)
                    d.score = "seconds";
            }
            if (m.percent != null && m.hasOwnProperty("percent")) {
                d.percent = $root.google.protobuf.DoubleValue.toObject(m.percent, o).value;
                if (o.oneofs)
                    d.score = "percent";
            }
            if (m.offset != null && m.hasOwnProperty("offset")) {
                d.offset = $root.google.protobuf.UInt32Value.toObject(m.offset, o).value;
                if (o.oneofs)
                    d.score = "offset";
            }
            if (m.count != null && m.hasOwnProperty("count")) {
                d.count = $root.google.protobuf.UInt32Value.toObject(m.count, o).value;
                if (o.oneofs)
                    d.score = "count";
            }
            return d;
        };

        RecScore.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RecScore;
    })();

    globals.PageContext = (function() {

        function PageContext(p) {
            this.attributes = {};
            this.testGroups = [];
            this.experiments = [];
            this.rollouts = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        PageContext.prototype.page = 0;
        PageContext.prototype.attributes = $util.emptyObject;
        PageContext.prototype.streamType = 0;
        PageContext.prototype.userId = null;
        PageContext.prototype.mixId = null;
        PageContext.prototype.categoryId = null;
        PageContext.prototype.categoryTopicId = null;
        PageContext.prototype.topicId = null;
        PageContext.prototype.shareId = null;
        PageContext.prototype.testGroups = $util.emptyArray;
        PageContext.prototype.pageSection = null;
        PageContext.prototype.categorySlugKey = null;
        PageContext.prototype.topicKey = null;
        PageContext.prototype.recId = null;
        PageContext.prototype.recBatchId = null;
        PageContext.prototype.searchQuery = null;
        PageContext.prototype.searchResultRank = null;
        PageContext.prototype.externalReferrer = null;
        PageContext.prototype.experiments = $util.emptyArray;
        PageContext.prototype.rollouts = $util.emptyArray;

        PageContext.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.page != null && Object.hasOwnProperty.call(m, "page"))
                w.uint32(32).int32(m.page);
            if (m.attributes != null && Object.hasOwnProperty.call(m, "attributes")) {
                for (var ks = Object.keys(m.attributes), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.attributes[ks[i]]).ldelim();
                }
            }
            if (m.streamType != null && Object.hasOwnProperty.call(m, "streamType"))
                w.uint32(48).int32(m.streamType);
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                $root.google.protobuf.UInt64Value.encode(m.userId, w.uint32(58).fork()).ldelim();
            if (m.mixId != null && Object.hasOwnProperty.call(m, "mixId"))
                $root.google.protobuf.UInt64Value.encode(m.mixId, w.uint32(66).fork()).ldelim();
            if (m.categoryId != null && Object.hasOwnProperty.call(m, "categoryId"))
                $root.google.protobuf.UInt64Value.encode(m.categoryId, w.uint32(74).fork()).ldelim();
            if (m.categoryTopicId != null && Object.hasOwnProperty.call(m, "categoryTopicId"))
                $root.google.protobuf.UInt64Value.encode(m.categoryTopicId, w.uint32(82).fork()).ldelim();
            if (m.topicId != null && Object.hasOwnProperty.call(m, "topicId"))
                $root.google.protobuf.UInt64Value.encode(m.topicId, w.uint32(90).fork()).ldelim();
            if (m.shareId != null && Object.hasOwnProperty.call(m, "shareId"))
                $root.google.protobuf.UInt64Value.encode(m.shareId, w.uint32(98).fork()).ldelim();
            if (m.testGroups != null && m.testGroups.length) {
                for (var i = 0; i < m.testGroups.length; ++i)
                    w.uint32(106).string(m.testGroups[i]);
            }
            if (m.pageSection != null && Object.hasOwnProperty.call(m, "pageSection"))
                $root.google.protobuf.StringValue.encode(m.pageSection, w.uint32(114).fork()).ldelim();
            if (m.categorySlugKey != null && Object.hasOwnProperty.call(m, "categorySlugKey"))
                $root.google.protobuf.StringValue.encode(m.categorySlugKey, w.uint32(122).fork()).ldelim();
            if (m.topicKey != null && Object.hasOwnProperty.call(m, "topicKey"))
                $root.google.protobuf.StringValue.encode(m.topicKey, w.uint32(130).fork()).ldelim();
            if (m.recId != null && Object.hasOwnProperty.call(m, "recId"))
                $root.google.protobuf.StringValue.encode(m.recId, w.uint32(138).fork()).ldelim();
            if (m.recBatchId != null && Object.hasOwnProperty.call(m, "recBatchId"))
                $root.google.protobuf.StringValue.encode(m.recBatchId, w.uint32(146).fork()).ldelim();
            if (m.searchQuery != null && Object.hasOwnProperty.call(m, "searchQuery"))
                $root.google.protobuf.StringValue.encode(m.searchQuery, w.uint32(154).fork()).ldelim();
            if (m.searchResultRank != null && Object.hasOwnProperty.call(m, "searchResultRank"))
                $root.google.protobuf.UInt64Value.encode(m.searchResultRank, w.uint32(162).fork()).ldelim();
            if (m.externalReferrer != null && Object.hasOwnProperty.call(m, "externalReferrer"))
                $root.google.protobuf.StringValue.encode(m.externalReferrer, w.uint32(170).fork()).ldelim();
            if (m.experiments != null && m.experiments.length) {
                for (var i = 0; i < m.experiments.length; ++i)
                    $root.globals.Experiment.encode(m.experiments[i], w.uint32(178).fork()).ldelim();
            }
            if (m.rollouts != null && m.rollouts.length) {
                for (var i = 0; i < m.rollouts.length; ++i)
                    w.uint32(186).string(m.rollouts[i]);
            }
            return w;
        };

        PageContext.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        PageContext.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.PageContext(), k;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 4:
                    m.page = r.int32();
                    break;
                case 5:
                    r.skip().pos++;
                    if (m.attributes === $util.emptyObject)
                        m.attributes = {};
                    k = r.string();
                    r.pos++;
                    m.attributes[k] = r.string();
                    break;
                case 6:
                    m.streamType = r.int32();
                    break;
                case 7:
                    m.userId = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 8:
                    m.mixId = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 9:
                    m.categoryId = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 10:
                    m.categoryTopicId = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 11:
                    m.topicId = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 12:
                    m.shareId = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 13:
                    if (!(m.testGroups && m.testGroups.length))
                        m.testGroups = [];
                    m.testGroups.push(r.string());
                    break;
                case 14:
                    m.pageSection = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 15:
                    m.categorySlugKey = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 16:
                    m.topicKey = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 17:
                    m.recId = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 18:
                    m.recBatchId = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 19:
                    m.searchQuery = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 20:
                    m.searchResultRank = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 21:
                    m.externalReferrer = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 22:
                    if (!(m.experiments && m.experiments.length))
                        m.experiments = [];
                    m.experiments.push($root.globals.Experiment.decode(r, r.uint32()));
                    break;
                case 23:
                    if (!(m.rollouts && m.rollouts.length))
                        m.rollouts = [];
                    m.rollouts.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        PageContext.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        PageContext.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.page != null && m.hasOwnProperty("page")) {
                switch (m.page) {
                default:
                    return "page: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                case 21:
                case 22:
                case 23:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 45:
                case 46:
                case 47:
                    break;
                }
            }
            if (m.attributes != null && m.hasOwnProperty("attributes")) {
                if (!$util.isObject(m.attributes))
                    return "attributes: object expected";
                var k = Object.keys(m.attributes);
                for (var i = 0; i < k.length; ++i) {
                    if (!$util.isString(m.attributes[k[i]]))
                        return "attributes: string{k:string} expected";
                }
            }
            if (m.streamType != null && m.hasOwnProperty("streamType")) {
                switch (m.streamType) {
                default:
                    return "streamType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                    break;
                }
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.userId);
                    if (e)
                        return "userId." + e;
                }
            }
            if (m.mixId != null && m.hasOwnProperty("mixId")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.mixId);
                    if (e)
                        return "mixId." + e;
                }
            }
            if (m.categoryId != null && m.hasOwnProperty("categoryId")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.categoryId);
                    if (e)
                        return "categoryId." + e;
                }
            }
            if (m.categoryTopicId != null && m.hasOwnProperty("categoryTopicId")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.categoryTopicId);
                    if (e)
                        return "categoryTopicId." + e;
                }
            }
            if (m.topicId != null && m.hasOwnProperty("topicId")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.topicId);
                    if (e)
                        return "topicId." + e;
                }
            }
            if (m.shareId != null && m.hasOwnProperty("shareId")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.shareId);
                    if (e)
                        return "shareId." + e;
                }
            }
            if (m.testGroups != null && m.hasOwnProperty("testGroups")) {
                if (!Array.isArray(m.testGroups))
                    return "testGroups: array expected";
                for (var i = 0; i < m.testGroups.length; ++i) {
                    if (!$util.isString(m.testGroups[i]))
                        return "testGroups: string[] expected";
                }
            }
            if (m.pageSection != null && m.hasOwnProperty("pageSection")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.pageSection);
                    if (e)
                        return "pageSection." + e;
                }
            }
            if (m.categorySlugKey != null && m.hasOwnProperty("categorySlugKey")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.categorySlugKey);
                    if (e)
                        return "categorySlugKey." + e;
                }
            }
            if (m.topicKey != null && m.hasOwnProperty("topicKey")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.topicKey);
                    if (e)
                        return "topicKey." + e;
                }
            }
            if (m.recId != null && m.hasOwnProperty("recId")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.recId);
                    if (e)
                        return "recId." + e;
                }
            }
            if (m.recBatchId != null && m.hasOwnProperty("recBatchId")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.recBatchId);
                    if (e)
                        return "recBatchId." + e;
                }
            }
            if (m.searchQuery != null && m.hasOwnProperty("searchQuery")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.searchQuery);
                    if (e)
                        return "searchQuery." + e;
                }
            }
            if (m.searchResultRank != null && m.hasOwnProperty("searchResultRank")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.searchResultRank);
                    if (e)
                        return "searchResultRank." + e;
                }
            }
            if (m.externalReferrer != null && m.hasOwnProperty("externalReferrer")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.externalReferrer);
                    if (e)
                        return "externalReferrer." + e;
                }
            }
            if (m.experiments != null && m.hasOwnProperty("experiments")) {
                if (!Array.isArray(m.experiments))
                    return "experiments: array expected";
                for (var i = 0; i < m.experiments.length; ++i) {
                    {
                        var e = $root.globals.Experiment.verify(m.experiments[i]);
                        if (e)
                            return "experiments." + e;
                    }
                }
            }
            if (m.rollouts != null && m.hasOwnProperty("rollouts")) {
                if (!Array.isArray(m.rollouts))
                    return "rollouts: array expected";
                for (var i = 0; i < m.rollouts.length; ++i) {
                    if (!$util.isString(m.rollouts[i]))
                        return "rollouts: string[] expected";
                }
            }
            return null;
        };

        PageContext.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.PageContext)
                return d;
            var m = new $root.globals.PageContext();
            switch (d.page) {
            case "UNKNOWN_PAGE":
            case 0:
                m.page = 0;
                break;
            case "STREAMS_PAGE":
            case 1:
                m.page = 1;
                break;
            case "INBOX_SENT":
            case 2:
                m.page = 2;
                break;
            case "INBOX_RECEIVED":
            case 3:
                m.page = 3;
                break;
            case "CARD_VIEW":
            case 4:
                m.page = 4;
                break;
            case "CONTENT_VIEW":
            case 5:
                m.page = 5;
                break;
            case "IN_APP_SHARE":
            case 6:
                m.page = 6;
                break;
            case "SHARE_EXTENSION":
            case 7:
                m.page = 7;
                break;
            case "USER_PROFILE_PAGES":
            case 8:
                m.page = 8;
                break;
            case "USER_PROFILE_MIXES":
            case 9:
                m.page = 9;
                break;
            case "USER_PROFILE_FOLLOWERS":
            case 10:
                m.page = 10;
                break;
            case "USER_PROFILE_FOLLOWING":
            case 11:
                m.page = 11;
                break;
            case "USER_PROFILE_SEEN":
            case 12:
                m.page = 12;
                break;
            case "MIX_PROFILE_PAGES":
            case 13:
                m.page = 13;
                break;
            case "MIX_PROFILE_FOLLOWERS":
            case 14:
                m.page = 14;
                break;
            case "TOPIC_PROFILE_PAGES":
            case 15:
                m.page = 15;
                break;
            case "TOPIC_PROFILE_FOLLOWERS":
            case 16:
                m.page = 16;
                break;
            case "CATEGORY_PROFILE_PAGES":
            case 17:
                m.page = 17;
                break;
            case "CATEGORY_PROFILE_FOLLOWERS":
            case 18:
                m.page = 18;
                break;
            case "ONBOARDING_CATEGORY_FOLLOW":
            case 19:
                m.page = 19;
                break;
            case "ONBOARDING_USER_FOLLOW":
            case 20:
                m.page = 20;
                break;
            case "CARD_MIXED_BY":
            case 21:
                m.page = 21;
                break;
            case "SHARE_INBOX":
            case 22:
                m.page = 22;
                break;
            case "SHARE_CONVERSATION":
            case 23:
                m.page = 23;
                break;
            case "END_OF_STREAM":
            case 24:
                m.page = 24;
                break;
            case "DEEP_LINK":
            case 25:
                m.page = 25;
                break;
            case "PUSH_NOTIFICATION":
            case 26:
                m.page = 26;
                break;
            case "SEARCH_PAGE":
            case 27:
                m.page = 27;
                break;
            case "ONBOARDING_MIX_FOLLOW":
            case 28:
                m.page = 28;
                break;
            case "FIND_FRIENDS":
            case 29:
                m.page = 29;
                break;
            case "ONBOARDING_PROFILE":
            case 30:
                m.page = 30;
                break;
            case "STREAM_PROFILE_PAGE":
            case 31:
                m.page = 31;
                break;
            case "USER_PROFILE_CREATED_COLLECTIONS":
            case 32:
                m.page = 32;
                break;
            case "USER_PROFILE_SUBSCRIBED_COLLECTIONS":
            case 33:
                m.page = 33;
                break;
            case "USER_PROFILE_NOTIFICATIONS":
            case 34:
                m.page = 34;
                break;
            case "USER_PROFILE_SETTINGS":
            case 35:
                m.page = 35;
                break;
            case "LOGGED_OUT_HOME":
            case 36:
                m.page = 36;
                break;
            case "MIXIT_LINK":
            case 37:
                m.page = 37;
                break;
            case "MIX_PROFILE_EDIT":
            case 39:
                m.page = 39;
                break;
            case "LOGIN_PAGE":
            case 40:
                m.page = 40;
                break;
            case "ONBOARDING_INTEREST_FOLLOW":
            case 41:
                m.page = 41;
                break;
            case "SHARE_EXTENSION_MIXED_BY":
            case 42:
                m.page = 42;
                break;
            case "ADMIN_PAGE":
            case 43:
                m.page = 43;
                break;
            case "USER_PROFILE_LINKED_ACCOUNTS":
            case 44:
                m.page = 44;
                break;
            case "EMAIL_AUTH_LOGIN_PAGE":
            case 45:
                m.page = 45;
                break;
            case "EMAIL_AUTH_SENT_PAGE":
            case 46:
                m.page = 46;
                break;
            case "EMAIL_AUTH_ERROR_PAGE":
            case 47:
                m.page = 47;
                break;
            }
            if (d.attributes) {
                if (typeof d.attributes !== "object")
                    throw TypeError(".globals.PageContext.attributes: object expected");
                m.attributes = {};
                for (var ks = Object.keys(d.attributes), i = 0; i < ks.length; ++i) {
                    m.attributes[ks[i]] = String(d.attributes[ks[i]]);
                }
            }
            switch (d.streamType) {
            case "UNKNOWN_STREAM_TYPE":
            case 0:
                m.streamType = 0;
                break;
            case "TOP_FOR_YOU_STREAM":
            case 1:
                m.streamType = 1;
                break;
            case "CATEGORY_STREAM":
            case 2:
                m.streamType = 2;
                break;
            case "TOPIC_STREAM":
            case 3:
                m.streamType = 3;
                break;
            case "MIX_STREAM":
            case 4:
                m.streamType = 4;
                break;
            case "SHARE_STREAM":
            case 5:
                m.streamType = 5;
                break;
            case "USER_MIXED_STREAM":
            case 6:
                m.streamType = 6;
                break;
            case "MIX_DIGEST_STREAM":
            case 7:
                m.streamType = 7;
                break;
            case "ALL_OF_MIX_STREAM":
            case 8:
                m.streamType = 8;
                break;
            case "FEATURED_COLLECTION_CAROUSEL":
            case 9:
                m.streamType = 9;
                break;
            case "FEATURED_ARTICLE_CAROUSEL":
            case 10:
                m.streamType = 10;
                break;
            case "RELATED_ARTICLE_STREAM":
            case 11:
                m.streamType = 11;
                break;
            case "SEARCH_POSTS_STREAM":
            case 12:
                m.streamType = 12;
                break;
            case "SEARCH_COLLECTIONS_STREAM":
            case 13:
                m.streamType = 13;
                break;
            case "SEARCH_INTERESTS_STREAM":
            case 14:
                m.streamType = 14;
                break;
            case "SEARCH_PEOPLE_STREAM":
            case 15:
                m.streamType = 15;
                break;
            case "SEARCH_ALL_STREAM":
            case 16:
                m.streamType = 16;
                break;
            }
            if (d.userId != null) {
                if (typeof d.userId === "object" && d.userId !== null && d.userId.value !== undefined)
                    throw TypeError(".globals.PageContext.userId: wrapped value not expected");
                m.userId = $root.google.protobuf.UInt64Value.fromObject({ value: d.userId });
            }
            if (d.mixId != null) {
                if (typeof d.mixId === "object" && d.mixId !== null && d.mixId.value !== undefined)
                    throw TypeError(".globals.PageContext.mixId: wrapped value not expected");
                m.mixId = $root.google.protobuf.UInt64Value.fromObject({ value: d.mixId });
            }
            if (d.categoryId != null) {
                if (typeof d.categoryId === "object" && d.categoryId !== null && d.categoryId.value !== undefined)
                    throw TypeError(".globals.PageContext.categoryId: wrapped value not expected");
                m.categoryId = $root.google.protobuf.UInt64Value.fromObject({ value: d.categoryId });
            }
            if (d.categoryTopicId != null) {
                if (typeof d.categoryTopicId === "object" && d.categoryTopicId !== null && d.categoryTopicId.value !== undefined)
                    throw TypeError(".globals.PageContext.categoryTopicId: wrapped value not expected");
                m.categoryTopicId = $root.google.protobuf.UInt64Value.fromObject({ value: d.categoryTopicId });
            }
            if (d.topicId != null) {
                if (typeof d.topicId === "object" && d.topicId !== null && d.topicId.value !== undefined)
                    throw TypeError(".globals.PageContext.topicId: wrapped value not expected");
                m.topicId = $root.google.protobuf.UInt64Value.fromObject({ value: d.topicId });
            }
            if (d.shareId != null) {
                if (typeof d.shareId === "object" && d.shareId !== null && d.shareId.value !== undefined)
                    throw TypeError(".globals.PageContext.shareId: wrapped value not expected");
                m.shareId = $root.google.protobuf.UInt64Value.fromObject({ value: d.shareId });
            }
            if (d.testGroups) {
                if (!Array.isArray(d.testGroups))
                    throw TypeError(".globals.PageContext.testGroups: array expected");
                m.testGroups = [];
                for (var i = 0; i < d.testGroups.length; ++i) {
                    m.testGroups[i] = String(d.testGroups[i]);
                }
            }
            if (d.pageSection != null) {
                if (typeof d.pageSection === "object" && d.pageSection !== null && d.pageSection.value !== undefined)
                    throw TypeError(".globals.PageContext.pageSection: wrapped value not expected");
                m.pageSection = $root.google.protobuf.StringValue.fromObject({ value: d.pageSection });
            }
            if (d.categorySlugKey != null) {
                if (typeof d.categorySlugKey === "object" && d.categorySlugKey !== null && d.categorySlugKey.value !== undefined)
                    throw TypeError(".globals.PageContext.categorySlugKey: wrapped value not expected");
                m.categorySlugKey = $root.google.protobuf.StringValue.fromObject({ value: d.categorySlugKey });
            }
            if (d.topicKey != null) {
                if (typeof d.topicKey === "object" && d.topicKey !== null && d.topicKey.value !== undefined)
                    throw TypeError(".globals.PageContext.topicKey: wrapped value not expected");
                m.topicKey = $root.google.protobuf.StringValue.fromObject({ value: d.topicKey });
            }
            if (d.recId != null) {
                if (typeof d.recId === "object" && d.recId !== null && d.recId.value !== undefined)
                    throw TypeError(".globals.PageContext.recId: wrapped value not expected");
                m.recId = $root.google.protobuf.StringValue.fromObject({ value: d.recId });
            }
            if (d.recBatchId != null) {
                if (typeof d.recBatchId === "object" && d.recBatchId !== null && d.recBatchId.value !== undefined)
                    throw TypeError(".globals.PageContext.recBatchId: wrapped value not expected");
                m.recBatchId = $root.google.protobuf.StringValue.fromObject({ value: d.recBatchId });
            }
            if (d.searchQuery != null) {
                if (typeof d.searchQuery === "object" && d.searchQuery !== null && d.searchQuery.value !== undefined)
                    throw TypeError(".globals.PageContext.searchQuery: wrapped value not expected");
                m.searchQuery = $root.google.protobuf.StringValue.fromObject({ value: d.searchQuery });
            }
            if (d.searchResultRank != null) {
                if (typeof d.searchResultRank === "object" && d.searchResultRank !== null && d.searchResultRank.value !== undefined)
                    throw TypeError(".globals.PageContext.searchResultRank: wrapped value not expected");
                m.searchResultRank = $root.google.protobuf.UInt64Value.fromObject({ value: d.searchResultRank });
            }
            if (d.externalReferrer != null) {
                if (typeof d.externalReferrer === "object" && d.externalReferrer !== null && d.externalReferrer.value !== undefined)
                    throw TypeError(".globals.PageContext.externalReferrer: wrapped value not expected");
                m.externalReferrer = $root.google.protobuf.StringValue.fromObject({ value: d.externalReferrer });
            }
            if (d.experiments) {
                if (!Array.isArray(d.experiments))
                    throw TypeError(".globals.PageContext.experiments: array expected");
                m.experiments = [];
                for (var i = 0; i < d.experiments.length; ++i) {
                    if (typeof d.experiments[i] !== "object")
                        throw TypeError(".globals.PageContext.experiments: object expected");
                    m.experiments[i] = $root.globals.Experiment.fromObject(d.experiments[i]);
                }
            }
            if (d.rollouts) {
                if (!Array.isArray(d.rollouts))
                    throw TypeError(".globals.PageContext.rollouts: array expected");
                m.rollouts = [];
                for (var i = 0; i < d.rollouts.length; ++i) {
                    m.rollouts[i] = String(d.rollouts[i]);
                }
            }
            return m;
        };

        PageContext.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.testGroups = [];
                d.experiments = [];
                d.rollouts = [];
            }
            if (o.objects || o.defaults) {
                d.attributes = {};
            }
            if (o.defaults) {
                d.page = o.enums === String ? "UNKNOWN_PAGE" : 0;
                d.streamType = o.enums === String ? "UNKNOWN_STREAM_TYPE" : 0;
                d.userId = null;
                d.mixId = null;
                d.categoryId = null;
                d.categoryTopicId = null;
                d.topicId = null;
                d.shareId = null;
                d.pageSection = null;
                d.categorySlugKey = null;
                d.topicKey = null;
                d.recId = null;
                d.recBatchId = null;
                d.searchQuery = null;
                d.searchResultRank = null;
                d.externalReferrer = null;
            }
            if (m.page != null && m.hasOwnProperty("page")) {
                d.page = o.enums === String ? $root.globals.PageContext.PageType[m.page] : m.page;
            }
            var ks2;
            if (m.attributes && (ks2 = Object.keys(m.attributes)).length) {
                d.attributes = {};
                for (var j = 0; j < ks2.length; ++j) {
                    d.attributes[ks2[j]] = m.attributes[ks2[j]];
                }
            }
            if (m.streamType != null && m.hasOwnProperty("streamType")) {
                d.streamType = o.enums === String ? $root.globals.StreamType[m.streamType] : m.streamType;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                d.userId = $root.google.protobuf.UInt64Value.toObject(m.userId, o).value;
            }
            if (m.mixId != null && m.hasOwnProperty("mixId")) {
                d.mixId = $root.google.protobuf.UInt64Value.toObject(m.mixId, o).value;
            }
            if (m.categoryId != null && m.hasOwnProperty("categoryId")) {
                d.categoryId = $root.google.protobuf.UInt64Value.toObject(m.categoryId, o).value;
            }
            if (m.categoryTopicId != null && m.hasOwnProperty("categoryTopicId")) {
                d.categoryTopicId = $root.google.protobuf.UInt64Value.toObject(m.categoryTopicId, o).value;
            }
            if (m.topicId != null && m.hasOwnProperty("topicId")) {
                d.topicId = $root.google.protobuf.UInt64Value.toObject(m.topicId, o).value;
            }
            if (m.shareId != null && m.hasOwnProperty("shareId")) {
                d.shareId = $root.google.protobuf.UInt64Value.toObject(m.shareId, o).value;
            }
            if (m.testGroups && m.testGroups.length) {
                d.testGroups = [];
                for (var j = 0; j < m.testGroups.length; ++j) {
                    d.testGroups[j] = m.testGroups[j];
                }
            }
            if (m.pageSection != null && m.hasOwnProperty("pageSection")) {
                d.pageSection = $root.google.protobuf.StringValue.toObject(m.pageSection, o).value;
            }
            if (m.categorySlugKey != null && m.hasOwnProperty("categorySlugKey")) {
                d.categorySlugKey = $root.google.protobuf.StringValue.toObject(m.categorySlugKey, o).value;
            }
            if (m.topicKey != null && m.hasOwnProperty("topicKey")) {
                d.topicKey = $root.google.protobuf.StringValue.toObject(m.topicKey, o).value;
            }
            if (m.recId != null && m.hasOwnProperty("recId")) {
                d.recId = $root.google.protobuf.StringValue.toObject(m.recId, o).value;
            }
            if (m.recBatchId != null && m.hasOwnProperty("recBatchId")) {
                d.recBatchId = $root.google.protobuf.StringValue.toObject(m.recBatchId, o).value;
            }
            if (m.searchQuery != null && m.hasOwnProperty("searchQuery")) {
                d.searchQuery = $root.google.protobuf.StringValue.toObject(m.searchQuery, o).value;
            }
            if (m.searchResultRank != null && m.hasOwnProperty("searchResultRank")) {
                d.searchResultRank = $root.google.protobuf.UInt64Value.toObject(m.searchResultRank, o).value;
            }
            if (m.externalReferrer != null && m.hasOwnProperty("externalReferrer")) {
                d.externalReferrer = $root.google.protobuf.StringValue.toObject(m.externalReferrer, o).value;
            }
            if (m.experiments && m.experiments.length) {
                d.experiments = [];
                for (var j = 0; j < m.experiments.length; ++j) {
                    d.experiments[j] = $root.globals.Experiment.toObject(m.experiments[j], o);
                }
            }
            if (m.rollouts && m.rollouts.length) {
                d.rollouts = [];
                for (var j = 0; j < m.rollouts.length; ++j) {
                    d.rollouts[j] = m.rollouts[j];
                }
            }
            return d;
        };

        PageContext.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        PageContext.PageType = (function() {
            const valuesById = {}, values = Object.create(valuesById);
            values[valuesById[0] = "UNKNOWN_PAGE"] = 0;
            values[valuesById[1] = "STREAMS_PAGE"] = 1;
            values[valuesById[2] = "INBOX_SENT"] = 2;
            values[valuesById[3] = "INBOX_RECEIVED"] = 3;
            values[valuesById[4] = "CARD_VIEW"] = 4;
            values[valuesById[5] = "CONTENT_VIEW"] = 5;
            values[valuesById[6] = "IN_APP_SHARE"] = 6;
            values[valuesById[7] = "SHARE_EXTENSION"] = 7;
            values[valuesById[8] = "USER_PROFILE_PAGES"] = 8;
            values[valuesById[9] = "USER_PROFILE_MIXES"] = 9;
            values[valuesById[10] = "USER_PROFILE_FOLLOWERS"] = 10;
            values[valuesById[11] = "USER_PROFILE_FOLLOWING"] = 11;
            values[valuesById[12] = "USER_PROFILE_SEEN"] = 12;
            values[valuesById[13] = "MIX_PROFILE_PAGES"] = 13;
            values[valuesById[14] = "MIX_PROFILE_FOLLOWERS"] = 14;
            values[valuesById[15] = "TOPIC_PROFILE_PAGES"] = 15;
            values[valuesById[16] = "TOPIC_PROFILE_FOLLOWERS"] = 16;
            values[valuesById[17] = "CATEGORY_PROFILE_PAGES"] = 17;
            values[valuesById[18] = "CATEGORY_PROFILE_FOLLOWERS"] = 18;
            values[valuesById[19] = "ONBOARDING_CATEGORY_FOLLOW"] = 19;
            values[valuesById[20] = "ONBOARDING_USER_FOLLOW"] = 20;
            values[valuesById[21] = "CARD_MIXED_BY"] = 21;
            values[valuesById[22] = "SHARE_INBOX"] = 22;
            values[valuesById[23] = "SHARE_CONVERSATION"] = 23;
            values[valuesById[24] = "END_OF_STREAM"] = 24;
            values[valuesById[25] = "DEEP_LINK"] = 25;
            values[valuesById[26] = "PUSH_NOTIFICATION"] = 26;
            values[valuesById[27] = "SEARCH_PAGE"] = 27;
            values[valuesById[28] = "ONBOARDING_MIX_FOLLOW"] = 28;
            values[valuesById[29] = "FIND_FRIENDS"] = 29;
            values[valuesById[30] = "ONBOARDING_PROFILE"] = 30;
            values[valuesById[31] = "STREAM_PROFILE_PAGE"] = 31;
            values[valuesById[32] = "USER_PROFILE_CREATED_COLLECTIONS"] = 32;
            values[valuesById[33] = "USER_PROFILE_SUBSCRIBED_COLLECTIONS"] = 33;
            values[valuesById[34] = "USER_PROFILE_NOTIFICATIONS"] = 34;
            values[valuesById[35] = "USER_PROFILE_SETTINGS"] = 35;
            values[valuesById[36] = "LOGGED_OUT_HOME"] = 36;
            values[valuesById[37] = "MIXIT_LINK"] = 37;
            values[valuesById[39] = "MIX_PROFILE_EDIT"] = 39;
            values[valuesById[40] = "LOGIN_PAGE"] = 40;
            values[valuesById[41] = "ONBOARDING_INTEREST_FOLLOW"] = 41;
            values[valuesById[42] = "SHARE_EXTENSION_MIXED_BY"] = 42;
            values[valuesById[43] = "ADMIN_PAGE"] = 43;
            values[valuesById[44] = "USER_PROFILE_LINKED_ACCOUNTS"] = 44;
            values[valuesById[45] = "EMAIL_AUTH_LOGIN_PAGE"] = 45;
            values[valuesById[46] = "EMAIL_AUTH_SENT_PAGE"] = 46;
            values[valuesById[47] = "EMAIL_AUTH_ERROR_PAGE"] = 47;
            return values;
        })();

        return PageContext;
    })();

    globals.AppVersion = (function() {

        function AppVersion(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        AppVersion.prototype.appName = null;
        AppVersion.prototype.versionNumber = null;
        AppVersion.prototype.provider = 0;
        AppVersion.prototype.buildNumber = null;
        AppVersion.prototype.appType = 0;
        AppVersion.prototype.customProvider = null;

        AppVersion.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.appName != null && Object.hasOwnProperty.call(m, "appName"))
                $root.google.protobuf.StringValue.encode(m.appName, w.uint32(10).fork()).ldelim();
            if (m.versionNumber != null && Object.hasOwnProperty.call(m, "versionNumber"))
                $root.google.protobuf.StringValue.encode(m.versionNumber, w.uint32(18).fork()).ldelim();
            if (m.provider != null && Object.hasOwnProperty.call(m, "provider"))
                w.uint32(24).int32(m.provider);
            if (m.buildNumber != null && Object.hasOwnProperty.call(m, "buildNumber"))
                $root.google.protobuf.StringValue.encode(m.buildNumber, w.uint32(34).fork()).ldelim();
            if (m.appType != null && Object.hasOwnProperty.call(m, "appType"))
                w.uint32(40).int32(m.appType);
            if (m.customProvider != null && Object.hasOwnProperty.call(m, "customProvider"))
                $root.google.protobuf.StringValue.encode(m.customProvider, w.uint32(50).fork()).ldelim();
            return w;
        };

        AppVersion.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        AppVersion.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.AppVersion();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.appName = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.versionNumber = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 3:
                    m.provider = r.int32();
                    break;
                case 4:
                    m.buildNumber = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 5:
                    m.appType = r.int32();
                    break;
                case 6:
                    m.customProvider = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        AppVersion.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        AppVersion.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.appName != null && m.hasOwnProperty("appName")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.appName);
                    if (e)
                        return "appName." + e;
                }
            }
            if (m.versionNumber != null && m.hasOwnProperty("versionNumber")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.versionNumber);
                    if (e)
                        return "versionNumber." + e;
                }
            }
            if (m.provider != null && m.hasOwnProperty("provider")) {
                switch (m.provider) {
                default:
                    return "provider: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                    break;
                }
            }
            if (m.buildNumber != null && m.hasOwnProperty("buildNumber")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.buildNumber);
                    if (e)
                        return "buildNumber." + e;
                }
            }
            if (m.appType != null && m.hasOwnProperty("appType")) {
                switch (m.appType) {
                default:
                    return "appType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                    break;
                }
            }
            if (m.customProvider != null && m.hasOwnProperty("customProvider")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.customProvider);
                    if (e)
                        return "customProvider." + e;
                }
            }
            return null;
        };

        AppVersion.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.AppVersion)
                return d;
            var m = new $root.globals.AppVersion();
            if (d.appName != null) {
                if (typeof d.appName === "object" && d.appName !== null && d.appName.value !== undefined)
                    throw TypeError(".globals.AppVersion.appName: wrapped value not expected");
                m.appName = $root.google.protobuf.StringValue.fromObject({ value: d.appName });
            }
            if (d.versionNumber != null) {
                if (typeof d.versionNumber === "object" && d.versionNumber !== null && d.versionNumber.value !== undefined)
                    throw TypeError(".globals.AppVersion.versionNumber: wrapped value not expected");
                m.versionNumber = $root.google.protobuf.StringValue.fromObject({ value: d.versionNumber });
            }
            switch (d.provider) {
            case "UNKNOWN_PROVIDER":
            case 0:
                m.provider = 0;
                break;
            case "APPLE_STORE":
            case 1:
                m.provider = 1;
                break;
            case "CHROME_WEB_STORE":
            case 2:
                m.provider = 2;
                break;
            case "MIX":
            case 3:
                m.provider = 3;
                break;
            case "GOOGLE_PLAY_STORE":
            case 4:
                m.provider = 4;
                break;
            case "OTHER_APP_PROVIDER":
            case 5:
                m.provider = 5;
                break;
            case "FIREFOX_ADD_ONS":
            case 6:
                m.provider = 6;
                break;
            case "MICROSOFT_STORE":
            case 7:
                m.provider = 7;
                break;
            }
            if (d.buildNumber != null) {
                if (typeof d.buildNumber === "object" && d.buildNumber !== null && d.buildNumber.value !== undefined)
                    throw TypeError(".globals.AppVersion.buildNumber: wrapped value not expected");
                m.buildNumber = $root.google.protobuf.StringValue.fromObject({ value: d.buildNumber });
            }
            switch (d.appType) {
            case "UNKNOWN_APP":
            case 0:
                m.appType = 0;
                break;
            case "IOS_APP":
            case 1:
                m.appType = 1;
                break;
            case "WEBAPP":
            case 2:
                m.appType = 2;
                break;
            case "ANDROID_APP":
            case 3:
                m.appType = 3;
                break;
            case "CHROME_EXTENSION":
            case 4:
                m.appType = 4;
                break;
            case "FIREFOX_EXTENSION":
            case 5:
                m.appType = 5;
                break;
            case "MIX_BADGE":
            case 6:
                m.appType = 6;
                break;
            case "THIRD_PARTY_BADGE":
            case 7:
                m.appType = 7;
                break;
            case "INGESTER":
            case 8:
                m.appType = 8;
                break;
            case "INTERNAL_APP":
            case 9:
                m.appType = 9;
                break;
            case "SAFARI_EXTENSION":
            case 10:
                m.appType = 10;
                break;
            case "EDGE_EXTENSION":
            case 11:
                m.appType = 11;
                break;
            }
            if (d.customProvider != null) {
                if (typeof d.customProvider === "object" && d.customProvider !== null && d.customProvider.value !== undefined)
                    throw TypeError(".globals.AppVersion.customProvider: wrapped value not expected");
                m.customProvider = $root.google.protobuf.StringValue.fromObject({ value: d.customProvider });
            }
            return m;
        };

        AppVersion.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.appName = null;
                d.versionNumber = null;
                d.provider = o.enums === String ? "UNKNOWN_PROVIDER" : 0;
                d.buildNumber = null;
                d.appType = o.enums === String ? "UNKNOWN_APP" : 0;
                d.customProvider = null;
            }
            if (m.appName != null && m.hasOwnProperty("appName")) {
                d.appName = $root.google.protobuf.StringValue.toObject(m.appName, o).value;
            }
            if (m.versionNumber != null && m.hasOwnProperty("versionNumber")) {
                d.versionNumber = $root.google.protobuf.StringValue.toObject(m.versionNumber, o).value;
            }
            if (m.provider != null && m.hasOwnProperty("provider")) {
                d.provider = o.enums === String ? $root.globals.AppProvider[m.provider] : m.provider;
            }
            if (m.buildNumber != null && m.hasOwnProperty("buildNumber")) {
                d.buildNumber = $root.google.protobuf.StringValue.toObject(m.buildNumber, o).value;
            }
            if (m.appType != null && m.hasOwnProperty("appType")) {
                d.appType = o.enums === String ? $root.globals.ApplicationType[m.appType] : m.appType;
            }
            if (m.customProvider != null && m.hasOwnProperty("customProvider")) {
                d.customProvider = $root.google.protobuf.StringValue.toObject(m.customProvider, o).value;
            }
            return d;
        };

        AppVersion.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return AppVersion;
    })();

    globals.Device = (function() {

        function Device(p) {
            this.data = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Device.prototype.deviceType = 0;
        Device.prototype.userAgent = null;
        Device.prototype.osVersion = null;
        Device.prototype.osLanguage = 0;
        Device.prototype.data = $util.emptyObject;
        Device.prototype.deviceModel = null;

        Device.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.deviceType != null && Object.hasOwnProperty.call(m, "deviceType"))
                w.uint32(8).int32(m.deviceType);
            if (m.userAgent != null && Object.hasOwnProperty.call(m, "userAgent"))
                $root.google.protobuf.StringValue.encode(m.userAgent, w.uint32(18).fork()).ldelim();
            if (m.osVersion != null && Object.hasOwnProperty.call(m, "osVersion"))
                $root.google.protobuf.StringValue.encode(m.osVersion, w.uint32(26).fork()).ldelim();
            if (m.osLanguage != null && Object.hasOwnProperty.call(m, "osLanguage"))
                w.uint32(32).int32(m.osLanguage);
            if (m.data != null && Object.hasOwnProperty.call(m, "data")) {
                for (var ks = Object.keys(m.data), i = 0; i < ks.length; ++i) {
                    w.uint32(42).fork().uint32(10).string(ks[i]).uint32(18).string(m.data[ks[i]]).ldelim();
                }
            }
            if (m.deviceModel != null && Object.hasOwnProperty.call(m, "deviceModel"))
                $root.google.protobuf.StringValue.encode(m.deviceModel, w.uint32(50).fork()).ldelim();
            return w;
        };

        Device.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Device.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.Device(), k;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.deviceType = r.int32();
                    break;
                case 2:
                    m.userAgent = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 3:
                    m.osVersion = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 4:
                    m.osLanguage = r.int32();
                    break;
                case 5:
                    r.skip().pos++;
                    if (m.data === $util.emptyObject)
                        m.data = {};
                    k = r.string();
                    r.pos++;
                    m.data[k] = r.string();
                    break;
                case 6:
                    m.deviceModel = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Device.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Device.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.deviceType != null && m.hasOwnProperty("deviceType")) {
                switch (m.deviceType) {
                default:
                    return "deviceType: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                    break;
                }
            }
            if (m.userAgent != null && m.hasOwnProperty("userAgent")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.userAgent);
                    if (e)
                        return "userAgent." + e;
                }
            }
            if (m.osVersion != null && m.hasOwnProperty("osVersion")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.osVersion);
                    if (e)
                        return "osVersion." + e;
                }
            }
            if (m.osLanguage != null && m.hasOwnProperty("osLanguage")) {
                switch (m.osLanguage) {
                default:
                    return "osLanguage: enum value expected";
                case 0:
                case 1:
                    break;
                }
            }
            if (m.data != null && m.hasOwnProperty("data")) {
                if (!$util.isObject(m.data))
                    return "data: object expected";
                var k = Object.keys(m.data);
                for (var i = 0; i < k.length; ++i) {
                    if (!$util.isString(m.data[k[i]]))
                        return "data: string{k:string} expected";
                }
            }
            if (m.deviceModel != null && m.hasOwnProperty("deviceModel")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.deviceModel);
                    if (e)
                        return "deviceModel." + e;
                }
            }
            return null;
        };

        Device.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.Device)
                return d;
            var m = new $root.globals.Device();
            switch (d.deviceType) {
            case "UNKNOWN_DEVICE":
            case 0:
                m.deviceType = 0;
                break;
            case "IPHONE":
            case 1:
                m.deviceType = 1;
                break;
            case "DEPRECATED_CHROME_EXTENSION":
            case 2:
                m.deviceType = 2;
                break;
            case "DEPRECATED_WEBAPP":
            case 3:
                m.deviceType = 3;
                break;
            case "DEPRECATED_FIREFOX_EXTENSION":
            case 4:
                m.deviceType = 4;
                break;
            case "ANDROID":
            case 5:
                m.deviceType = 5;
                break;
            case "IPAD":
            case 6:
                m.deviceType = 6;
                break;
            case "ANDROID_TABLET":
            case 7:
                m.deviceType = 7;
                break;
            case "DESKTOP":
            case 8:
                m.deviceType = 8;
                break;
            case "INTERNAL":
            case 9:
                m.deviceType = 9;
                break;
            case "WINDOWS_PHONE":
            case 10:
                m.deviceType = 10;
                break;
            case "SYMBIAN":
            case 11:
                m.deviceType = 11;
                break;
            }
            if (d.userAgent != null) {
                if (typeof d.userAgent === "object" && d.userAgent !== null && d.userAgent.value !== undefined)
                    throw TypeError(".globals.Device.userAgent: wrapped value not expected");
                m.userAgent = $root.google.protobuf.StringValue.fromObject({ value: d.userAgent });
            }
            if (d.osVersion != null) {
                if (typeof d.osVersion === "object" && d.osVersion !== null && d.osVersion.value !== undefined)
                    throw TypeError(".globals.Device.osVersion: wrapped value not expected");
                m.osVersion = $root.google.protobuf.StringValue.fromObject({ value: d.osVersion });
            }
            switch (d.osLanguage) {
            case "UNKNOWN_LANGUAGE":
            case 0:
                m.osLanguage = 0;
                break;
            case "ENGLISH":
            case 1:
                m.osLanguage = 1;
                break;
            }
            if (d.data) {
                if (typeof d.data !== "object")
                    throw TypeError(".globals.Device.data: object expected");
                m.data = {};
                for (var ks = Object.keys(d.data), i = 0; i < ks.length; ++i) {
                    m.data[ks[i]] = String(d.data[ks[i]]);
                }
            }
            if (d.deviceModel != null) {
                if (typeof d.deviceModel === "object" && d.deviceModel !== null && d.deviceModel.value !== undefined)
                    throw TypeError(".globals.Device.deviceModel: wrapped value not expected");
                m.deviceModel = $root.google.protobuf.StringValue.fromObject({ value: d.deviceModel });
            }
            return m;
        };

        Device.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.objects || o.defaults) {
                d.data = {};
            }
            if (o.defaults) {
                d.deviceType = o.enums === String ? "UNKNOWN_DEVICE" : 0;
                d.userAgent = null;
                d.osVersion = null;
                d.osLanguage = o.enums === String ? "UNKNOWN_LANGUAGE" : 0;
                d.deviceModel = null;
            }
            if (m.deviceType != null && m.hasOwnProperty("deviceType")) {
                d.deviceType = o.enums === String ? $root.globals.DeviceType[m.deviceType] : m.deviceType;
            }
            if (m.userAgent != null && m.hasOwnProperty("userAgent")) {
                d.userAgent = $root.google.protobuf.StringValue.toObject(m.userAgent, o).value;
            }
            if (m.osVersion != null && m.hasOwnProperty("osVersion")) {
                d.osVersion = $root.google.protobuf.StringValue.toObject(m.osVersion, o).value;
            }
            if (m.osLanguage != null && m.hasOwnProperty("osLanguage")) {
                d.osLanguage = o.enums === String ? $root.globals.Language[m.osLanguage] : m.osLanguage;
            }
            var ks2;
            if (m.data && (ks2 = Object.keys(m.data)).length) {
                d.data = {};
                for (var j = 0; j < ks2.length; ++j) {
                    d.data[ks2[j]] = m.data[ks2[j]];
                }
            }
            if (m.deviceModel != null && m.hasOwnProperty("deviceModel")) {
                d.deviceModel = $root.google.protobuf.StringValue.toObject(m.deviceModel, o).value;
            }
            return d;
        };

        Device.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Device;
    })();

    globals.Session = (function() {

        function Session(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Session.prototype.sessionId = null;
        Session.prototype.device = null;
        Session.prototype.appVersion = null;
        Session.prototype.location = null;
        Session.prototype.clientIp = null;
        Session.prototype.isAdmin = null;
        Session.prototype.clientSessionId = null;
        Session.prototype.isSystem = null;

        Session.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.sessionId != null && Object.hasOwnProperty.call(m, "sessionId"))
                $root.google.protobuf.StringValue.encode(m.sessionId, w.uint32(10).fork()).ldelim();
            if (m.device != null && Object.hasOwnProperty.call(m, "device"))
                $root.globals.Device.encode(m.device, w.uint32(18).fork()).ldelim();
            if (m.appVersion != null && Object.hasOwnProperty.call(m, "appVersion"))
                $root.globals.AppVersion.encode(m.appVersion, w.uint32(26).fork()).ldelim();
            if (m.location != null && Object.hasOwnProperty.call(m, "location"))
                $root.globals.Geolocation.encode(m.location, w.uint32(34).fork()).ldelim();
            if (m.clientIp != null && Object.hasOwnProperty.call(m, "clientIp"))
                $root.google.protobuf.StringValue.encode(m.clientIp, w.uint32(42).fork()).ldelim();
            if (m.isAdmin != null && Object.hasOwnProperty.call(m, "isAdmin"))
                $root.google.protobuf.BoolValue.encode(m.isAdmin, w.uint32(50).fork()).ldelim();
            if (m.clientSessionId != null && Object.hasOwnProperty.call(m, "clientSessionId"))
                $root.google.protobuf.StringValue.encode(m.clientSessionId, w.uint32(58).fork()).ldelim();
            if (m.isSystem != null && Object.hasOwnProperty.call(m, "isSystem"))
                $root.google.protobuf.BoolValue.encode(m.isSystem, w.uint32(66).fork()).ldelim();
            return w;
        };

        Session.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Session.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.Session();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.sessionId = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.device = $root.globals.Device.decode(r, r.uint32());
                    break;
                case 3:
                    m.appVersion = $root.globals.AppVersion.decode(r, r.uint32());
                    break;
                case 4:
                    m.location = $root.globals.Geolocation.decode(r, r.uint32());
                    break;
                case 5:
                    m.clientIp = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 6:
                    m.isAdmin = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                case 7:
                    m.clientSessionId = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 8:
                    m.isSystem = $root.google.protobuf.BoolValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Session.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Session.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.sessionId != null && m.hasOwnProperty("sessionId")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.sessionId);
                    if (e)
                        return "sessionId." + e;
                }
            }
            if (m.device != null && m.hasOwnProperty("device")) {
                {
                    var e = $root.globals.Device.verify(m.device);
                    if (e)
                        return "device." + e;
                }
            }
            if (m.appVersion != null && m.hasOwnProperty("appVersion")) {
                {
                    var e = $root.globals.AppVersion.verify(m.appVersion);
                    if (e)
                        return "appVersion." + e;
                }
            }
            if (m.location != null && m.hasOwnProperty("location")) {
                {
                    var e = $root.globals.Geolocation.verify(m.location);
                    if (e)
                        return "location." + e;
                }
            }
            if (m.clientIp != null && m.hasOwnProperty("clientIp")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.clientIp);
                    if (e)
                        return "clientIp." + e;
                }
            }
            if (m.isAdmin != null && m.hasOwnProperty("isAdmin")) {
                {
                    var e = $root.google.protobuf.BoolValue.verify(m.isAdmin);
                    if (e)
                        return "isAdmin." + e;
                }
            }
            if (m.clientSessionId != null && m.hasOwnProperty("clientSessionId")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.clientSessionId);
                    if (e)
                        return "clientSessionId." + e;
                }
            }
            if (m.isSystem != null && m.hasOwnProperty("isSystem")) {
                {
                    var e = $root.google.protobuf.BoolValue.verify(m.isSystem);
                    if (e)
                        return "isSystem." + e;
                }
            }
            return null;
        };

        Session.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.Session)
                return d;
            var m = new $root.globals.Session();
            if (d.sessionId != null) {
                if (typeof d.sessionId === "object" && d.sessionId !== null && d.sessionId.value !== undefined)
                    throw TypeError(".globals.Session.sessionId: wrapped value not expected");
                m.sessionId = $root.google.protobuf.StringValue.fromObject({ value: d.sessionId });
            }
            if (d.device != null) {
                if (typeof d.device !== "object")
                    throw TypeError(".globals.Session.device: object expected");
                m.device = $root.globals.Device.fromObject(d.device);
            }
            if (d.appVersion != null) {
                if (typeof d.appVersion !== "object")
                    throw TypeError(".globals.Session.appVersion: object expected");
                m.appVersion = $root.globals.AppVersion.fromObject(d.appVersion);
            }
            if (d.location != null) {
                if (typeof d.location !== "object")
                    throw TypeError(".globals.Session.location: object expected");
                m.location = $root.globals.Geolocation.fromObject(d.location);
            }
            if (d.clientIp != null) {
                if (typeof d.clientIp === "object" && d.clientIp !== null && d.clientIp.value !== undefined)
                    throw TypeError(".globals.Session.clientIp: wrapped value not expected");
                m.clientIp = $root.google.protobuf.StringValue.fromObject({ value: d.clientIp });
            }
            if (d.isAdmin != null) {
                if (typeof d.isAdmin === "object" && d.isAdmin !== null && d.isAdmin.value !== undefined)
                    throw TypeError(".globals.Session.isAdmin: wrapped value not expected");
                m.isAdmin = $root.google.protobuf.BoolValue.fromObject({ value: d.isAdmin });
            }
            if (d.clientSessionId != null) {
                if (typeof d.clientSessionId === "object" && d.clientSessionId !== null && d.clientSessionId.value !== undefined)
                    throw TypeError(".globals.Session.clientSessionId: wrapped value not expected");
                m.clientSessionId = $root.google.protobuf.StringValue.fromObject({ value: d.clientSessionId });
            }
            if (d.isSystem != null) {
                if (typeof d.isSystem === "object" && d.isSystem !== null && d.isSystem.value !== undefined)
                    throw TypeError(".globals.Session.isSystem: wrapped value not expected");
                m.isSystem = $root.google.protobuf.BoolValue.fromObject({ value: d.isSystem });
            }
            return m;
        };

        Session.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.sessionId = null;
                d.device = null;
                d.appVersion = null;
                d.location = null;
                d.clientIp = null;
                d.isAdmin = null;
                d.clientSessionId = null;
                d.isSystem = null;
            }
            if (m.sessionId != null && m.hasOwnProperty("sessionId")) {
                d.sessionId = $root.google.protobuf.StringValue.toObject(m.sessionId, o).value;
            }
            if (m.device != null && m.hasOwnProperty("device")) {
                d.device = $root.globals.Device.toObject(m.device, o);
            }
            if (m.appVersion != null && m.hasOwnProperty("appVersion")) {
                d.appVersion = $root.globals.AppVersion.toObject(m.appVersion, o);
            }
            if (m.location != null && m.hasOwnProperty("location")) {
                d.location = $root.globals.Geolocation.toObject(m.location, o);
            }
            if (m.clientIp != null && m.hasOwnProperty("clientIp")) {
                d.clientIp = $root.google.protobuf.StringValue.toObject(m.clientIp, o).value;
            }
            if (m.isAdmin != null && m.hasOwnProperty("isAdmin")) {
                d.isAdmin = $root.google.protobuf.BoolValue.toObject(m.isAdmin, o).value;
            }
            if (m.clientSessionId != null && m.hasOwnProperty("clientSessionId")) {
                d.clientSessionId = $root.google.protobuf.StringValue.toObject(m.clientSessionId, o).value;
            }
            if (m.isSystem != null && m.hasOwnProperty("isSystem")) {
                d.isSystem = $root.google.protobuf.BoolValue.toObject(m.isSystem, o).value;
            }
            return d;
        };

        Session.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Session;
    })();

    globals.Geolocation = (function() {

        function Geolocation(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Geolocation.prototype.latitude = null;
        Geolocation.prototype.longitude = null;
        Geolocation.prototype.timestamp = null;
        Geolocation.prototype.country = 0;

        Geolocation.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.latitude != null && Object.hasOwnProperty.call(m, "latitude"))
                $root.google.protobuf.DoubleValue.encode(m.latitude, w.uint32(10).fork()).ldelim();
            if (m.longitude != null && Object.hasOwnProperty.call(m, "longitude"))
                $root.google.protobuf.DoubleValue.encode(m.longitude, w.uint32(18).fork()).ldelim();
            if (m.timestamp != null && Object.hasOwnProperty.call(m, "timestamp"))
                $root.google.protobuf.UInt64Value.encode(m.timestamp, w.uint32(26).fork()).ldelim();
            if (m.country != null && Object.hasOwnProperty.call(m, "country"))
                w.uint32(32).int32(m.country);
            return w;
        };

        Geolocation.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Geolocation.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.Geolocation();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.latitude = $root.google.protobuf.DoubleValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.longitude = $root.google.protobuf.DoubleValue.decode(r, r.uint32());
                    break;
                case 3:
                    m.timestamp = $root.google.protobuf.UInt64Value.decode(r, r.uint32());
                    break;
                case 4:
                    m.country = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Geolocation.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Geolocation.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.latitude != null && m.hasOwnProperty("latitude")) {
                {
                    var e = $root.google.protobuf.DoubleValue.verify(m.latitude);
                    if (e)
                        return "latitude." + e;
                }
            }
            if (m.longitude != null && m.hasOwnProperty("longitude")) {
                {
                    var e = $root.google.protobuf.DoubleValue.verify(m.longitude);
                    if (e)
                        return "longitude." + e;
                }
            }
            if (m.timestamp != null && m.hasOwnProperty("timestamp")) {
                {
                    var e = $root.google.protobuf.UInt64Value.verify(m.timestamp);
                    if (e)
                        return "timestamp." + e;
                }
            }
            if (m.country != null && m.hasOwnProperty("country")) {
                switch (m.country) {
                default:
                    return "country: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                case 21:
                case 22:
                case 23:
                case 24:
                case 25:
                case 26:
                case 27:
                case 28:
                case 29:
                case 30:
                case 31:
                case 32:
                case 33:
                case 34:
                case 35:
                case 36:
                case 37:
                case 38:
                case 39:
                case 40:
                case 41:
                case 42:
                case 43:
                case 44:
                case 45:
                case 46:
                case 47:
                case 48:
                case 49:
                case 50:
                case 51:
                case 52:
                case 53:
                case 54:
                case 55:
                case 56:
                case 57:
                case 58:
                case 59:
                case 60:
                case 61:
                case 62:
                case 63:
                case 64:
                case 65:
                case 66:
                case 67:
                case 68:
                case 69:
                case 70:
                case 71:
                case 72:
                case 73:
                case 74:
                case 75:
                case 76:
                case 77:
                case 78:
                case 79:
                case 80:
                case 81:
                case 82:
                case 83:
                case 84:
                case 85:
                case 86:
                case 87:
                case 88:
                case 89:
                case 90:
                case 91:
                case 92:
                case 93:
                case 94:
                case 95:
                case 96:
                case 97:
                case 98:
                case 99:
                case 100:
                case 101:
                case 102:
                case 103:
                case 104:
                case 105:
                case 106:
                case 107:
                case 108:
                case 109:
                case 110:
                case 111:
                case 112:
                case 113:
                case 114:
                case 115:
                case 116:
                case 117:
                case 118:
                case 119:
                case 120:
                case 121:
                case 122:
                case 123:
                case 124:
                case 125:
                case 126:
                case 127:
                case 128:
                case 129:
                case 130:
                case 131:
                case 132:
                case 133:
                case 134:
                case 135:
                case 136:
                case 137:
                case 138:
                case 139:
                case 140:
                case 141:
                case 142:
                case 143:
                case 144:
                case 145:
                case 146:
                case 147:
                case 148:
                case 149:
                case 150:
                case 151:
                case 152:
                case 153:
                case 154:
                case 155:
                case 156:
                case 157:
                case 158:
                case 159:
                case 160:
                case 161:
                case 162:
                case 163:
                case 164:
                case 165:
                case 166:
                case 167:
                case 168:
                case 169:
                case 170:
                case 171:
                case 172:
                case 173:
                case 174:
                case 175:
                case 176:
                case 177:
                case 178:
                case 179:
                case 180:
                case 181:
                case 182:
                case 183:
                case 184:
                case 185:
                case 186:
                case 187:
                case 188:
                case 189:
                case 190:
                case 191:
                case 192:
                case 193:
                case 194:
                case 195:
                case 196:
                case 197:
                case 198:
                case 199:
                case 200:
                case 201:
                case 202:
                case 203:
                case 204:
                case 205:
                case 206:
                case 207:
                case 208:
                case 209:
                case 210:
                case 211:
                case 212:
                case 213:
                case 214:
                case 215:
                case 216:
                case 217:
                case 218:
                case 219:
                case 220:
                case 221:
                case 222:
                case 223:
                case 224:
                case 225:
                case 226:
                case 227:
                case 228:
                case 229:
                case 230:
                case 231:
                case 232:
                case 233:
                case 234:
                case 235:
                case 236:
                case 237:
                case 238:
                case 239:
                case 240:
                case 241:
                case 242:
                case 243:
                case 244:
                case 245:
                case 246:
                case 247:
                case 248:
                case 249:
                case 250:
                case 251:
                case 252:
                case 253:
                case 254:
                case 255:
                    break;
                }
            }
            return null;
        };

        Geolocation.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.Geolocation)
                return d;
            var m = new $root.globals.Geolocation();
            if (d.latitude != null) {
                if (typeof d.latitude === "object" && d.latitude !== null && d.latitude.value !== undefined)
                    throw TypeError(".globals.Geolocation.latitude: wrapped value not expected");
                m.latitude = $root.google.protobuf.DoubleValue.fromObject({ value: d.latitude });
            }
            if (d.longitude != null) {
                if (typeof d.longitude === "object" && d.longitude !== null && d.longitude.value !== undefined)
                    throw TypeError(".globals.Geolocation.longitude: wrapped value not expected");
                m.longitude = $root.google.protobuf.DoubleValue.fromObject({ value: d.longitude });
            }
            if (d.timestamp != null) {
                if (typeof d.timestamp === "object" && d.timestamp !== null && d.timestamp.value !== undefined)
                    throw TypeError(".globals.Geolocation.timestamp: wrapped value not expected");
                m.timestamp = $root.google.protobuf.UInt64Value.fromObject({ value: d.timestamp });
            }
            switch (d.country) {
            case "UNKNOWN_COUNTRY":
            case 0:
                m.country = 0;
                break;
            case "AF":
            case 1:
                m.country = 1;
                break;
            case "AL":
            case 2:
                m.country = 2;
                break;
            case "AQ":
            case 3:
                m.country = 3;
                break;
            case "DZ":
            case 4:
                m.country = 4;
                break;
            case "AS":
            case 5:
                m.country = 5;
                break;
            case "AD":
            case 6:
                m.country = 6;
                break;
            case "AO":
            case 7:
                m.country = 7;
                break;
            case "AG":
            case 8:
                m.country = 8;
                break;
            case "AZ":
            case 9:
                m.country = 9;
                break;
            case "AR":
            case 10:
                m.country = 10;
                break;
            case "AU":
            case 11:
                m.country = 11;
                break;
            case "AT":
            case 12:
                m.country = 12;
                break;
            case "BS":
            case 13:
                m.country = 13;
                break;
            case "BH":
            case 14:
                m.country = 14;
                break;
            case "BD":
            case 15:
                m.country = 15;
                break;
            case "AM":
            case 16:
                m.country = 16;
                break;
            case "BB":
            case 17:
                m.country = 17;
                break;
            case "BE":
            case 18:
                m.country = 18;
                break;
            case "BM":
            case 19:
                m.country = 19;
                break;
            case "BT":
            case 20:
                m.country = 20;
                break;
            case "BO":
            case 21:
                m.country = 21;
                break;
            case "BA":
            case 22:
                m.country = 22;
                break;
            case "BW":
            case 23:
                m.country = 23;
                break;
            case "BV":
            case 24:
                m.country = 24;
                break;
            case "BR":
            case 25:
                m.country = 25;
                break;
            case "BZ":
            case 26:
                m.country = 26;
                break;
            case "IO":
            case 27:
                m.country = 27;
                break;
            case "SB":
            case 28:
                m.country = 28;
                break;
            case "VG":
            case 29:
                m.country = 29;
                break;
            case "BN":
            case 30:
                m.country = 30;
                break;
            case "BG":
            case 31:
                m.country = 31;
                break;
            case "MM":
            case 32:
                m.country = 32;
                break;
            case "BI":
            case 33:
                m.country = 33;
                break;
            case "BY":
            case 34:
                m.country = 34;
                break;
            case "KH":
            case 35:
                m.country = 35;
                break;
            case "CM":
            case 36:
                m.country = 36;
                break;
            case "CA":
            case 37:
                m.country = 37;
                break;
            case "CV":
            case 38:
                m.country = 38;
                break;
            case "KY":
            case 39:
                m.country = 39;
                break;
            case "CF":
            case 40:
                m.country = 40;
                break;
            case "LK":
            case 41:
                m.country = 41;
                break;
            case "TD":
            case 42:
                m.country = 42;
                break;
            case "CL":
            case 43:
                m.country = 43;
                break;
            case "CN":
            case 44:
                m.country = 44;
                break;
            case "TW":
            case 45:
                m.country = 45;
                break;
            case "CX":
            case 46:
                m.country = 46;
                break;
            case "CC":
            case 47:
                m.country = 47;
                break;
            case "CO":
            case 48:
                m.country = 48;
                break;
            case "KM":
            case 49:
                m.country = 49;
                break;
            case "YT":
            case 50:
                m.country = 50;
                break;
            case "CG":
            case 51:
                m.country = 51;
                break;
            case "CD":
            case 52:
                m.country = 52;
                break;
            case "CK":
            case 53:
                m.country = 53;
                break;
            case "CR":
            case 54:
                m.country = 54;
                break;
            case "HR":
            case 55:
                m.country = 55;
                break;
            case "CU":
            case 56:
                m.country = 56;
                break;
            case "CY":
            case 57:
                m.country = 57;
                break;
            case "CZ":
            case 58:
                m.country = 58;
                break;
            case "BJ":
            case 59:
                m.country = 59;
                break;
            case "DK":
            case 60:
                m.country = 60;
                break;
            case "DM":
            case 61:
                m.country = 61;
                break;
            case "DO":
            case 62:
                m.country = 62;
                break;
            case "EC":
            case 63:
                m.country = 63;
                break;
            case "SV":
            case 64:
                m.country = 64;
                break;
            case "GQ":
            case 65:
                m.country = 65;
                break;
            case "ET":
            case 66:
                m.country = 66;
                break;
            case "ER":
            case 67:
                m.country = 67;
                break;
            case "EE":
            case 68:
                m.country = 68;
                break;
            case "FO":
            case 69:
                m.country = 69;
                break;
            case "FK":
            case 70:
                m.country = 70;
                break;
            case "GS":
            case 71:
                m.country = 71;
                break;
            case "FJ":
            case 72:
                m.country = 72;
                break;
            case "FI":
            case 73:
                m.country = 73;
                break;
            case "AX":
            case 74:
                m.country = 74;
                break;
            case "FR":
            case 75:
                m.country = 75;
                break;
            case "GF":
            case 76:
                m.country = 76;
                break;
            case "PF":
            case 77:
                m.country = 77;
                break;
            case "TF":
            case 78:
                m.country = 78;
                break;
            case "DJ":
            case 79:
                m.country = 79;
                break;
            case "GA":
            case 80:
                m.country = 80;
                break;
            case "GE":
            case 81:
                m.country = 81;
                break;
            case "GM":
            case 82:
                m.country = 82;
                break;
            case "PS":
            case 83:
                m.country = 83;
                break;
            case "DE":
            case 84:
                m.country = 84;
                break;
            case "GH":
            case 85:
                m.country = 85;
                break;
            case "GI":
            case 86:
                m.country = 86;
                break;
            case "KI":
            case 87:
                m.country = 87;
                break;
            case "GR":
            case 88:
                m.country = 88;
                break;
            case "GL":
            case 89:
                m.country = 89;
                break;
            case "GD":
            case 90:
                m.country = 90;
                break;
            case "GP":
            case 91:
                m.country = 91;
                break;
            case "GU":
            case 92:
                m.country = 92;
                break;
            case "GT":
            case 93:
                m.country = 93;
                break;
            case "GN":
            case 94:
                m.country = 94;
                break;
            case "GY":
            case 95:
                m.country = 95;
                break;
            case "HT":
            case 96:
                m.country = 96;
                break;
            case "HM":
            case 97:
                m.country = 97;
                break;
            case "VA":
            case 98:
                m.country = 98;
                break;
            case "HN":
            case 99:
                m.country = 99;
                break;
            case "HK":
            case 100:
                m.country = 100;
                break;
            case "HU":
            case 101:
                m.country = 101;
                break;
            case "IS":
            case 102:
                m.country = 102;
                break;
            case "IN":
            case 103:
                m.country = 103;
                break;
            case "ID":
            case 104:
                m.country = 104;
                break;
            case "IR":
            case 105:
                m.country = 105;
                break;
            case "IQ":
            case 106:
                m.country = 106;
                break;
            case "IE":
            case 107:
                m.country = 107;
                break;
            case "IL":
            case 108:
                m.country = 108;
                break;
            case "IT":
            case 109:
                m.country = 109;
                break;
            case "CI":
            case 110:
                m.country = 110;
                break;
            case "JM":
            case 111:
                m.country = 111;
                break;
            case "JP":
            case 112:
                m.country = 112;
                break;
            case "KZ":
            case 113:
                m.country = 113;
                break;
            case "JO":
            case 114:
                m.country = 114;
                break;
            case "KE":
            case 115:
                m.country = 115;
                break;
            case "KP":
            case 116:
                m.country = 116;
                break;
            case "KR":
            case 117:
                m.country = 117;
                break;
            case "KW":
            case 118:
                m.country = 118;
                break;
            case "KG":
            case 119:
                m.country = 119;
                break;
            case "LA":
            case 120:
                m.country = 120;
                break;
            case "LB":
            case 121:
                m.country = 121;
                break;
            case "LS":
            case 122:
                m.country = 122;
                break;
            case "LV":
            case 123:
                m.country = 123;
                break;
            case "LR":
            case 124:
                m.country = 124;
                break;
            case "LY":
            case 125:
                m.country = 125;
                break;
            case "LI":
            case 126:
                m.country = 126;
                break;
            case "LT":
            case 127:
                m.country = 127;
                break;
            case "LU":
            case 128:
                m.country = 128;
                break;
            case "MO":
            case 129:
                m.country = 129;
                break;
            case "MG":
            case 130:
                m.country = 130;
                break;
            case "MW":
            case 131:
                m.country = 131;
                break;
            case "MY":
            case 132:
                m.country = 132;
                break;
            case "MV":
            case 133:
                m.country = 133;
                break;
            case "ML":
            case 134:
                m.country = 134;
                break;
            case "MT":
            case 135:
                m.country = 135;
                break;
            case "MQ":
            case 136:
                m.country = 136;
                break;
            case "MR":
            case 137:
                m.country = 137;
                break;
            case "MU":
            case 138:
                m.country = 138;
                break;
            case "MX":
            case 139:
                m.country = 139;
                break;
            case "MC":
            case 140:
                m.country = 140;
                break;
            case "MN":
            case 141:
                m.country = 141;
                break;
            case "MD":
            case 142:
                m.country = 142;
                break;
            case "ME":
            case 143:
                m.country = 143;
                break;
            case "MS":
            case 144:
                m.country = 144;
                break;
            case "MA":
            case 145:
                m.country = 145;
                break;
            case "MZ":
            case 146:
                m.country = 146;
                break;
            case "OM":
            case 147:
                m.country = 147;
                break;
            case "NA":
            case 148:
                m.country = 148;
                break;
            case "NR":
            case 149:
                m.country = 149;
                break;
            case "NP":
            case 150:
                m.country = 150;
                break;
            case "NL":
            case 151:
                m.country = 151;
                break;
            case "CW":
            case 152:
                m.country = 152;
                break;
            case "AW":
            case 153:
                m.country = 153;
                break;
            case "SX":
            case 154:
                m.country = 154;
                break;
            case "BQ":
            case 155:
                m.country = 155;
                break;
            case "NC":
            case 156:
                m.country = 156;
                break;
            case "VU":
            case 157:
                m.country = 157;
                break;
            case "NZ":
            case 158:
                m.country = 158;
                break;
            case "NI":
            case 159:
                m.country = 159;
                break;
            case "NE":
            case 160:
                m.country = 160;
                break;
            case "NG":
            case 161:
                m.country = 161;
                break;
            case "NU":
            case 162:
                m.country = 162;
                break;
            case "NF":
            case 163:
                m.country = 163;
                break;
            case "NO":
            case 164:
                m.country = 164;
                break;
            case "MP":
            case 165:
                m.country = 165;
                break;
            case "UM":
            case 166:
                m.country = 166;
                break;
            case "FM":
            case 167:
                m.country = 167;
                break;
            case "MH":
            case 168:
                m.country = 168;
                break;
            case "PW":
            case 169:
                m.country = 169;
                break;
            case "PK":
            case 170:
                m.country = 170;
                break;
            case "PA":
            case 171:
                m.country = 171;
                break;
            case "PG":
            case 172:
                m.country = 172;
                break;
            case "PY":
            case 173:
                m.country = 173;
                break;
            case "PE":
            case 174:
                m.country = 174;
                break;
            case "PH":
            case 175:
                m.country = 175;
                break;
            case "PN":
            case 176:
                m.country = 176;
                break;
            case "PL":
            case 177:
                m.country = 177;
                break;
            case "PT":
            case 178:
                m.country = 178;
                break;
            case "GW":
            case 179:
                m.country = 179;
                break;
            case "TL":
            case 180:
                m.country = 180;
                break;
            case "PR":
            case 181:
                m.country = 181;
                break;
            case "QA":
            case 182:
                m.country = 182;
                break;
            case "RE":
            case 183:
                m.country = 183;
                break;
            case "RO":
            case 184:
                m.country = 184;
                break;
            case "RU":
            case 185:
                m.country = 185;
                break;
            case "RW":
            case 186:
                m.country = 186;
                break;
            case "BL":
            case 187:
                m.country = 187;
                break;
            case "SH":
            case 188:
                m.country = 188;
                break;
            case "KN":
            case 189:
                m.country = 189;
                break;
            case "AI":
            case 190:
                m.country = 190;
                break;
            case "LC":
            case 191:
                m.country = 191;
                break;
            case "MF":
            case 192:
                m.country = 192;
                break;
            case "PM":
            case 193:
                m.country = 193;
                break;
            case "VC":
            case 194:
                m.country = 194;
                break;
            case "SM":
            case 195:
                m.country = 195;
                break;
            case "ST":
            case 196:
                m.country = 196;
                break;
            case "SA":
            case 197:
                m.country = 197;
                break;
            case "SN":
            case 198:
                m.country = 198;
                break;
            case "RS":
            case 199:
                m.country = 199;
                break;
            case "SC":
            case 200:
                m.country = 200;
                break;
            case "SL":
            case 201:
                m.country = 201;
                break;
            case "SG":
            case 202:
                m.country = 202;
                break;
            case "SK":
            case 203:
                m.country = 203;
                break;
            case "VN":
            case 204:
                m.country = 204;
                break;
            case "SI":
            case 205:
                m.country = 205;
                break;
            case "SO":
            case 206:
                m.country = 206;
                break;
            case "ZA":
            case 207:
                m.country = 207;
                break;
            case "ZW":
            case 208:
                m.country = 208;
                break;
            case "ES":
            case 209:
                m.country = 209;
                break;
            case "SS":
            case 210:
                m.country = 210;
                break;
            case "SD":
            case 211:
                m.country = 211;
                break;
            case "EH":
            case 212:
                m.country = 212;
                break;
            case "SR":
            case 213:
                m.country = 213;
                break;
            case "SJ":
            case 214:
                m.country = 214;
                break;
            case "SZ":
            case 215:
                m.country = 215;
                break;
            case "SE":
            case 216:
                m.country = 216;
                break;
            case "CH":
            case 217:
                m.country = 217;
                break;
            case "SY":
            case 218:
                m.country = 218;
                break;
            case "TJ":
            case 219:
                m.country = 219;
                break;
            case "TH":
            case 220:
                m.country = 220;
                break;
            case "TG":
            case 221:
                m.country = 221;
                break;
            case "TK":
            case 222:
                m.country = 222;
                break;
            case "TO":
            case 223:
                m.country = 223;
                break;
            case "TT":
            case 224:
                m.country = 224;
                break;
            case "AE":
            case 225:
                m.country = 225;
                break;
            case "TN":
            case 226:
                m.country = 226;
                break;
            case "TR":
            case 227:
                m.country = 227;
                break;
            case "TM":
            case 228:
                m.country = 228;
                break;
            case "TC":
            case 229:
                m.country = 229;
                break;
            case "TV":
            case 230:
                m.country = 230;
                break;
            case "UG":
            case 231:
                m.country = 231;
                break;
            case "UA":
            case 232:
                m.country = 232;
                break;
            case "MK":
            case 233:
                m.country = 233;
                break;
            case "EG":
            case 234:
                m.country = 234;
                break;
            case "GB":
            case 235:
                m.country = 235;
                break;
            case "GG":
            case 236:
                m.country = 236;
                break;
            case "JE":
            case 237:
                m.country = 237;
                break;
            case "IM":
            case 238:
                m.country = 238;
                break;
            case "TZ":
            case 239:
                m.country = 239;
                break;
            case "US":
            case 240:
                m.country = 240;
                break;
            case "VI":
            case 241:
                m.country = 241;
                break;
            case "BF":
            case 242:
                m.country = 242;
                break;
            case "UY":
            case 243:
                m.country = 243;
                break;
            case "UZ":
            case 244:
                m.country = 244;
                break;
            case "VE":
            case 245:
                m.country = 245;
                break;
            case "WF":
            case 246:
                m.country = 246;
                break;
            case "WS":
            case 247:
                m.country = 247;
                break;
            case "YE":
            case 248:
                m.country = 248;
                break;
            case "ZM":
            case 249:
                m.country = 249;
                break;
            case "A1":
            case 250:
                m.country = 250;
                break;
            case "A2":
            case 251:
                m.country = 251;
                break;
            case "O1":
            case 252:
                m.country = 252;
                break;
            case "AP":
            case 253:
                m.country = 253;
                break;
            case "EU":
            case 254:
                m.country = 254;
                break;
            case "PRIVATE":
            case 255:
                m.country = 255;
                break;
            }
            return m;
        };

        Geolocation.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.latitude = null;
                d.longitude = null;
                d.timestamp = null;
                d.country = o.enums === String ? "UNKNOWN_COUNTRY" : 0;
            }
            if (m.latitude != null && m.hasOwnProperty("latitude")) {
                d.latitude = $root.google.protobuf.DoubleValue.toObject(m.latitude, o).value;
            }
            if (m.longitude != null && m.hasOwnProperty("longitude")) {
                d.longitude = $root.google.protobuf.DoubleValue.toObject(m.longitude, o).value;
            }
            if (m.timestamp != null && m.hasOwnProperty("timestamp")) {
                d.timestamp = $root.google.protobuf.UInt64Value.toObject(m.timestamp, o).value;
            }
            if (m.country != null && m.hasOwnProperty("country")) {
                d.country = o.enums === String ? $root.globals.CountryCodeType[m.country] : m.country;
            }
            return d;
        };

        Geolocation.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Geolocation;
    })();

    globals.ApptimizeClientSession = (function() {

        function ApptimizeClientSession(p) {
            this.groups = [];
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ApptimizeClientSession.prototype.userId = null;
        ApptimizeClientSession.prototype.groups = $util.emptyArray;

        ApptimizeClientSession.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.userId != null && Object.hasOwnProperty.call(m, "userId"))
                $root.google.protobuf.StringValue.encode(m.userId, w.uint32(10).fork()).ldelim();
            if (m.groups != null && m.groups.length) {
                for (var i = 0; i < m.groups.length; ++i)
                    w.uint32(18).string(m.groups[i]);
            }
            return w;
        };

        ApptimizeClientSession.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        ApptimizeClientSession.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.ApptimizeClientSession();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.userId = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 2:
                    if (!(m.groups && m.groups.length))
                        m.groups = [];
                    m.groups.push(r.string());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        ApptimizeClientSession.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        ApptimizeClientSession.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.userId != null && m.hasOwnProperty("userId")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.userId);
                    if (e)
                        return "userId." + e;
                }
            }
            if (m.groups != null && m.hasOwnProperty("groups")) {
                if (!Array.isArray(m.groups))
                    return "groups: array expected";
                for (var i = 0; i < m.groups.length; ++i) {
                    if (!$util.isString(m.groups[i]))
                        return "groups: string[] expected";
                }
            }
            return null;
        };

        ApptimizeClientSession.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.ApptimizeClientSession)
                return d;
            var m = new $root.globals.ApptimizeClientSession();
            if (d.userId != null) {
                if (typeof d.userId === "object" && d.userId !== null && d.userId.value !== undefined)
                    throw TypeError(".globals.ApptimizeClientSession.userId: wrapped value not expected");
                m.userId = $root.google.protobuf.StringValue.fromObject({ value: d.userId });
            }
            if (d.groups) {
                if (!Array.isArray(d.groups))
                    throw TypeError(".globals.ApptimizeClientSession.groups: array expected");
                m.groups = [];
                for (var i = 0; i < d.groups.length; ++i) {
                    m.groups[i] = String(d.groups[i]);
                }
            }
            return m;
        };

        ApptimizeClientSession.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.arrays || o.defaults) {
                d.groups = [];
            }
            if (o.defaults) {
                d.userId = null;
            }
            if (m.userId != null && m.hasOwnProperty("userId")) {
                d.userId = $root.google.protobuf.StringValue.toObject(m.userId, o).value;
            }
            if (m.groups && m.groups.length) {
                d.groups = [];
                for (var j = 0; j < m.groups.length; ++j) {
                    d.groups[j] = m.groups[j];
                }
            }
            return d;
        };

        ApptimizeClientSession.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ApptimizeClientSession;
    })();

    globals.BranchClientSession = (function() {

        function BranchClientSession(p) {
            this.params = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        BranchClientSession.prototype.identityId = null;
        BranchClientSession.prototype.params = $util.emptyObject;

        BranchClientSession.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.identityId != null && Object.hasOwnProperty.call(m, "identityId"))
                $root.google.protobuf.StringValue.encode(m.identityId, w.uint32(10).fork()).ldelim();
            if (m.params != null && Object.hasOwnProperty.call(m, "params")) {
                for (var ks = Object.keys(m.params), i = 0; i < ks.length; ++i) {
                    w.uint32(18).fork().uint32(10).string(ks[i]).uint32(18).string(m.params[ks[i]]).ldelim();
                }
            }
            return w;
        };

        BranchClientSession.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        BranchClientSession.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.BranchClientSession(), k;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.identityId = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 2:
                    r.skip().pos++;
                    if (m.params === $util.emptyObject)
                        m.params = {};
                    k = r.string();
                    r.pos++;
                    m.params[k] = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        BranchClientSession.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        BranchClientSession.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.identityId != null && m.hasOwnProperty("identityId")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.identityId);
                    if (e)
                        return "identityId." + e;
                }
            }
            if (m.params != null && m.hasOwnProperty("params")) {
                if (!$util.isObject(m.params))
                    return "params: object expected";
                var k = Object.keys(m.params);
                for (var i = 0; i < k.length; ++i) {
                    if (!$util.isString(m.params[k[i]]))
                        return "params: string{k:string} expected";
                }
            }
            return null;
        };

        BranchClientSession.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.BranchClientSession)
                return d;
            var m = new $root.globals.BranchClientSession();
            if (d.identityId != null) {
                if (typeof d.identityId === "object" && d.identityId !== null && d.identityId.value !== undefined)
                    throw TypeError(".globals.BranchClientSession.identityId: wrapped value not expected");
                m.identityId = $root.google.protobuf.StringValue.fromObject({ value: d.identityId });
            }
            if (d.params) {
                if (typeof d.params !== "object")
                    throw TypeError(".globals.BranchClientSession.params: object expected");
                m.params = {};
                for (var ks = Object.keys(d.params), i = 0; i < ks.length; ++i) {
                    m.params[ks[i]] = String(d.params[ks[i]]);
                }
            }
            return m;
        };

        BranchClientSession.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.objects || o.defaults) {
                d.params = {};
            }
            if (o.defaults) {
                d.identityId = null;
            }
            if (m.identityId != null && m.hasOwnProperty("identityId")) {
                d.identityId = $root.google.protobuf.StringValue.toObject(m.identityId, o).value;
            }
            var ks2;
            if (m.params && (ks2 = Object.keys(m.params)).length) {
                d.params = {};
                for (var j = 0; j < ks2.length; ++j) {
                    d.params[ks2[j]] = m.params[ks2[j]];
                }
            }
            return d;
        };

        BranchClientSession.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return BranchClientSession;
    })();

    globals.TrackingParams = (function() {

        function TrackingParams(p) {
            this.utmCustomParams = {};
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        TrackingParams.prototype.utmSource = null;
        TrackingParams.prototype.utmMedium = null;
        TrackingParams.prototype.utmCampaign = null;
        TrackingParams.prototype.utmTerm = null;
        TrackingParams.prototype.utmContent = null;
        TrackingParams.prototype.utmCustomParams = $util.emptyObject;

        TrackingParams.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.utmSource != null && Object.hasOwnProperty.call(m, "utmSource"))
                $root.google.protobuf.StringValue.encode(m.utmSource, w.uint32(10).fork()).ldelim();
            if (m.utmMedium != null && Object.hasOwnProperty.call(m, "utmMedium"))
                $root.google.protobuf.StringValue.encode(m.utmMedium, w.uint32(18).fork()).ldelim();
            if (m.utmCampaign != null && Object.hasOwnProperty.call(m, "utmCampaign"))
                $root.google.protobuf.StringValue.encode(m.utmCampaign, w.uint32(26).fork()).ldelim();
            if (m.utmTerm != null && Object.hasOwnProperty.call(m, "utmTerm"))
                $root.google.protobuf.StringValue.encode(m.utmTerm, w.uint32(34).fork()).ldelim();
            if (m.utmContent != null && Object.hasOwnProperty.call(m, "utmContent"))
                $root.google.protobuf.StringValue.encode(m.utmContent, w.uint32(42).fork()).ldelim();
            if (m.utmCustomParams != null && Object.hasOwnProperty.call(m, "utmCustomParams")) {
                for (var ks = Object.keys(m.utmCustomParams), i = 0; i < ks.length; ++i) {
                    w.uint32(50).fork().uint32(10).string(ks[i]).uint32(18).string(m.utmCustomParams[ks[i]]).ldelim();
                }
            }
            return w;
        };

        TrackingParams.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        TrackingParams.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.TrackingParams(), k;
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.utmSource = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.utmMedium = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 3:
                    m.utmCampaign = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 4:
                    m.utmTerm = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 5:
                    m.utmContent = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 6:
                    r.skip().pos++;
                    if (m.utmCustomParams === $util.emptyObject)
                        m.utmCustomParams = {};
                    k = r.string();
                    r.pos++;
                    m.utmCustomParams[k] = r.string();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        TrackingParams.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        TrackingParams.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.utmSource != null && m.hasOwnProperty("utmSource")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.utmSource);
                    if (e)
                        return "utmSource." + e;
                }
            }
            if (m.utmMedium != null && m.hasOwnProperty("utmMedium")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.utmMedium);
                    if (e)
                        return "utmMedium." + e;
                }
            }
            if (m.utmCampaign != null && m.hasOwnProperty("utmCampaign")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.utmCampaign);
                    if (e)
                        return "utmCampaign." + e;
                }
            }
            if (m.utmTerm != null && m.hasOwnProperty("utmTerm")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.utmTerm);
                    if (e)
                        return "utmTerm." + e;
                }
            }
            if (m.utmContent != null && m.hasOwnProperty("utmContent")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.utmContent);
                    if (e)
                        return "utmContent." + e;
                }
            }
            if (m.utmCustomParams != null && m.hasOwnProperty("utmCustomParams")) {
                if (!$util.isObject(m.utmCustomParams))
                    return "utmCustomParams: object expected";
                var k = Object.keys(m.utmCustomParams);
                for (var i = 0; i < k.length; ++i) {
                    if (!$util.isString(m.utmCustomParams[k[i]]))
                        return "utmCustomParams: string{k:string} expected";
                }
            }
            return null;
        };

        TrackingParams.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.TrackingParams)
                return d;
            var m = new $root.globals.TrackingParams();
            if (d.utmSource != null) {
                if (typeof d.utmSource === "object" && d.utmSource !== null && d.utmSource.value !== undefined)
                    throw TypeError(".globals.TrackingParams.utmSource: wrapped value not expected");
                m.utmSource = $root.google.protobuf.StringValue.fromObject({ value: d.utmSource });
            }
            if (d.utmMedium != null) {
                if (typeof d.utmMedium === "object" && d.utmMedium !== null && d.utmMedium.value !== undefined)
                    throw TypeError(".globals.TrackingParams.utmMedium: wrapped value not expected");
                m.utmMedium = $root.google.protobuf.StringValue.fromObject({ value: d.utmMedium });
            }
            if (d.utmCampaign != null) {
                if (typeof d.utmCampaign === "object" && d.utmCampaign !== null && d.utmCampaign.value !== undefined)
                    throw TypeError(".globals.TrackingParams.utmCampaign: wrapped value not expected");
                m.utmCampaign = $root.google.protobuf.StringValue.fromObject({ value: d.utmCampaign });
            }
            if (d.utmTerm != null) {
                if (typeof d.utmTerm === "object" && d.utmTerm !== null && d.utmTerm.value !== undefined)
                    throw TypeError(".globals.TrackingParams.utmTerm: wrapped value not expected");
                m.utmTerm = $root.google.protobuf.StringValue.fromObject({ value: d.utmTerm });
            }
            if (d.utmContent != null) {
                if (typeof d.utmContent === "object" && d.utmContent !== null && d.utmContent.value !== undefined)
                    throw TypeError(".globals.TrackingParams.utmContent: wrapped value not expected");
                m.utmContent = $root.google.protobuf.StringValue.fromObject({ value: d.utmContent });
            }
            if (d.utmCustomParams) {
                if (typeof d.utmCustomParams !== "object")
                    throw TypeError(".globals.TrackingParams.utmCustomParams: object expected");
                m.utmCustomParams = {};
                for (var ks = Object.keys(d.utmCustomParams), i = 0; i < ks.length; ++i) {
                    m.utmCustomParams[ks[i]] = String(d.utmCustomParams[ks[i]]);
                }
            }
            return m;
        };

        TrackingParams.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.objects || o.defaults) {
                d.utmCustomParams = {};
            }
            if (o.defaults) {
                d.utmSource = null;
                d.utmMedium = null;
                d.utmCampaign = null;
                d.utmTerm = null;
                d.utmContent = null;
            }
            if (m.utmSource != null && m.hasOwnProperty("utmSource")) {
                d.utmSource = $root.google.protobuf.StringValue.toObject(m.utmSource, o).value;
            }
            if (m.utmMedium != null && m.hasOwnProperty("utmMedium")) {
                d.utmMedium = $root.google.protobuf.StringValue.toObject(m.utmMedium, o).value;
            }
            if (m.utmCampaign != null && m.hasOwnProperty("utmCampaign")) {
                d.utmCampaign = $root.google.protobuf.StringValue.toObject(m.utmCampaign, o).value;
            }
            if (m.utmTerm != null && m.hasOwnProperty("utmTerm")) {
                d.utmTerm = $root.google.protobuf.StringValue.toObject(m.utmTerm, o).value;
            }
            if (m.utmContent != null && m.hasOwnProperty("utmContent")) {
                d.utmContent = $root.google.protobuf.StringValue.toObject(m.utmContent, o).value;
            }
            var ks2;
            if (m.utmCustomParams && (ks2 = Object.keys(m.utmCustomParams)).length) {
                d.utmCustomParams = {};
                for (var j = 0; j < ks2.length; ++j) {
                    d.utmCustomParams[ks2[j]] = m.utmCustomParams[ks2[j]];
                }
            }
            return d;
        };

        TrackingParams.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return TrackingParams;
    })();

    globals.ClientSession = (function() {

        function ClientSession(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        ClientSession.prototype.id = null;
        ClientSession.prototype.apptimize = null;
        ClientSession.prototype.branch = null;
        ClientSession.prototype.track = null;

        ClientSession.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.id != null && Object.hasOwnProperty.call(m, "id"))
                $root.google.protobuf.StringValue.encode(m.id, w.uint32(10).fork()).ldelim();
            if (m.apptimize != null && Object.hasOwnProperty.call(m, "apptimize"))
                $root.globals.ApptimizeClientSession.encode(m.apptimize, w.uint32(18).fork()).ldelim();
            if (m.branch != null && Object.hasOwnProperty.call(m, "branch"))
                $root.globals.BranchClientSession.encode(m.branch, w.uint32(26).fork()).ldelim();
            if (m.track != null && Object.hasOwnProperty.call(m, "track"))
                $root.globals.TrackingParams.encode(m.track, w.uint32(34).fork()).ldelim();
            return w;
        };

        ClientSession.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        ClientSession.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.ClientSession();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.id = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.apptimize = $root.globals.ApptimizeClientSession.decode(r, r.uint32());
                    break;
                case 3:
                    m.branch = $root.globals.BranchClientSession.decode(r, r.uint32());
                    break;
                case 4:
                    m.track = $root.globals.TrackingParams.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        ClientSession.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        ClientSession.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.id != null && m.hasOwnProperty("id")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.id);
                    if (e)
                        return "id." + e;
                }
            }
            if (m.apptimize != null && m.hasOwnProperty("apptimize")) {
                {
                    var e = $root.globals.ApptimizeClientSession.verify(m.apptimize);
                    if (e)
                        return "apptimize." + e;
                }
            }
            if (m.branch != null && m.hasOwnProperty("branch")) {
                {
                    var e = $root.globals.BranchClientSession.verify(m.branch);
                    if (e)
                        return "branch." + e;
                }
            }
            if (m.track != null && m.hasOwnProperty("track")) {
                {
                    var e = $root.globals.TrackingParams.verify(m.track);
                    if (e)
                        return "track." + e;
                }
            }
            return null;
        };

        ClientSession.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.ClientSession)
                return d;
            var m = new $root.globals.ClientSession();
            if (d.id != null) {
                if (typeof d.id === "object" && d.id !== null && d.id.value !== undefined)
                    throw TypeError(".globals.ClientSession.id: wrapped value not expected");
                m.id = $root.google.protobuf.StringValue.fromObject({ value: d.id });
            }
            if (d.apptimize != null) {
                if (typeof d.apptimize !== "object")
                    throw TypeError(".globals.ClientSession.apptimize: object expected");
                m.apptimize = $root.globals.ApptimizeClientSession.fromObject(d.apptimize);
            }
            if (d.branch != null) {
                if (typeof d.branch !== "object")
                    throw TypeError(".globals.ClientSession.branch: object expected");
                m.branch = $root.globals.BranchClientSession.fromObject(d.branch);
            }
            if (d.track != null) {
                if (typeof d.track !== "object")
                    throw TypeError(".globals.ClientSession.track: object expected");
                m.track = $root.globals.TrackingParams.fromObject(d.track);
            }
            return m;
        };

        ClientSession.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.id = null;
                d.apptimize = null;
                d.branch = null;
                d.track = null;
            }
            if (m.id != null && m.hasOwnProperty("id")) {
                d.id = $root.google.protobuf.StringValue.toObject(m.id, o).value;
            }
            if (m.apptimize != null && m.hasOwnProperty("apptimize")) {
                d.apptimize = $root.globals.ApptimizeClientSession.toObject(m.apptimize, o);
            }
            if (m.branch != null && m.hasOwnProperty("branch")) {
                d.branch = $root.globals.BranchClientSession.toObject(m.branch, o);
            }
            if (m.track != null && m.hasOwnProperty("track")) {
                d.track = $root.globals.TrackingParams.toObject(m.track, o);
            }
            return d;
        };

        ClientSession.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ClientSession;
    })();

    globals.UserExternalAccount = (function() {

        function UserExternalAccount(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        UserExternalAccount.prototype.type = 0;
        UserExternalAccount.prototype.username = null;

        UserExternalAccount.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.type != null && Object.hasOwnProperty.call(m, "type"))
                w.uint32(8).int32(m.type);
            if (m.username != null && Object.hasOwnProperty.call(m, "username"))
                $root.google.protobuf.StringValue.encode(m.username, w.uint32(18).fork()).ldelim();
            return w;
        };

        UserExternalAccount.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        UserExternalAccount.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.UserExternalAccount();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.type = r.int32();
                    break;
                case 2:
                    m.username = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        UserExternalAccount.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        UserExternalAccount.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.type != null && m.hasOwnProperty("type")) {
                switch (m.type) {
                default:
                    return "type: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    break;
                }
            }
            if (m.username != null && m.hasOwnProperty("username")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.username);
                    if (e)
                        return "username." + e;
                }
            }
            return null;
        };

        UserExternalAccount.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.UserExternalAccount)
                return d;
            var m = new $root.globals.UserExternalAccount();
            switch (d.type) {
            case "UNKNOWN_ACCOUNT":
            case 0:
                m.type = 0;
                break;
            case "FACEBOOK_ACCOUNT":
            case 1:
                m.type = 1;
                break;
            case "TWITTER_ACCOUNT":
            case 2:
                m.type = 2;
                break;
            case "GOOGLE_ACCOUNT":
            case 3:
                m.type = 3;
                break;
            case "STUMBLEUPON_ACCOUNT":
            case 4:
                m.type = 4;
                break;
            case "APPLE_ACCOUNT":
            case 5:
                m.type = 5;
                break;
            case "EMAIL_ACCOUNT":
            case 6:
                m.type = 6;
                break;
            }
            if (d.username != null) {
                if (typeof d.username === "object" && d.username !== null && d.username.value !== undefined)
                    throw TypeError(".globals.UserExternalAccount.username: wrapped value not expected");
                m.username = $root.google.protobuf.StringValue.fromObject({ value: d.username });
            }
            return m;
        };

        UserExternalAccount.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.type = o.enums === String ? "UNKNOWN_ACCOUNT" : 0;
                d.username = null;
            }
            if (m.type != null && m.hasOwnProperty("type")) {
                d.type = o.enums === String ? $root.globals.UserExternalAccountType[m.type] : m.type;
            }
            if (m.username != null && m.hasOwnProperty("username")) {
                d.username = $root.google.protobuf.StringValue.toObject(m.username, o).value;
            }
            return d;
        };

        UserExternalAccount.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserExternalAccount;
    })();

    globals.NotificationPreference = (function() {

        function NotificationPreference(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        NotificationPreference.prototype.optType = 0;
        NotificationPreference.prototype.channel = 0;
        NotificationPreference.prototype.name = null;

        NotificationPreference.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.optType != null && Object.hasOwnProperty.call(m, "optType"))
                w.uint32(8).int32(m.optType);
            if (m.channel != null && Object.hasOwnProperty.call(m, "channel"))
                w.uint32(16).int32(m.channel);
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                $root.google.protobuf.StringValue.encode(m.name, w.uint32(26).fork()).ldelim();
            return w;
        };

        NotificationPreference.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        NotificationPreference.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.NotificationPreference();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.optType = r.int32();
                    break;
                case 2:
                    m.channel = r.int32();
                    break;
                case 3:
                    m.name = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        NotificationPreference.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        NotificationPreference.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.optType != null && m.hasOwnProperty("optType")) {
                switch (m.optType) {
                default:
                    return "optType: enum value expected";
                case 0:
                case 1:
                case 2:
                    break;
                }
            }
            if (m.channel != null && m.hasOwnProperty("channel")) {
                switch (m.channel) {
                default:
                    return "channel: enum value expected";
                case 0:
                case 1:
                case 2:
                case 3:
                    break;
                }
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.name);
                    if (e)
                        return "name." + e;
                }
            }
            return null;
        };

        NotificationPreference.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.NotificationPreference)
                return d;
            var m = new $root.globals.NotificationPreference();
            switch (d.optType) {
            case "UNKNOWN_OPT_TYPE":
            case 0:
                m.optType = 0;
                break;
            case "OPT_IN":
            case 1:
                m.optType = 1;
                break;
            case "OPT_OUT":
            case 2:
                m.optType = 2;
                break;
            }
            switch (d.channel) {
            case "UNKNOWN_NOTIFICATION_CHANNEL":
            case 0:
                m.channel = 0;
                break;
            case "SMS":
            case 1:
                m.channel = 1;
                break;
            case "EMAIL":
            case 2:
                m.channel = 2;
                break;
            case "MOBILE":
            case 3:
                m.channel = 3;
                break;
            }
            if (d.name != null) {
                if (typeof d.name === "object" && d.name !== null && d.name.value !== undefined)
                    throw TypeError(".globals.NotificationPreference.name: wrapped value not expected");
                m.name = $root.google.protobuf.StringValue.fromObject({ value: d.name });
            }
            return m;
        };

        NotificationPreference.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.optType = o.enums === String ? "UNKNOWN_OPT_TYPE" : 0;
                d.channel = o.enums === String ? "UNKNOWN_NOTIFICATION_CHANNEL" : 0;
                d.name = null;
            }
            if (m.optType != null && m.hasOwnProperty("optType")) {
                d.optType = o.enums === String ? $root.globals.OptType[m.optType] : m.optType;
            }
            if (m.channel != null && m.hasOwnProperty("channel")) {
                d.channel = o.enums === String ? $root.globals.NotificationChannel[m.channel] : m.channel;
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                d.name = $root.google.protobuf.StringValue.toObject(m.name, o).value;
            }
            return d;
        };

        NotificationPreference.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return NotificationPreference;
    })();

    globals.Experiment = (function() {

        function Experiment(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        Experiment.prototype.name = null;
        Experiment.prototype.group = null;

        Experiment.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.name != null && Object.hasOwnProperty.call(m, "name"))
                $root.google.protobuf.StringValue.encode(m.name, w.uint32(10).fork()).ldelim();
            if (m.group != null && Object.hasOwnProperty.call(m, "group"))
                $root.google.protobuf.StringValue.encode(m.group, w.uint32(18).fork()).ldelim();
            return w;
        };

        Experiment.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        Experiment.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.globals.Experiment();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.name = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                case 2:
                    m.group = $root.google.protobuf.StringValue.decode(r, r.uint32());
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        Experiment.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        Experiment.verify = function verify(m) {
            if (typeof m !== "object" || m === null)
                return "object expected";
            if (m.name != null && m.hasOwnProperty("name")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.name);
                    if (e)
                        return "name." + e;
                }
            }
            if (m.group != null && m.hasOwnProperty("group")) {
                {
                    var e = $root.google.protobuf.StringValue.verify(m.group);
                    if (e)
                        return "group." + e;
                }
            }
            return null;
        };

        Experiment.fromObject = function fromObject(d) {
            if (d instanceof $root.globals.Experiment)
                return d;
            var m = new $root.globals.Experiment();
            if (d.name != null) {
                if (typeof d.name === "object" && d.name !== null && d.name.value !== undefined)
                    throw TypeError(".globals.Experiment.name: wrapped value not expected");
                m.name = $root.google.protobuf.StringValue.fromObject({ value: d.name });
            }
            if (d.group != null) {
                if (typeof d.group === "object" && d.group !== null && d.group.value !== undefined)
                    throw TypeError(".globals.Experiment.group: wrapped value not expected");
                m.group = $root.google.protobuf.StringValue.fromObject({ value: d.group });
            }
            return m;
        };

        Experiment.toObject = function toObject(m, o) {
            if (!o)
                o = {};
            var d = {};
            if (o.defaults) {
                d.name = null;
                d.group = null;
            }
            if (m.name != null && m.hasOwnProperty("name")) {
                d.name = $root.google.protobuf.StringValue.toObject(m.name, o).value;
            }
            if (m.group != null && m.hasOwnProperty("group")) {
                d.group = $root.google.protobuf.StringValue.toObject(m.group, o).value;
            }
            return d;
        };

        Experiment.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Experiment;
    })();

    return globals;
})();

module.exports = $root;
